export const customerSupportJson = {
  uid: "9fa7c353-70d2-4a2f-abb2-51fd78bb237b",
  componentName: "CustomerSupport",
  dataSource: "{B64FDCA7-177F-42C8-8661-8B29F2D98D96}",
  params: {
    buttonAlignment: "center",
    backgroundColor: "orange-white",
    paddingTop: "Large",
    paddingBottom: "Large",
  },
  fields: {
    title: { value: "บริการให้ความช่วยเหลือส่วนบุคคล" },
    description: {
      value: "ไม่สามารถตัดสินใจเลือกผลิตภัณฑ์ที่เหมาะกับคุณ?",
    },
    supportOptions: [
      {
        id: "9d0b5568-7a7e-422a-8edb-f1edf7f6b230",
        fields: {
          contactNumber: { value: "+661351" },
          title: { value: "โทรหาเราที่ 1351" },
          icon: {
            value: {
              src: "/-/media/images/supports/call.svg?rev=344495c4c2c14009bee1d70f685936dd",
              alt: "call",
            },
          },
          subTitle: {
            value: "เราพร้อมช่วยเหลือคุณทุกวัน เวลา 8.00-20.00 น.",
          },
          supportIcon: {
            id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
            fieldType: "CustomDroplink",
            fieldName: "supportIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
            fields: {
              value: { value: "call" },
              key: { value: "Call" },
            },
          },

          buttonIcon: {
            id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
            fieldType: "CustomDroplink",
            fieldName: "buttonIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
            fields: {
              value: { value: "arrow-right" },
              key: { value: "Link" },
            },
          },
          link: {
            value: {
              href: "http://tel:1351",
              text: "โทร. 1351",
              linktype: "external",
              url: "tel:1351",
              anchor: "",
              target: "",
            },
          },
          buttonMode: {
            id: "02a5a5c7-c318-4919-b773-86a65ba98969",
            fieldType: "Droplink",
            fieldName: "buttonMode",
            url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
            fields: {
              value: { value: "SimpleLink" },
              key: { value: "SimpleLink" },
            },
          },
          linkGALabelName: { value: "Call 1351" },
          listType: {
            id: "a5bee68c-8e43-4f78-8d15-d42982fd053a",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "/sitecore/content/fwd/global/settings/list/linklisttype/call",
            fields: {
              value: { value: "Call" },
              key: { value: "call" },
            },
          },
        },
      },
      {
        id: "9aa49352-9157-4c69-8276-906c960b3d02",
        fields: {
          title: { value: "เรียกร้องสินไหม" },
          icon: {
            value: {
              src: "/-/media/images/supports/chat.svg?rev=e28bd495e1254211a32fffa85ba6ff82",
              alt: "chat",
            },
          },
          subTitle: {
            value:
              "ดูขั้นตอนการเรียกร้องสินไหมที่ง่ายและรวดเร็วของเราได้ที่นี่",
          },
          supportIcon: {
            id: "8ba0c144-7d03-426d-84a8-3329cca6784a",
            fieldType: "CustomDroplink",
            fieldName: "supportIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/claims",
            fields: {
              value: { value: "claims" },
              key: { value: "claims" },
            },
          },
          medalliaForm: { value: "" },
          listType: {
            id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
            fieldType: "Droplink",
            fieldName: "listType",
            url: "/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
            fields: {
              value: { value: "Generic Link" },
              key: { value: "generic_link" },
            },
          },
          buttonIcon: {
            id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
            fieldType: "CustomDroplink",
            fieldName: "buttonIcon",
            url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
            fields: {
              value: { value: "arrow-right" },
              key: { value: "Link" },
            },
          },
          link: {
            value: {
              href: "https://www.fwd.co.th/th/claims/",
              text: "Open claim page",
              anchor: "",
              linktype: "internal",
              class: "",
              title: "",
              querystring: "",
              id: "{69567D54-9813-4873-A169-DDE101852FAE}",
            },
          },
          buttonMode: {
            id: "02a5a5c7-c318-4919-b773-86a65ba98969",
            fieldType: "Droplink",
            fieldName: "buttonMode",
            url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
            fields: {
              value: { value: "SimpleLink" },
              key: { value: "SimpleLink" },
            },
          },
          linkGALabelName: { value: "" },
        },
      },
    ],
    supportIcon: null,
    buttonIcon: {
      id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
      fieldType: "CustomDroplink",
      fieldName: "buttonIcon",
      url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
      fields: {
        value: { value: "arrow-right" },
        key: { value: "Link" },
      },
    },
    link: {
      value: {
        href: "https://www.fwd.co.th/th/support/",
        text: "แสดงช่องทางการติดต่อทั้งหมด",
        anchor: "",
        linktype: "internal",
        class: "",
        title: "ดูช่องทางการติดต่อทั้งหมด",
        querystring: "",
        id: "{A09F0B08-17C3-43BA-A3B1-FD62BA1E29C9}",
      },
    },
    buttonMode: {
      id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
      fieldType: "Droplink",
      fieldName: "buttonMode",
      url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
      fields: {
        value: { value: "Primary" },
        key: { value: "Primary" },
      },
    },
    linkGALabelName: { value: "" },
    gaCategoryName: { value: "" },
    gaLabelName: { value: "" },
  },
  callbackForm: {
    sitecoreContext: {
      context: {
        pageEditing: false,
        site: { name: "fwd-th" },
        pageState: "normal",
        language: "th",
        languageCode: "th",
        defaultLanguage: "th",
        siteSettings: {
          productListPage: "/products/",
          splashPage: "",
          articleTagLink: "/search/",
          articleTypeDesign: [],
          articleOverlineText: false,
          globalMetaText: "เอฟดับบลิวดี ประเทศไทย",
          globalMetaTag: "",
          cookieMessage:
            'เราใช้คุกกี้เพื่อเพิ่มประสบการณ์การใช้งานที่ดี การเข้าใช้งานเว็บไซต์นี้ ถือว่าท่านยอมรับวิธีที่เราใช้คุกกี้และข้อมูลของท่าน ตาม<a href="https://www.fwd.co.th/th/privacy-policy/">นโยบายคุ้มครองข้อมูลส่วนบุคคล</a> ของเรา',
          cookieTimeStamp: "365",
          currencyPlacement: "AfterNumericals",
          currencyWhitespace: false,
          currencySeparator: { value: {} },
          currencyLabel: { value: { THB: "บาท" } },
          splashPageUpdatedDuration: "365",
          splashPageUpdatedDate: "",
          faviconImageUrl:
            "/-/media/global/images/icons/favicon.ico?rev=9d80f0017e88450db421c1247e3665fe",
          productErrorPictogramUrl:
            "/-/media/pictograms/no-result-48px2x.png?rev=458f050fa6494a13874483d2d84d6bc2",
          dateFormat: "DD/MM/YYYY",
          enablePlanCardSharePostCalc: "",
          sessionTimeout: "20",
          loaderTimeout: "",
          gAID: "GTM-WKBBW9X",
          gTMID: "GTM-WKBBW9X",
          gtmParamters: [],
          optimize360: true,
          hostName: "https://www.fwd.co.th",
          enableBackToTopButton: 1,
          dialogSessionTimeout: "5",
          productFallbackCTA: {
            value: {
              href: "/formslist/product-enquiry-form",
              text: "สอบถาม",
              anchor: "",
              linkType: "form",
              title: "",
              queryString: "enquiry",
              id: "{136AA02C-41C6-4E79-88E1-7893B161A37F}",
              gaLabel: "",
            },
          },
          brightcoveAccountID: "5650355171001",
          languageIcon: { key: "language-globe", value: "language-globe" },
          enableMultipleNotifications: false,
          hidePrimaryLanguage: false,
          currencyGALabelName: "",
          showArticleSubtitle: false,
          hasArticleSubtitleFallback: false,
        },
        share: {
          socialApps: [
            {
              facebook: {
                url: {
                  value: {
                    href: "https://www.facebook.com/sharer.php?u=",
                    text: "Facebook Url",
                    linktype: "external",
                    url: "https://www.facebook.com/sharer.php?u=",
                    anchor: "",
                    target: "",
                  },
                },
                header: { value: "แชร์บนเฟซบุ๊ก" },
                toolTip: { value: "" },
              },
            },
            {
              twitter: {
                url: {
                  value: {
                    href: "https://twitter.com/intent/tweet?text=",
                    text: "Twitter Url",
                    linktype: "external",
                    url: "https://twitter.com/intent/tweet?text=",
                    anchor: "",
                    target: "",
                  },
                },
                header: { value: "แชร์บนทวิตเตอร์" },
                toolTip: { value: "" },
              },
            },
            {
              line: {
                url: {
                  value: {
                    href: "https://social-plugins.line.me/lineit/share?url=",
                    text: "Line Url",
                    linktype: "external",
                    url: "https://social-plugins.line.me/lineit/share?url=",
                    anchor: "",
                    target: "",
                  },
                },
                header: { value: "แชร์บนไลน์" },
                toolTip: { value: "" },
              },
            },
          ],
        },
        siteNotifications: { notifications: [] },
        dialogModals: {
          modalList: [
            {
              activeSessionModal: {
                title: { value: "คุณยังอยู่ที่นี่หรือไม่?" },
                description: {
                  value:
                    "หน้านี้จะหมดอายุใน {time} คุณไม่ได้ใช้งานมาระยะหนึ่งแล้ว เลือกดำเนินการต่อเพื่อให้อยู่ในหน้า",
                },
                key: {
                  id: "bab3dabc-242d-419f-bc41-f342458cb50a",
                  fieldType: "Droplink",
                  fieldName: "key",
                  url: "/sitecore/content/fwd/global/settings/list/dialog-modal/activesessionmodal",
                  fields: {
                    value: { value: "ActiveSessionModal" },
                    key: { value: "activeSessionModal" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: { value: {} },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
              },
            },
            {
              expiredSessionModal: {
                title: { value: "หน้านี้หมดอายุแล้ว" },
                description: {
                  value:
                    "ดูเหมือนว่าคุณจะไม่ได้ใช้งานมาระยะหนึ่งแล้ว ข้อมูลของคุณยังไม่ได้รับการจัดเก็บ โปรดรีเฟรชและลองอีกครั้ง",
                },
                key: {
                  id: "13bd5030-db40-4148-a65f-678b8f0fb5a5",
                  fieldType: "Droplink",
                  fieldName: "key",
                  url: "/sitecore/content/fwd/global/settings/list/dialog-modal/expiredsessionmodal",
                  fields: {
                    value: { value: "ExpiredSessionModal" },
                    key: { value: "expiredSessionModal" },
                  },
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: { value: {} },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
              },
            },
          ],
        },
        disclosurePopups: {
          popupList: [
            {
              sticky: { value: true },
              activeAtEndOfScroll: { value: true },
              sessionTimeout: { value: "" },
              frequency: {
                id: "0585858d-6024-4df6-a556-08bc04932510",
                fieldType: "Droplink",
                fieldName: "frequency",
                url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                fields: {
                  value: {
                    value: "Every time user land on the identified page",
                  },
                  key: { value: "every-time-in-session" },
                },
              },
              isRiskDisclosure: { value: true },
              defaultPageLink: { value: {} },
              enableSmallView: { value: false },
              title: { value: "คำเตือน" },
              footerText: { value: "" },
              text: {
                value:
                  '<ul>\n    <li>หนังสือชี้ชวนที่ปรากฎอยู่ใน&nbsp;<span style="text-decoration: underline;">fwd.co.th</span>&nbsp;แม้ว่าจะได้รับการอนุมัติให้จัดตั้งและจัดการจากสำนักงานคณะกรรมการ ก.ล.ต.แต่มิได้เป็นการแสดงว่า คณะกรรมการ กลต. และสำนักงานคณะกรรมการ กลต. ได้รับรองถึงความถูกต้องของข้อมูลในหนังสือชี้ชวนและมิได้ประกันราคาหน่วยลงทุนที่เสนอขาย</li>\n</ul>\n<ul>\n    <li>การลงทุนมีความเสี่ยง ผู้เอาประกันภัยอาจได้รับเงินคืนมากกว่าหรือน้อยกว่ามูลค่าเบี้ยประกันภัยที่ถูกจัดสรรเข้ากองทุนรวมโดยหากผลการดำเนินงานของกองทุนรวมมีกำไร ผู้เอาประกันภัยก็จะได้ผลตอบแทนสูง แต่หากผลการดำเนินงานของกองทุนรวมขาดทุน ผู้เอาประกันภัยจะได้ผลตอบแทนต่ำ หรือบางกรณีอาจขาดทุน กล่าวคือ ไม่ได้รับเงินส่วนลงทุนคืนเต็มจำนวน ทั้งนี้กรมธรรม์นี้ไม่มีการรับประกันเงินส่วนลงทุน</li>\n</ul>\n<ul>\n    <li>กรมธรรม์นี้เหมาะสำหรับการออมเงินระยะยาว</li>\n</ul>\n<ul>\n    <li>ผู้เอาประกันภัยควรศึกษารายละเอียดเกี่ยวกับความเสี่ยงจากการลงทุนในกองทุนรวมในหนังสือชี้ชวนของกองทุนรวมด้วย</li>\n</ul>\n<ul>\n    <li>กองทุนรวมเป็นนิติบุคคลแยกต่างหากจากบริษัทประกันชีวิตและบริษัทจัดการ ดังนั้น บริษัทประกันชีวิตและบริษัทจัดการจึงไม่มีภาระผูกพันในการชดเชยผลขาดทุนของกองทุนรวม และจะไม่สามารถนำทรัพย์สินของกองทุนรวมไปใช้ประโยชน์เพื่อการชำระหนี้ของตนเอง</li>\n</ul>\n<ul>\n    <li>การลงทุนในหน่วยลงทุนมิใช่การฝากเงิน ผู้ลงทุนอาจได้รับคืนเงินลงทุนมากกว่าหรือน้อยกว่าเงินลงทุนเริ่มต้นและมีโอกาสไม่ได้รับชำระเงินค่าขายคืนหน่วยลงทุนภายในระยะเวลาที่กำหนด ในกรณีกองทุนเปิด ผู้ลงทุนอาจไม่สามารถขายคืนหน่วยลงทุนได้ตามที่มีคำสั่งไว้&nbsp;</li>\n</ul>\n<ul>\n    <li>การวัดผลการดำเนินงานของกองทุนรวม จัดทำขึ้นตามมาตรฐานการวัดผลการดำเนินงานของสมาคมบริษัทจัดการลงทุน</li>\n</ul>\n<ul>\n    <li>ผลการดำเนินงานของกองทุนรวม ไม่ได้ขึ้นอยู่กับสถานะทางการเงินหรือผลการดำเนินงานของบริษัทจัดการและบริษัทประกันชีวิต</li>\n</ul>\n<ul>\n    <li>ผลการดำเนินงานในอดีตของกองทุนรวม มิได้เป็นสิ่งยืนยันถึงผลการดำเนินงานในอนาคต</li>\n</ul>\n<ul>\n    <li>ผู้สนใจลงทุนควรศึกษาข้อมูลในหนังสือชี้ชวนให้เข้าใจอย่างละเอียดก่อนซื้อหน่วยลงทุน และควรเก็บเป็นข้อมูลไว้ใช้อ้างอิงในอนาคต หากต้องการข้อมูลเพิ่มเติมสามารถขอข้อมูลโครงการและสอบถามรายละเอียดได้ที่บริษัทจัดการหรือตัวแทน</li>\n</ul>\n<ul>\n    <li>กรุณาตอบคำถามตามแบบสอบถามของบริษัทฯ ซึ่งควรให้ข้อมูลที่เป็นความจริง ถูกต้อง เป็นปัจจุบัน และครบถ้วน โดยท่านได้รับหนังสือชี้ชวนจากบริษัทฯ แล้ว ทั้งนี้การให้ข้อมูลของท่าน จะมีผลต่อการให้บริการ หรือการให้คำแนะนำที่ท่านจะได้รับจากตัวแทนประกันชีวิตและบริษัทฯ</li>\n</ul>\n<ul>\n    <li>ข้อมูลที่ปรากฎอยู่ใน เว็บไซต์นี้ บริษัทได้จัดทำและรวบรวมขึ้นด้วยความสุจริต และพยายามจัดทำขึ้น บนพื้นฐานของแหล่งข้อมูลที่มีความน่าเชื่อถือ เพื่อให้เป็นข้อมูลที่ถูกต้อง แต่บริษัทและผู้บริหาร รวมถึงพนักงานเจ้าหน้าที่ของบริษัทมิอาจรับประกันความถูกต้อง ครบถ้วน หรือความน่าเชื่อถือของข้อมูลดังกล่าวได้ ทั้งนี้ อาจมีสาเหตุมาจาก ข้อมูลนั้นเอง หรืออาจมาจากสาเหตุอื่น ๆ ดังนั้น หากผู้ลงทุนจะใช้ข้อมูลที่ปรากฏอยู่ในเว็บไซต์นี้ เพื่อการดำเนินการอย่างใดอย่างหนึ่งผู้ลงทุนควรใช้ด้วยความรอบคอบ หรือใช้ข้อมูลจากแหล่งอื่นๆ ประกอบการพิจารณาด้วย</li>\n</ul>\n<ul>\n    <li>บริษัทขอสงวนสิทธิ์ในการแก้ไข ปรับปรุง หรือเปลี่ยนแปลงข้อมูลใดๆ ใน&nbsp;website แห่งนี้ โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้าแต่อย่างใด</li>\n</ul>\n<ul>\n    <li>บริษัทและผู้บริหาร รวมถึงพนักงานเจ้าหน้าที่ของบริษัท ขอสงวนสิทธิ์ที่จะไม่รับผิดชอบ ต่อความเสียหายทุกกรณี ที่เกิดขึ้นกับข้อมูล หรือ ระบบสื่อสารของผู้เข้าเยี่ยมชมหรือผู้ลงทุน อันเนื่องมาจากการเข้ามาใช้เว็บไซต์นี้ และหรือ เว็บไซต์ที่ร่วมกิจกรรมกับบริษัท</li>\n</ul>\n<ul>\n    <li>ผู้ลงทุนควรตรวจสอบให้แน่ใจว่า ผู้ขายประกันชีวิตควบการลงทุนเป็นบุคคลที่ได้รับความเห็นชอบจากสำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย และควรขอดูบัตรประจำตัวของบุคคลดังกล่าวที่สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย ออกให้ด้วย</li>\n</ul>\n<ul>\n    <li>การเผยแพร่ข้อมูลต่างๆ บริษัททำขึ้นเพื่อวัตถุประสงค์ในการอำนวยความสะดวกแก่ผู้ลงทุนเท่านั้น บริษัทมิได้รับรองถึงความถูกต้องแท้จริงและความครบถ้วนของข้อมูลไม่ว่าใน กรณีใดๆ ทั้งสิ้น</li>\n</ul>',
              },
              buttonIcon: {
                id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                fields: {
                  value: { value: "arrow-right" },
                  key: { value: "Link" },
                },
              },
              link: { value: {} },
              buttonMode: {
                id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                fieldType: "Droplink",
                fieldName: "buttonMode",
                url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                fields: {
                  value: { value: "SimpleLink" },
                  key: { value: "SimpleLink" },
                },
              },
              linkGALabelName: { value: "InvestmentDisclosureAccepted" },
              isCloseCTA: { value: true },
              closeCTALabel: {
                value: "ใช่ ข้าพเจ้าได้อ่านและเข้าใจเงื่อนไขดังกล่าวข้างต้น",
              },
              secondaryLinkButtonMode: {
                id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                fieldType: "Droplink",
                fieldName: "secondaryLinkButtonMode",
                url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                fields: {
                  value: { value: "Secondary" },
                  key: { value: "Secondary" },
                },
              },
              secondaryLinkGALabelName: { value: "InvestmentDisclosureDenied" },
              secondaryLink: { value: {} },
              secondaryLinkButtonIcon: {
                id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                fieldType: "CustomDroplink",
                fieldName: "secondaryLinkButtonIcon",
                url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                fields: {
                  value: { value: "arrow-right" },
                  key: { value: "Link" },
                },
              },
              secondaryCloseCTALabel: {
                value: "ไม่ ข้าพเจ้าไม่ต้องการจะดำเนินการต่อ",
              },
              isSecondaryCloseCTA: { value: true },
              IsFormPost: { value: false },
              FormParameters: { value: {} },
              id: "c375f832-ec0e-4a2b-8836-bbfe6d573640",
            },
            {
              sticky: { value: true },
              activeAtEndOfScroll: { value: true },
              sessionTimeout: { value: "" },
              frequency: {
                id: "0585858d-6024-4df6-a556-08bc04932510",
                fieldType: "Droplink",
                fieldName: "frequency",
                url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                fields: {
                  value: {
                    value: "Every time user land on the identified page",
                  },
                  key: { value: "every-time-in-session" },
                },
              },
              isRiskDisclosure: { value: true },
              defaultPageLink: { value: {} },
              enableSmallView: { value: false },
              title: { value: "คำเตือน" },
              footerText: { value: "" },
              text: {
                value:
                  '<ul>\n    <li>หนังสือชี้ชวนที่ปรากฎอยู่ใน&nbsp;<span style="text-decoration: underline;">fwd.co.th</span>&nbsp;แม้ว่าจะได้รับการอนุมัติให้จัดตั้งและจัดการจากสำนักงานคณะกรรมการ ก.ล.ต.แต่มิได้เป็นการแสดงว่า คณะกรรมการ กลต. และสำนักงานคณะกรรมการ กลต. ได้รับรองถึงความถูกต้องของข้อมูลในหนังสือชี้ชวนและมิได้ประกันราคาหน่วยลงทุนที่เสนอขาย</li>\n</ul>\n<ul>\n    <li>การลงทุนมีความเสี่ยง ผู้เอาประกันภัยอาจได้รับเงินคืนมากกว่าหรือน้อยกว่ามูลค่าเบี้ยประกันภัยที่ถูกจัดสรรเข้ากองทุนรวมโดยหากผลการดำเนินงานของกองทุนรวมมีกำไร ผู้เอาประกันภัยก็จะได้ผลตอบแทนสูง แต่หากผลการดำเนินงานของกองทุนรวมขาดทุน ผู้เอาประกันภัยจะได้ผลตอบแทนต่ำ หรือบางกรณีอาจขาดทุน กล่าวคือ ไม่ได้รับเงินส่วนลงทุนคืนเต็มจำนวน ทั้งนี้กรมธรรม์นี้ไม่มีการรับประกันเงินส่วนลงทุน</li>\n</ul>\n<ul>\n    <li>กรมธรรม์นี้เหมาะสำหรับการออมเงินระยะยาว</li>\n</ul>\n<ul>\n    <li>ผู้เอาประกันภัยควรศึกษารายละเอียดเกี่ยวกับความเสี่ยงจากการลงทุนในกองทุนรวมในหนังสือชี้ชวนของกองทุนรวมด้วย</li>\n</ul>\n<ul>\n    <li>กองทุนรวมเป็นนิติบุคคลแยกต่างหากจากบริษัทประกันชีวิตและบริษัทจัดการ ดังนั้น บริษัทประกันชีวิตและบริษัทจัดการจึงไม่มีภาระผูกพันในการชดเชยผลขาดทุนของกองทุนรวม และจะไม่สามารถนำทรัพย์สินของกองทุนรวมไปใช้ประโยชน์เพื่อการชำระหนี้ของตนเอง</li>\n</ul>\n<ul>\n    <li>การลงทุนในหน่วยลงทุนมิใช่การฝากเงิน ผู้ลงทุนอาจได้รับคืนเงินลงทุนมากกว่าหรือน้อยกว่าเงินลงทุนเริ่มต้นและมีโอกาสไม่ได้รับชำระเงินค่าขายคืนหน่วยลงทุนภายในระยะเวลาที่กำหนด ในกรณีกองทุนเปิด ผู้ลงทุนอาจไม่สามารถขายคืนหน่วยลงทุนได้ตามที่มีคำสั่งไว้&nbsp;</li>\n</ul>\n<ul>\n    <li>การวัดผลการดำเนินงานของกองทุนรวม จัดทำขึ้นตามมาตรฐานการวัดผลการดำเนินงานของสมาคมบริษัทจัดการลงทุน</li>\n</ul>\n<ul>\n    <li>ผลการดำเนินงานของกองทุนรวม ไม่ได้ขึ้นอยู่กับสถานะทางการเงินหรือผลการดำเนินงานของบริษัทจัดการและบริษัทประกันชีวิต</li>\n</ul>\n<ul>\n    <li>ผลการดำเนินงานในอดีตของกองทุนรวม มิได้เป็นสิ่งยืนยันถึงผลการดำเนินงานในอนาคต</li>\n</ul>\n<ul>\n    <li>ผู้สนใจลงทุนควรศึกษาข้อมูลในหนังสือชี้ชวนให้เข้าใจอย่างละเอียดก่อนซื้อหน่วยลงทุน และควรเก็บเป็นข้อมูลไว้ใช้อ้างอิงในอนาคต หากต้องการข้อมูลเพิ่มเติมสามารถขอข้อมูลโครงการและสอบถามรายละเอียดได้ที่บริษัทจัดการหรือตัวแทน</li>\n</ul>\n<ul>\n    <li>กรุณาตอบคำถามตามแบบสอบถามของบริษัทฯ ซึ่งควรให้ข้อมูลที่เป็นความจริง ถูกต้อง เป็นปัจจุบัน และครบถ้วน โดยท่านได้รับหนังสือชี้ชวนจากบริษัทฯ แล้ว ทั้งนี้การให้ข้อมูลของท่าน จะมีผลต่อการให้บริการ หรือการให้คำแนะนำที่ท่านจะได้รับจากตัวแทนประกันชีวิตและบริษัทฯ</li>\n</ul>\n<ul>\n    <li>ข้อมูลที่ปรากฎอยู่ใน เว็บไซต์นี้ บริษัทได้จัดทำและรวบรวมขึ้นด้วยความสุจริต และพยายามจัดทำขึ้น บนพื้นฐานของแหล่งข้อมูลที่มีความน่าเชื่อถือ เพื่อให้เป็นข้อมูลที่ถูกต้อง แต่บริษัทและผู้บริหาร รวมถึงพนักงานเจ้าหน้าที่ของบริษัทมิอาจรับประกันความถูกต้อง ครบถ้วน หรือความน่าเชื่อถือของข้อมูลดังกล่าวได้ ทั้งนี้ อาจมีสาเหตุมาจาก ข้อมูลนั้นเอง หรืออาจมาจากสาเหตุอื่น ๆ ดังนั้น หากผู้ลงทุนจะใช้ข้อมูลที่ปรากฏอยู่ในเว็บไซต์นี้ เพื่อการดำเนินการอย่างใดอย่างหนึ่งผู้ลงทุนควรใช้ด้วยความรอบคอบ หรือใช้ข้อมูลจากแหล่งอื่นๆ ประกอบการพิจารณาด้วย</li>\n</ul>\n<ul>\n    <li>บริษัทขอสงวนสิทธิ์ในการแก้ไข ปรับปรุง หรือเปลี่ยนแปลงข้อมูลใดๆ ใน&nbsp;website แห่งนี้ โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้าแต่อย่างใด</li>\n</ul>\n<ul>\n    <li>บริษัทและผู้บริหาร รวมถึงพนักงานเจ้าหน้าที่ของบริษัท ขอสงวนสิทธิ์ที่จะไม่รับผิดชอบ ต่อความเสียหายทุกกรณี ที่เกิดขึ้นกับข้อมูล หรือ ระบบสื่อสารของผู้เข้าเยี่ยมชมหรือผู้ลงทุน อันเนื่องมาจากการเข้ามาใช้เว็บไซต์นี้ และหรือ เว็บไซต์ที่ร่วมกิจกรรมกับบริษัท</li>\n</ul>\n<ul>\n    <li>ผู้ลงทุนควรตรวจสอบให้แน่ใจว่า ผู้ขายประกันชีวิตควบการลงทุนเป็นบุคคลที่ได้รับความเห็นชอบจากสำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย และควรขอดูบัตรประจำตัวของบุคคลดังกล่าวที่สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย ออกให้ด้วย</li>\n</ul>\n<ul>\n    <li>การเผยแพร่ข้อมูลต่างๆ บริษัททำขึ้นเพื่อวัตถุประสงค์ในการอำนวยความสะดวกแก่ผู้ลงทุนเท่านั้น บริษัทมิได้รับรองถึงความถูกต้องแท้จริงและความครบถ้วนของข้อมูลไม่ว่าใน กรณีใดๆ ทั้งสิ้น</li>\n</ul>',
              },
              buttonIcon: {
                id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                fieldType: "CustomDroplink",
                fieldName: "buttonIcon",
                url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                fields: {
                  value: { value: "arrow-right" },
                  key: { value: "Link" },
                },
              },
              link: { value: {} },
              buttonMode: {
                id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                fieldType: "Droplink",
                fieldName: "buttonMode",
                url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                fields: {
                  value: { value: "SimpleLink" },
                  key: { value: "SimpleLink" },
                },
              },
              linkGALabelName: { value: "InvestmentDisclosureAccepted" },
              isCloseCTA: { value: true },
              closeCTALabel: {
                value: "ใช่ ข้าพเจ้าได้อ่านและเข้าใจเงื่อนไขดังกล่าวข้างต้น",
              },
              secondaryLinkButtonMode: {
                id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                fieldType: "Droplink",
                fieldName: "secondaryLinkButtonMode",
                url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                fields: {
                  value: { value: "Secondary" },
                  key: { value: "Secondary" },
                },
              },
              secondaryLinkGALabelName: { value: "InvestmentDisclosureDenied" },
              secondaryLink: { value: {} },
              secondaryLinkButtonIcon: {
                id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                fieldType: "CustomDroplink",
                fieldName: "secondaryLinkButtonIcon",
                url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                fields: {
                  value: { value: "arrow-right" },
                  key: { value: "Link" },
                },
              },
              secondaryCloseCTALabel: {
                value: "ไม่ ข้าพเจ้าไม่ต้องการจะดำเนินการต่อ",
              },
              isSecondaryCloseCTA: { value: true },
              IsFormPost: { value: false },
              FormParameters: { value: {} },
              id: "441cbf7c-a146-4a9b-b7e1-5dfbc83700c7",
            },
          ],
        },
        localizedPages: [
          { th: "https://www.fwd.co.th/th/products" },
          { en: "/en/products" },
        ],
        isRequestFromExternalSource: false,
        availableLanguages: ["th", "en"],
      },
      route: {
        name: "Products",
        displayName: "Products",
        fields: {
          contentType: null,
          pagetitle: { value: "" },
          pagedescription: { value: "" },
          metadataTitle: { value: "ค้นหาแผนประกันที่ต้องการกับเอฟดับบลิวดี" },
          metadataDescription: {
            value:
              "เอฟดับบลิวดี ประเทศไทย เราออกแบบแผนประกันจากความต้องการของลูกค้า เพื่อตอบโจทย์ที่หลากหลาย คุณสามารถค้นหาแผนประกันออนไลน์ที่เหมาะกับไลฟ์สไตล์ของคุณมากที่สุด",
          },
          pageType: null,
          metadataKeywords: { value: "ประกัน, ประกันภัย, ประกันออนไลน์" },
          globalMetaTextSetting: null,
          localizedPages: { value: {} },
          overwriteGlobalMetaTag: { value: false },
          additionalMetaTag: { value: "" },
          accrediationValue: null,
          disableCompliance: { value: false },
          accreditationMode: null,
          accreditationDescription: { value: "" },
          Priority: { value: "1" },
          disableHTMLCache: { value: false },
          openGraphURL: { value: {} },
          openGraphType: { value: "" },
          openGraphDescription: { value: "" },
          openGraphImage: {
            value: {
              src: "/-/media/images/get-insured/desktop-plp.jpg?rev=8b3df3c7e80e4386811314d2f84884e5",
              alt: "ผลิตภัณฑ์ประกันภัย",
            },
          },
          openGraphTitle: { value: "" },
          canonicalUrl: { value: "" },
          isPageSearchable: { value: false },
          hideLocalizedVersion: { value: false },
          hideInSitemap: { value: false },
          seoScript: { value: "" },
        },
        databaseName: "web",
        deviceId: "fe5d7fdf-89c0-4d99-9aa3-b5fbd009c9f3",
        itemId: "528d2c44-05e6-4e13-8c4c-0a7fff35b120",
        itemLanguage: "th",
        itemVersion: 10,
        layoutId: "e60605a5-f4f9-479a-b992-741bce767b1d",
        templateId: "52873596-fd74-488b-9e6e-6382b1cc2eb2",
        templateName: "Product Listing Page",
        placeholders: {
          "jss-metadata": [],
          "jss-header": [
            {
              uid: "abaca3eb-6579-47ef-b88f-c9e713f1ec17",
              componentName: "Header",
              dataSource: "{CCCFE6F7-1169-409A-AB37-3CAE30D24488}",
              params: {
                backgroundColor: "white-orange",
                paddingTop: "None",
                paddingBottom: "None",
              },
              fields: {
                displayMode: {
                  id: "c81d8d8f-e8d9-468f-acfc-bbdce30d66ec",
                  fieldType: "Droplink",
                  fieldName: "displayMode",
                  url: "/sitecore/content/fwd/global/settings/list/carouselmode/mobile",
                  fields: {
                    value: { value: "Mobile" },
                    key: { value: "Mobile" },
                  },
                },
                countrySelector: [
                  {
                    id: "0f8ee116-4b66-4b7e-81c5-275ee4c64978",
                    name: "Group",
                    displayName: "Group",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "FWD Group" },
                      link: {
                        value: {
                          href: "https://www.fwd.com/",
                          text: "FWD Group",
                          linktype: "external",
                          url: "https://www.fwd.com/",
                          anchor: "",
                          title: "FWD Group",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "c8790a90-c83f-4e0e-9337-d4b42e0f634b",
                    name: "Cambodia",
                    displayName: "Cambodia",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "กัมพูชา" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.kh/",
                          text: "กัมพูชา",
                          linktype: "external",
                          url: "https://www.fwd.com.kh/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "705fb6bf-8708-4aff-aba3-843de80e7577",
                    name: "Hong Kong",
                    displayName: "Hong Kong",
                    fields: {
                      isDefault: { value: false },
                      title: { value: " ฮ่องกง" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.hk/",
                          text: "FWD Hong Kong",
                          linktype: "external",
                          url: "https://www.fwd.com.hk/",
                          anchor: "",
                          title: "FWD Hong Kong",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "4c2ac688-4db2-44c0-a2a3-df7eee3f311b",
                    name: "Macau",
                    displayName: "Macau",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "มาเก๊า" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.mo/",
                          text: "FWD Macau",
                          linktype: "external",
                          url: "https://www.fwd.com.mo/",
                          anchor: "",
                          title: "FWD Macau",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "d6ec9fe1-6716-41f9-b260-777a3a0df396",
                    name: "Indonesia",
                    displayName: "Indonesia",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "อินโดนีเซีย" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.id/",
                          text: "FWD Indonesia",
                          linktype: "external",
                          url: "https://www.fwd.co.id/",
                          anchor: "",
                          title: "FWD Indonesia",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "1c474efb-12a7-46c4-b789-9dac52771e92",
                    name: "Japan",
                    displayName: "Japan",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "ญี่ปุ่น" },
                      link: {
                        value: {
                          href: "http://www.fwdlife.co.jp",
                          text: "FWD Japan",
                          linktype: "external",
                          url: "http://www.fwdlife.co.jp",
                          anchor: "",
                          title: "FWD Japan",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "7819367f-f443-4cc4-8500-853d174d5931",
                    name: "Malaysia",
                    displayName: "Malaysia",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "มาเลเซีย" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/",
                          text: "FWD Malaysia",
                          linktype: "external",
                          url: "https://www.fwd.com.my/",
                          anchor: "",
                          title: "FWD Malaysia",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "3cbf0795-1368-4bfa-823f-992a5e34ef0d",
                    name: "Philippines",
                    displayName: "Philippines",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "ฟิลิปปินส์" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.ph/",
                          text: "FWD Philippines",
                          linktype: "external",
                          url: "https://www.fwd.com.ph/",
                          anchor: "",
                          title: "FWD Philippines",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "38e2032c-59d9-45f0-b485-98c30b212638",
                    name: "Singapore",
                    displayName: "Singapore",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "สิงคโปร์" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.sg/",
                          text: "FWD Singapore",
                          linktype: "external",
                          url: "https://www.fwd.com.sg/",
                          anchor: "",
                          title: "FWD Singapore",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "66cfbe84-bc11-4565-9e91-63a71e5e33aa",
                    name: "Thailand",
                    displayName: "Thailand",
                    fields: {
                      isDefault: { value: true },
                      title: { value: "ประเทศไทย" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/",
                          text: "FWD Thailand",
                          linktype: "external",
                          url: "https://www.fwd.co.th/",
                          anchor: "",
                          title: "FWD Thailand",
                          target: "",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "35530397-2c2a-4175-9914-35dc9ed3b057",
                    name: "Vietnam",
                    displayName: "Vietnam",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "เวียดนาม" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.vn/",
                          text: "FWD Vietnam",
                          linktype: "external",
                          url: "https://www.fwd.com.vn/",
                          anchor: "",
                          title: "FWD Vietnam",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                ],
                mobileLogo: {
                  value: {
                    src: "/-/media/global/images/fwd_logo-mobile.gif?rev=9e29865196dd4776a143b57646afcdd5",
                    alt: "FWD Mobile logo",
                    x1: "/-/media/global/images/fwd_logo-mobile.gif?rev=9e29865196dd4776a143b57646afcdd5&cx=0&cy=0&cw=160&ch=55&hash=4FDFAE1542DDF131503F303BF85586B1",
                    x2: "/-/media/global/images/fwd_logo-mobile.gif?rev=9e29865196dd4776a143b57646afcdd5&cx=0&cy=0&cw=320&ch=110&hash=D8470B08365A6EF4FCC7FF151C00DF5E",
                  },
                },
                logo: {
                  value: {
                    src: "/-/media/global/images/fwd_logo-desktop.gif?rev=9945ec7a10524f8487d0ad6022ce8887",
                    alt: "FWD Desktop Logo",
                    x1: "/-/media/global/images/fwd_logo-desktop.gif?rev=9945ec7a10524f8487d0ad6022ce8887&cx=0&cy=0&cw=420&ch=145&hash=7CD7530DB8D97E3D51F3D9B0CFB0EB3E",
                    x2: "/-/media/global/images/fwd_logo-desktop.gif?rev=9945ec7a10524f8487d0ad6022ce8887&cx=0&cy=0&cw=840&ch=290&hash=EF0948D4A5CF7D4970CD39A8163F3638",
                  },
                },
                logoLink: {
                  value: {
                    href: "https://www.fwd.co.th/th/",
                    text: "Home",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    target: "",
                    querystring: "",
                    id: "{D9C6779B-43E9-4106-8357-AD0510A8547C}",
                  },
                },
                headerLogo: {
                  value: {
                    src: "/-/media/global/images/fwdlogod.svg?rev=a209dbca469647fa89f47c76a00dc55c",
                    alt: "FWD Desktop Logo",
                  },
                },
                headerNavigationLinks: [
                  {
                    id: "696e7720-7007-4515-baa2-f923545c5f67",
                    name: "personal-insurance",
                    displayName: "personal-insurance",
                    fields: {
                      title: { value: "ประกันภัยรายบุคคล" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/th/products/",
                          text: "",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          target: "",
                          querystring: "",
                          id: "{528D2C44-05E6-4E13-8C4C-0A7FFF35B120}",
                        },
                      },
                      buttonIcon: null,
                      pageType: {
                        id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                        fieldType: "Droptree",
                        fieldName: "pageType",
                        url: "/components/pagetype/individual",
                        fields: {
                          value: { value: "Individual" },
                          key: { value: "individual" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                    Children: [
                      {
                        id: "14c54add-25ec-4897-bdc9-425a41b6d53f",
                        name: "Life insurance",
                        displayName: "Life insurance",
                        fields: {
                          title: { value: "ประกันชีวิต" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/products/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              target: "",
                              querystring: "",
                              id: "{528D2C44-05E6-4E13-8C4C-0A7FFF35B120}",
                            },
                          },
                          buttonIcon: {
                            id: "19fcb2e6-0897-424f-9d15-b35209e646ed",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/products",
                            fields: {
                              value: { value: "products" },
                              key: { value: "products" },
                            },
                          },
                          pageType: {
                            id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "b7783aa2-a416-48b2-9b4c-688441d846f1",
                        name: "General insurance",
                        displayName: "General insurance",
                        fields: {
                          title: { value: "ประกันวินาศภัย" },
                          link: {
                            value: {
                              href: "http://www.fwdgi.co.th/th/",
                              text: "ประกันวินาศภัย",
                              linktype: "external",
                              url: "http://www.fwdgi.co.th/th/",
                              anchor: "",
                              target: "_blank",
                            },
                          },
                          buttonIcon: {
                            id: "19fcb2e6-0897-424f-9d15-b35209e646ed",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/products",
                            fields: {
                              value: { value: "products" },
                              key: { value: "products" },
                            },
                          },
                          pageType: {
                            id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "a4cabda7-dbb3-492f-8868-2f1a9f346e93",
                        name: "Claims",
                        displayName: "Claims",
                        fields: {
                          title: { value: "เรียกร้องสินไหม" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/claims/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              target: "",
                              querystring: "",
                              id: "{69567D54-9813-4873-A169-DDE101852FAE}",
                            },
                          },
                          buttonIcon: {
                            id: "8ba0c144-7d03-426d-84a8-3329cca6784a",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/claims",
                            fields: {
                              value: { value: "claims" },
                              key: { value: "claims" },
                            },
                          },
                          pageType: {
                            id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "626bffb7-d02b-4ff0-ae45-7d71f96b28a4",
                        name: "Support",
                        displayName: "Support",
                        fields: {
                          title: { value: "บริการลูกค้า" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/support/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{A09F0B08-17C3-43BA-A3B1-FD62BA1E29C9}",
                            },
                          },
                          buttonIcon: {
                            id: "327d49e8-0d7f-4133-b8eb-543e657d781b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/live-chat",
                            fields: {
                              value: { value: "live-chat" },
                              key: { value: "liveChat" },
                            },
                          },
                          pageType: {
                            id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "5aa022af-607b-4bb6-ad85-28ce83b26ac6",
                        name: "Rewards",
                        displayName: "Rewards",
                        fields: {
                          title: { value: "สิทธิพิเศษ" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/rewards/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{37296FD4-8CF2-45BA-88E0-FAAEC51215A7}",
                            },
                          },
                          buttonIcon: {
                            id: "7a571888-b9c6-4778-973b-828ec009c8b0",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/rewards",
                            fields: {
                              value: { value: "rewards" },
                              key: { value: "Rewards" },
                            },
                          },
                          pageType: {
                            id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "cd4f081e-a1ac-4ac6-a004-6aac01be8614",
                        name: "Visit Country site",
                        displayName: "Visit Country site",
                        fields: {
                          title: { value: "เยี่ยมชมเว็บไซต์ [ประเทศ]" },
                          link: { value: {} },
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                    ],
                  },
                  {
                    id: "94dcacbe-4314-4464-ba5b-6b74cb22020d",
                    name: "business-insurance",
                    displayName: "business-insurance",
                    fields: {
                      title: { value: "ประกันกลุ่ม" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/th/group-insurance/",
                          text: "",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          querystring: "",
                          id: "{0D08A74E-81B5-4DFD-9B53-B8AD7413F555}",
                        },
                      },
                      buttonIcon: null,
                      pageType: {
                        id: "186f12b8-f721-489f-8df9-67d5f10c69d5",
                        fieldType: "Droptree",
                        fieldName: "pageType",
                        url: "/components/pagetype/business",
                        fields: {
                          value: { value: "Business" },
                          key: { value: "business" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                    Children: [
                      {
                        id: "46efd563-0e58-4c65-a967-f1838d26aaf4",
                        name: "Products",
                        displayName: "Products",
                        fields: {
                          title: { value: "ผลิตภัณฑ์" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/group-insurance/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              target: "",
                              querystring: "",
                              id: "{0D08A74E-81B5-4DFD-9B53-B8AD7413F555}",
                            },
                          },
                          buttonIcon: {
                            id: "19fcb2e6-0897-424f-9d15-b35209e646ed",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/products",
                            fields: {
                              value: { value: "products" },
                              key: { value: "products" },
                            },
                          },
                          pageType: {
                            id: "186f12b8-f721-489f-8df9-67d5f10c69d5",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/business",
                            fields: {
                              value: { value: "Business" },
                              key: { value: "business" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "f7d7f2d9-b99f-4ac6-b715-a948f7037272",
                        name: "Support",
                        displayName: "Support",
                        fields: {
                          title: { value: "บริการลูกค้า" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/group-insurance/support/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{3CAD5672-1B79-4F04-8637-17B34ED987E9}",
                            },
                          },
                          buttonIcon: {
                            id: "fbdc2dbb-311b-47d3-929d-214d7b812ba5",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/supportoutline---obsolete",
                            fields: {
                              value: { value: "support-outline" },
                              key: { value: "supportOutline" },
                            },
                          },
                          pageType: {
                            id: "186f12b8-f721-489f-8df9-67d5f10c69d5",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/business",
                            fields: {
                              value: { value: "Business" },
                              key: { value: "business" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "941ed75c-de31-4f2e-bf74-0142d64eeee6",
                        name: "Visit Country site",
                        displayName: "Visit Country site",
                        fields: {
                          title: { value: "เยี่ยมชมเว็บไซต์ [ประเทศ]" },
                          link: { value: {} },
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                    ],
                  },
                  {
                    id: "286baa52-ced2-4202-bacc-40773b2e2545",
                    name: "Max",
                    displayName: "Max",
                    fields: {
                      title: { value: "เอฟดับบลิวดีแมกซ์" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/th/fwdmax/",
                          text: "",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          target: "",
                          querystring: "",
                          id: "{B06FCBBE-D82F-45E6-8CF6-9907C875B081}",
                        },
                      },
                      buttonIcon: null,
                      pageType: {
                        id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                        fieldType: "Droptree",
                        fieldName: "pageType",
                        url: "/components/pagetype/individual",
                        fields: {
                          value: { value: "Individual" },
                          key: { value: "individual" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "61f3e4bb-10b2-4c27-8459-85671780188a",
                    name: "about-us",
                    displayName: "about-us",
                    fields: {
                      title: { value: "เกี่ยวกับเรา" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/th/about-us/",
                          text: "",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          target: "",
                          querystring: "",
                          id: "{49F0D81D-2E91-44B2-9F6E-3267BABAFA41}",
                        },
                      },
                      buttonIcon: {
                        id: "368ba79d-8cae-435c-a781-fe6fb2f3725d",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/collection---obsolete",
                        fields: {
                          value: { value: "collection" },
                          key: { value: "Collection" },
                        },
                      },
                      pageType: {
                        id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                        fieldType: "Droptree",
                        fieldName: "pageType",
                        url: "/components/pagetype/individual",
                        fields: {
                          value: { value: "Individual" },
                          key: { value: "individual" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                ],
                iconNavigationLinks: [
                  {
                    id: "b478fc8e-7b49-4eb4-8635-d62df58d5e86",
                    name: "Login",
                    displayName: "Login",
                    fields: {
                      enableDropdown: { value: true },
                      title: { value: " เข้าสู่ระบบ" },
                      link: { value: {} },
                      buttonIcon: null,
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "Login" },
                    },
                    Children: [
                      {
                        id: "b6d18fad-2d17-4066-a3a5-0a13fe737c5e",
                        name: "Customer",
                        displayName: "Customer",
                        fields: {
                          title: { value: "ลูกค้า" },
                          link: {
                            value: {
                              href: "https://fwdlink.fwd.co.th/fwd/login?utm_source=nexgen&utm_medium=referral&utm_campaign=20210201-nexgenreferral",
                              text: "ลูกค้า",
                              linktype: "external",
                              url: "https://fwdlink.fwd.co.th/fwd/login?utm_source=nexgen&utm_medium=referral&utm_campaign=20210201-nexgenreferral",
                              anchor: "",
                              target: "",
                            },
                          },
                          buttonIcon: {
                            id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                            fields: {
                              value: { value: "arrow-right" },
                              key: { value: "Link" },
                            },
                          },
                          pageType: {
                            id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "customer" },
                        },
                      },
                      {
                        id: "a00211c6-37f4-4978-9153-7a4711bc5a96",
                        name: "Hospital",
                        displayName: "Hospital",
                        fields: {
                          title: { value: "โรงพยาบาล" },
                          link: {
                            value: {
                              href: "https://hospitalportal.fwd.co.th/",
                              linktype: "external",
                              url: "https://hospitalportal.fwd.co.th/",
                              anchor: "",
                              target: "",
                            },
                          },
                          buttonIcon: {
                            id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                            fields: {
                              value: { value: "arrow-right" },
                              key: { value: "Link" },
                            },
                          },
                          pageType: {
                            id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "hospital" },
                        },
                      },
                      {
                        id: "440f8161-d414-45b1-99fd-6277f3f1e199",
                        name: "Agent",
                        displayName: "Agent",
                        fields: {
                          title: { value: "ตัวแทนฝ่ายขาย" },
                          link: {
                            value: {
                              href: "https://www.fwd.in.th/logon.aspx?",
                              linktype: "external",
                              url: "https://www.fwd.in.th/logon.aspx?",
                            },
                          },
                          buttonIcon: {
                            id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                            fields: {
                              value: { value: "arrow-right" },
                              key: { value: "Link" },
                            },
                          },
                          pageType: {
                            id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "agent" },
                        },
                      },
                    ],
                  },
                  {
                    id: "5d801d94-570a-437f-a238-0fd2101dce5d",
                    name: "Support",
                    displayName: "Support",
                    fields: {
                      enableDropdown: { value: true },
                      title: { value: "" },
                      link: { value: {} },
                      buttonIcon: {
                        id: "79cc843a-2212-40b5-b09f-2018d04c72a9",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/contact",
                        fields: {
                          value: { value: "contact" },
                          key: { value: "Contact" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "Support" },
                    },
                    Children: [
                      {
                        id: "1575f6cd-317f-4bc7-9f9d-30ec68035f18",
                        name: "Call 1351",
                        displayName: "Call 1351",
                        fields: {
                          title: { value: "โทร. 1351" },
                          link: {
                            value: {
                              href: "http://tel:1351",
                              text: "โทร. 1351",
                              linktype: "external",
                              url: "tel:1351",
                              anchor: "",
                              target: "",
                            },
                          },
                          buttonIcon: {
                            id: "0853a008-9b3c-4a10-98b9-1e96a3cdc253",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/call",
                            fields: {
                              value: { value: "call" },
                              key: { value: "Call" },
                            },
                          },
                          pageType: {
                            id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "fd670504-d972-4fee-9582-656b0d6ba342",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/call",
                            fields: {
                              value: { value: "Call" },
                              key: { value: "call" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "fdf5ee71-675b-4ac4-9f71-0b8b34197e7d",
                        name: "Live Chat",
                        displayName: "Live Chat",
                        fields: {
                          title: { value: "แชตกับฟี่" },
                          link: { value: {} },
                          buttonIcon: {
                            id: "631bc306-c30e-4d10-afe5-670237118479",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/chat",
                            fields: {
                              value: { value: "chat" },
                              key: { value: "chat" },
                            },
                          },
                          pageType: {
                            id: "fb2c4a8a-0593-44b7-b7c4-ae07af4f8bb2",
                            fieldType: "Droptree",
                            fieldName: "pageType",
                            url: "/components/pagetype/individual",
                            fields: {
                              value: { value: "Individual" },
                              key: { value: "individual" },
                            },
                          },
                          listType: {
                            id: "5e19aacf-53fc-4f68-a278-b0c8ab1c5b67",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/chat",
                            fields: {
                              value: { value: "Chat" },
                              key: { value: "chat" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "Livechat" },
                        },
                      },
                    ],
                  },
                  {
                    id: "a06aeaa3-83e8-498d-91ab-2c715b18186c",
                    name: "Search",
                    displayName: "Search",
                    fields: {
                      enableDropdown: { value: true },
                      title: { value: "" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/th/search/",
                          text: "",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          querystring: "",
                          id: "{564D4C9C-BEEB-4497-9BB7-74A9EBAEF812}",
                        },
                      },
                      buttonIcon: {
                        id: "8e6f2179-2d7b-420d-9d47-d13c408bb3c5",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/search",
                        fields: {
                          value: { value: "search" },
                          key: { value: "Search" },
                        },
                      },
                      listType: {
                        id: "b91e87f2-99cc-4a93-a0ba-3ee8c14f36a4",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/search",
                        fields: {
                          value: { value: "Search" },
                          key: { value: "search" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                ],
                searchPageLink: {
                  value: {
                    href: "https://www.fwd.co.th/th/search/",
                    text: "",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{564D4C9C-BEEB-4497-9BB7-74A9EBAEF812}",
                  },
                },
                pastSearchRecordsCount: { value: "8" },
                title: { value: "ฉันกำลังมองหา" },
                placeholderText: { value: "กรุณาใส่คำหรือข้อความ" },
                languageModalDescription: {
                  value:
                    "เรากำลังดำเนินการพัฒนา คุณสามารถเลือกอยู่ในหน้านี้ หรือค้นหาบทความอื่นๆ ที่เกี่ยวข้อง",
                },
                languageModalLink: {
                  value: {
                    href: "https://www.fwd.co.th/th/",
                    text: "สำรวจ",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{D9C6779B-43E9-4106-8357-AD0510A8547C}",
                  },
                },
                languageModalSecondaryLink: { value: "อยู่หน้านี้" },
                languageModalTitle: {
                  value: "ไม่มีเนื้อหานี้ในภาษาที่คุณเลือก",
                },
                languageList: [
                  {
                    id: "65e62323-9da1-4172-b472-7443ebbbfbee",
                    fields: {
                      languageName: { value: "EN" },
                      languageCode: { value: "en" },
                      defaultLanguage: { value: "Th" },
                    },
                  },
                  {
                    id: "5f8cb340-ec7f-4b71-bb4a-c950856d3495",
                    fields: {
                      languageName: { value: "ไทย" },
                      languageCode: { value: "th" },
                      defaultLanguage: { value: "En" },
                    },
                  },
                ],
                enableLanguageToggle: { value: true },
              },
            },
          ],
          "jss-main": [
            {
              uid: "bd9bbfd0-cc3f-422c-ac56-008cba8fcade",
              componentName: "ProductListFilter",
              dataSource: "{62C006ED-C5AA-4D5E-975B-5C14D2646494}",
              fields: {
                linkIcon: {
                  id: "8e6f2179-2d7b-420d-9d47-d13c408bb3c5",
                  fieldType: "Droplink",
                  fieldName: "linkIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/search",
                  fields: {
                    value: { value: "search" },
                    key: { value: "Search" },
                  },
                },
                linkItem: { value: {} },
                title: { value: "ค้นหาแบบประกันที่ใช่สำหรับคุณ" },
                resetLinkIcon: {
                  id: "333fe4f4-b36c-409b-90ad-503a6561b8d8",
                  fieldType: "Droplink",
                  fieldName: "resetLinkIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/reset",
                  fields: {
                    value: { value: "reset" },
                    key: { value: "Reset" },
                  },
                },
                resetLinkItem: {
                  value: {
                    href: "http://ตั้งค่าเริ่มต้น",
                    text: "ตั้งค่าเริ่มต้น",
                    linktype: "external",
                    url: "ตั้งค่าเริ่มต้น",
                    anchor: "",
                    title: "Reset",
                    target: "",
                  },
                },
                primaryNeedTags: [
                  {
                    id: "67f745f2-3a37-4569-b598-0b98cdc6b144",
                    fields: {
                      searchName: { value: "Health" },
                      name: { value: "สุขภาพ" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "fe8587f2-045f-44a2-83ac-6058af7cc0af",
                    fields: {
                      searchName: { value: "Life protection" },
                      name: { value: "คุ้มครองชีวิต" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "eda8aa85-90e4-409c-99e9-adc0eca09767",
                    fields: {
                      searchName: { value: "savings" },
                      name: { value: "สะสมทรัพย์" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "79cc6ed6-35e7-48e5-b2f9-54d5c71cce20",
                    fields: {
                      searchName: { value: "retirement" },
                      name: { value: "เกษียณ" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "78547d81-08b8-4ba5-96a9-99c53e609994",
                    fields: {
                      searchName: { value: "legacy" },
                      name: { value: "มรดก" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "f21b83ef-a6e2-445c-8e35-4a7016f37b24",
                    fields: {
                      searchName: { value: "accident" },
                      name: { value: "อุบัติเหตุ " },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "390404dc-4c70-4662-b09e-5fb89b7b5294",
                    fields: {
                      searchName: { value: "Investments" },
                      name: { value: "การลงทุน" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "8dbd5bd3-0cfb-425f-add3-b718abaf6530",
                    fields: {
                      searchName: { value: "family" },
                      name: { value: "ครอบครัว" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                ],
                secondaryNeedTags: [
                  {
                    id: "43a7f218-3381-451d-9ce7-a6a6bb4d6b53",
                    name: "accident",
                    displayName: "accident",
                    fields: {
                      searchName: { value: "accident" },
                      name: { value: "อุบัติเหตุ " },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "7ae39c91-d225-4db6-87d0-e186ba86699f",
                    name: "Buy online",
                    displayName: "Buy online",
                    fields: {
                      searchName: { value: "Buy online" },
                      name: { value: "ประกันออนไลน์" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "76b23121-1a2d-4a4a-b0bb-03055681f0a1",
                    name: "cancer",
                    displayName: "cancer",
                    fields: {
                      searchName: { value: "cancer" },
                      name: { value: "โรคมะเร็ง" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "4c65204e-7c30-47cc-9d13-9ae30ddecc6d",
                    name: "Cash Return",
                    displayName: "Cash Return",
                    fields: {
                      searchName: { value: "Cash Return" },
                      name: { value: "เงินคืน" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "4aad76cf-31e0-4541-92ff-97fa5f247cdd",
                    name: "Critical Illness",
                    displayName: "Critical Illness",
                    fields: {
                      searchName: { value: "Critical Illness" },
                      name: { value: "โรคร้ายแรง" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "938f2a12-9b5e-4c34-83c0-6c6d1e08c7f7",
                    name: "Death",
                    displayName: "Death",
                    fields: {
                      searchName: { value: "Death" },
                      name: { value: "เสียชีวิต" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "283d3a04-6c0c-4518-b511-5ab6e51ae9ad",
                    name: "Group Insurance",
                    displayName: "Group Insurance",
                    fields: {
                      searchName: { value: "Group Insurance" },
                      name: { value: "ประกันกลุ่ม" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "3b665d9e-e173-4812-a021-1ca6786c593a",
                    name: "health benefit",
                    displayName: "health benefit",
                    fields: {
                      searchName: { value: "health benefit" },
                      name: { value: "ผลประโยชน์ด้านสุขภาพ" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "3128724f-810c-4acb-820c-783d2472867b",
                    name: "Hospital Benefit",
                    displayName: "Hospital Benefit",
                    fields: {
                      searchName: { value: "Hospital Benefit" },
                      name: { value: "ค่าชดเชยรายวัน" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "147b9125-5dd2-438b-81f2-b1d370122b56",
                    name: "IPD",
                    displayName: "IPD",
                    fields: {
                      searchName: { value: "IPD" },
                      name: { value: "ค่ารักษาพยาบาลผู้ป่วยใน" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "133affa4-0316-4fa7-bca6-9e79fe6fdc3d",
                    name: "Loss of organs",
                    displayName: "Loss of organs",
                    fields: {
                      searchName: { value: "Loss of organs" },
                      name: { value: "สูญเสียอวัยวะ/การมองเห็น" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "a071b27a-e1ba-4fbd-b76b-70f1a17e3939",
                    name: "OPD",
                    displayName: "OPD",
                    fields: {
                      searchName: { value: "OPD" },
                      name: { value: "ค่ารักษาพยาบาลผู้ป่วยนอก" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "471cac47-7cea-4986-ade7-5276c44ce631",
                    name: "Protection",
                    displayName: "Protection",
                    fields: {
                      searchName: { value: "Protection" },
                      name: { value: "ความคุ้มครอง" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "5759fca0-5580-4134-9ac6-a31e2d302741",
                    name: "retirement income",
                    displayName: "retirement income",
                    fields: {
                      searchName: { value: "retirement income" },
                      name: { value: "บำนาญ" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "4236c23a-7c22-4c31-9d04-c61cf4ff2cb2",
                    name: "Saving",
                    displayName: "Saving",
                    fields: {
                      searchName: { value: "saving" },
                      name: { value: "สะสมทรัพย์" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "bff3373d-bf65-4d18-9c77-585f7b90ff34",
                    name: "surgery",
                    displayName: "surgery",
                    fields: {
                      searchName: { value: "surgery" },
                      name: { value: "ค่าผ่าตัด" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "07176e71-7da2-4dcd-b6f8-2b1df480446c",
                    name: "Tax benefits",
                    displayName: "Tax benefits",
                    fields: {
                      searchName: { value: "Tax benefits" },
                      name: { value: "ลดหย่อนภาษี" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "9ae284b2-e199-4bca-9864-1a183236aabb",
                    name: "Total permanent disability",
                    displayName: "Total permanent disability",
                    fields: {
                      searchName: { value: "Total permanent disability" },
                      name: { value: "ทุพพลภาพถาวรสิ้นเชิง" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "87bce3a9-7726-407e-9b01-a1d226c9ee35",
                    name: "Unit link",
                    displayName: "Unit link",
                    fields: {
                      searchName: { value: "Unit linked" },
                      name: { value: "ประกันควบการลงทุน" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                  {
                    id: "a45d27f4-c715-47c2-b889-e5093b3caef3",
                    name: "weekly payout",
                    displayName: "weekly payout",
                    fields: {
                      searchName: { value: "weekly payout" },
                      name: { value: "เงินชดเชยรายสัปดาห์" },
                      mobileImage: { value: {} },
                      articlePillarPage: { value: "" },
                      image: { value: {} },
                      filterBy: null,
                    },
                  },
                ],
                image: {
                  value: {
                    src: "/-/media/images/get-insured/desktop-plp.jpg?rev=8b3df3c7e80e4386811314d2f84884e5",
                    alt: "ผลิตภัณฑ์ประกันภัย",
                    x1: "/-/media/images/get-insured/desktop-plp.jpg?rev=8b3df3c7e80e4386811314d2f84884e5&cx=0.33&cy=0.52&cw=1366&ch=456&hash=B7FCFA9AB2BD15975BA21E266B637DE0",
                    x2: "/-/media/images/get-insured/desktop-plp.jpg?rev=8b3df3c7e80e4386811314d2f84884e5&cx=0.33&cy=0.52&cw=2732&ch=912&hash=5A88E142F4C029540D505A26DFF0D7B6",
                    x3: "/-/media/images/get-insured/desktop-plp.jpg?rev=8b3df3c7e80e4386811314d2f84884e5&cx=0.33&cy=0.52&cw=1200&ch=630&hash=70C6CB9591A62CC7CCE65940BFF89159",
                  },
                },
                mobileImage: {
                  value: {
                    src: "/-/media/images/get-insured/desktop-plp.jpg?rev=8b3df3c7e80e4386811314d2f84884e5",
                    alt: "ผลิตภัณฑ์ประกันภัย",
                    x1: "/-/media/images/get-insured/desktop-plp.jpg?rev=8b3df3c7e80e4386811314d2f84884e5&cx=0.34&cy=0.61&cw=360&ch=360&hash=7E5229E374B346CF06E9F8E4224F2980",
                    x2: "/-/media/images/get-insured/desktop-plp.jpg?rev=8b3df3c7e80e4386811314d2f84884e5&cx=0.34&cy=0.61&cw=720&ch=720&hash=7056E07CE41AA538D05B4BE6732EE833",
                  },
                },
                gaCategoryName: { value: "" },
                gaLabelName: { value: "" },
              },
            },
            {
              uid: "6739198d-8b88-49c3-ac41-77833664f303",
              componentName: "ProductCardList",
              dataSource: "{64613F7E-A58F-493C-8634-84D7B66D5553}",
              params: {
                showProductCTA: "1",
                backgroundColor: "grey-white",
                paddingTop: "Medium",
                paddingBottom: "Medium",
              },
              fields: {
                filtersList: [
                  {
                    id: "3d0213d6-2dbe-4871-809f-400c7f94ff21",
                    fields: {
                      isBooleanFilter: { value: false },
                      queryStringKey: { value: "" },
                      value: { value: "ประเภทผลิตภัณฑ์" },
                      key: { value: "plancomponentfield_s" },
                    },
                  },
                  {
                    id: "0f0de57e-1571-40be-a20f-ffee468d56d7",
                    fields: {
                      isBooleanFilter: { value: false },
                      queryStringKey: { value: "" },
                      value: { value: "ซื้อตอนนี้" },
                      key: { value: "purchasemethodfield_sm" },
                    },
                  },
                ],
                linkItems: null,
                noResultFoundSource: {
                  id: "8f68f109-31b0-4b02-b903-5036bbbddc96",
                  fieldType: "Droplink",
                  fieldName: "noResultFoundSource",
                  url: "/components/noresultfound/product-listing",
                  fields: {
                    title: { value: "ไม่มีข้อมูล" },
                    icon: {
                      value: {
                        src: "/-/media/global/images/icons/noresult.png?rev=be6415d413fc434f961897dfa2a18891",
                      },
                    },
                    subTitle: {
                      value:
                        "ไม่มีผลิตภัณฑ์ใดตรงกับแท็กที่คุณเลือก ลองเลือกแท็กที่เฉพาะเจาะจงเพื่อผลการค้นหาที่ดียิ่งขึ้น",
                    },
                    gaCategoryName: { value: "" },
                    gaLabelName: { value: "" },
                  },
                },
                apiAllowPagination: { value: false },
                apiPageSize: { value: "9" },
                apiContentType: {
                  id: "3b19d2b5-aaa3-4fb7-a107-4cec5f9110f1",
                  fieldType: "Droplink",
                  fieldName: "apiContentType",
                  url: "/sitecore/content/fwd/global/settings/api-query/search-api/products",
                  fields: {
                    apiName: { value: "Products" },
                    value: {
                      value:
                        "https://prd-api-www.fwd.com/search/{language}/GetProductList",
                    },
                    key: {
                      value:
                        "C9VX6X34b56tC2n2b67hlL5N97VoHguVy1mVnH65KgCm0MWVATlgx9Z453Zb0gE0HXpOzo0Z6ery6oRiNN28z34mBk",
                    },
                  },
                },
                apiSortBy: {
                  id: "28c97c30-319a-403c-8d47-85eb8baa708f",
                  fieldType: "Droplink",
                  fieldName: "apiSortBy",
                  url: "/sitecore/content/fwd/global/settings/api-query/sort-by/score-and-title",
                  fields: {
                    value: { value: "scorevalue_l desc,titlefield_s asc" },
                    key: { value: "ScoreAndTitle" },
                  },
                },
                apiMobilePageSize: { value: "6" },
                apiSubType: null,
                gaCategoryName: { value: "" },
                gaLabelName: { value: "" },
              },
            },
            {
              uid: "bcb5c640-69d5-4c2c-a547-5999cfafbe4f",
              componentName: "ContentBlock",
              dataSource: "{2BF4F9C2-8879-4675-A598-08A3C33E0C92}",
              params: {
                showMediaOnMobile: "1",
                contentBlockType: "ls",
                backgroundColor: "white",
                paddingTop: "Medium",
                paddingBottom: "Medium",
              },
              fields: {
                mediaType: null,
                description: {
                  value:
                    '<p style="margin: 0pt 0in; text-align: left;"><span style="letter-spacing: 0pt; color: black;">เราคิดทุกอย่างมาจากความเข้าใจความต้องการของลูกค้า ทั้งสิทธิประโยชน์ที่มากมายและประกันที่หลากหลาย เพื่อให้ครอบคลุมทุกไลฟ์สไตล์&nbsp;</span><span style="letter-spacing: 0pt; color: black;">พร้อมช่วยดูแลคุณทุกที่ทุกเวลา</span></p>',
                },
                subTitle: { value: "" },
                enableHeading: { value: false },
                title: {
                  value: "ใช้ชีวิตในแบบที่ชอบ ด้วยประกันจากเอฟดับบลิวดี",
                },
                enableFeaturedTags: { value: false },
                enablePurchaseChannels: { value: false },
                mobileImage: { value: {} },
                image: { value: {} },
                videoYouTubeID: { value: "" },
                videoLink: { value: null },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwd.co.th/-/media/documents/usp/fwd-usp-a4_07092021_5.pdf?rev=0ce70c1f9e5b4dddbad53ff8a5a10f51",
                    text: "เอฟดับบลิวดีดูแลคุณได้อย่างไร?...พบคำตอบที่นี่",
                    linktype: "media",
                    target: "_blank",
                    id: "{4C240973-E833-4766-998A-E11CBD4E9662}",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: { value: "" },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                gaCategoryName: { value: "" },
                gaLabelName: { value: "" },
                brightcoveVideo: null,
              },
            },
            {
              uid: "9fa7c353-70d2-4a2f-abb2-51fd78bb237b",
              componentName: "CustomerSupport",
              dataSource: "{B64FDCA7-177F-42C8-8661-8B29F2D98D96}",
              params: {
                buttonAlignment: "center",
                backgroundColor: "orange-white",
                paddingTop: "Large",
                paddingBottom: "Large",
              },
              fields: {
                title: { value: "บริการให้ความช่วยเหลือส่วนบุคคล" },
                description: {
                  value: "ไม่สามารถตัดสินใจเลือกผลิตภัณฑ์ที่เหมาะกับคุณ?",
                },
                supportOptions: [
                  {
                    id: "9d0b5568-7a7e-422a-8edb-f1edf7f6b230",
                    fields: {
                      title: { value: "ติดต่อสอบถาม" },
                      icon: {
                        value: {
                          src: "/-/media/images/supports/call.svg?rev=344495c4c2c14009bee1d70f685936dd",
                          alt: "call",
                        },
                      },
                      subTitle: {
                        value:
                          "ส่งรายละเอียดเพิ่มเติม เราจะติดต่อกลับคุณโดยเร็วที่สุด ",
                      },
                      supportIcon: {
                        id: "f35ed9fd-ad24-494a-8fb6-33be8955a85d",
                        fieldType: "CustomDroplink",
                        fieldName: "supportIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/call-email",
                        fields: {
                          value: { value: "call-email" },
                          key: { value: "callEmail" },
                        },
                      },
                      medalliaForm: { value: "" },
                      listType: {
                        id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      buttonIcon: {
                        id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                        fields: {
                          value: { value: "arrow-right" },
                          key: { value: "Link" },
                        },
                      },
                      link: {
                        value: {
                          text: "Enquire",
                          linktype: "form",
                          querystring: "bookAnAgent",
                          target: "",
                          id: "{90D7A8DC-2EBC-4E16-8D0F-E162C7D01EC5}",
                          href: "/formslist/general-enquiry-form",
                        },
                      },
                      buttonMode: {
                        id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                        fieldType: "Droplink",
                        fieldName: "buttonMode",
                        url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                        fields: {
                          value: { value: "SimpleLink" },
                          key: { value: "SimpleLink" },
                        },
                      },
                      linkGALabelName: { value: "" },
                    },
                  },
                  {
                    id: "cc115d5a-4819-4224-8b56-f69aec264865",
                    fields: {
                      title: { value: "แชตกับฟี่" },
                      icon: {
                        value: {
                          src: "/-/media/images/supports/chat.svg?rev=e28bd495e1254211a32fffa85ba6ff82",
                          alt: "chat",
                        },
                      },
                      subTitle: {
                        value:
                          "แชตบอตของเราพร้อมหาคำตอบให้คุณอย่างรวดเร็ว ไม่ว่าจะเรื่องอะไร หากคุณต้องการความช่วยเหลือ แชตกับฟี่ได้เลย (หากเกินกำลังแชตบอต ฟี่จะเสนอตัวช่วยที่เหมาะสมให้)\n",
                      },
                      supportIcon: {
                        id: "631bc306-c30e-4d10-afe5-670237118479",
                        fieldType: "CustomDroplink",
                        fieldName: "supportIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/chat",
                        fields: {
                          value: { value: "chat" },
                          key: { value: "chat" },
                        },
                      },
                      buttonIcon: {
                        id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                        fields: {
                          value: { value: "arrow-right" },
                          key: { value: "Link" },
                        },
                      },
                      link: { value: {} },
                      buttonMode: {
                        id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                        fieldType: "Droplink",
                        fieldName: "buttonMode",
                        url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                        fields: {
                          value: { value: "SimpleLink" },
                          key: { value: "SimpleLink" },
                        },
                      },
                      linkGALabelName: { value: "AskFi" },
                      listType: {
                        id: "dda5c48b-3a8a-4afe-9b24-eaba5cda8c77",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/linklisttype/chat",
                        fields: {
                          value: { value: "Chat" },
                          key: { value: "chat" },
                        },
                      },
                    },
                  },
                  {
                    id: "9aa49352-9157-4c69-8276-906c960b3d02",
                    fields: {
                      title: { value: "เรียกร้องสินไหม" },
                      icon: {
                        value: {
                          src: "/-/media/images/supports/chat.svg?rev=e28bd495e1254211a32fffa85ba6ff82",
                          alt: "chat",
                        },
                      },
                      subTitle: {
                        value:
                          "ดูขั้นตอนการเรียกร้องสินไหมที่ง่ายและรวดเร็วของเราได้ที่นี่",
                      },
                      supportIcon: {
                        id: "8ba0c144-7d03-426d-84a8-3329cca6784a",
                        fieldType: "CustomDroplink",
                        fieldName: "supportIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/claims",
                        fields: {
                          value: { value: "claims" },
                          key: { value: "claims" },
                        },
                      },
                      medalliaForm: { value: "" },
                      listType: {
                        id: "f281af72-fa4b-4f87-98f1-4b9d77180e60",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/linklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      buttonIcon: {
                        id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                        fields: {
                          value: { value: "arrow-right" },
                          key: { value: "Link" },
                        },
                      },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/th/claims/",
                          text: "Open claim page",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "",
                          querystring: "",
                          id: "{69567D54-9813-4873-A169-DDE101852FAE}",
                        },
                      },
                      buttonMode: {
                        id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                        fieldType: "Droplink",
                        fieldName: "buttonMode",
                        url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                        fields: {
                          value: { value: "SimpleLink" },
                          key: { value: "SimpleLink" },
                        },
                      },
                      linkGALabelName: { value: "" },
                    },
                  },
                ],
                supportIcon: null,
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: {
                  value: {
                    href: "https://www.fwd.co.th/th/support/",
                    text: "แสดงช่องทางการติดต่อทั้งหมด",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "ดูช่องทางการติดต่อทั้งหมด",
                    querystring: "",
                    id: "{A09F0B08-17C3-43BA-A3B1-FD62BA1E29C9}",
                  },
                },
                buttonMode: {
                  id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                  fields: {
                    value: { value: "Primary" },
                    key: { value: "Primary" },
                  },
                },
                linkGALabelName: { value: "" },
                gaCategoryName: { value: "" },
                gaLabelName: { value: "" },
              },
            },
          ],
          "jss-footer": [
            {
              uid: "d6134fb5-960b-4784-8ae2-7231655f27dc",
              componentName: "Footer",
              dataSource: "{882A58F8-DDD7-4BA9-8EFC-D8D561AEC4F1}",
              params: {
                backgroundColor: "orangeLighter",
                paddingTop: "Medium",
                paddingBottom: "None",
              },
              fields: {
                logo: {
                  value: {
                    src: "/-/media/global/images/fwd-logo_colour.svg?rev=77f0e92219254f9caea8bbe5bba16478",
                    alt: "FWD logo svg",
                  },
                },
                logoLink: {
                  value: {
                    href: "https://www.fwd.co.th/th/",
                    text: "Home",
                    anchor: "",
                    linktype: "internal",
                    class: "",
                    title: "",
                    querystring: "",
                    id: "{D9C6779B-43E9-4106-8357-AD0510A8547C}",
                  },
                },
                call: { value: "1351" },
                icon: {
                  id: "166421b9-3ce6-4378-ae85-9cc48875088f",
                  fieldType: "CustomDroplink",
                  fieldName: "icon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/call-dual-tone---obsolete",
                  fields: {
                    value: { value: "call-dual-tone" },
                    key: { value: "Call Dual Tone" },
                  },
                },
                callingHoursTextAfterTooltip: { value: "" },
                callingHoursTextBeforeTooltip: { value: "" },
                callingHoursTooltip: { value: "" },
                enableCallingHoursText: { value: false },
                siteNavigationLinks: [
                  {
                    id: "b6a4a857-4afe-4885-b9c3-d3d6738e621a",
                    name: "column-1",
                    displayName: "column-1",
                    fields: {},
                    Children: [
                      {
                        id: "7ef68fd3-c87e-4e5f-9b9c-483934dfec17",
                        name: "Product",
                        displayName: "Product",
                        fields: {
                          title: { value: "ผลิตภัณฑ์" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/products/",
                              text: "ผลิตภัณฑ์",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{528D2C44-05E6-4E13-8C4C-0A7FFF35B120}",
                            },
                          },
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                        Children: [
                          {
                            id: "8a896737-457f-4728-93b3-f18099d75092",
                            name: "Health",
                            displayName: "Health",
                            fields: {
                              title: { value: "สุขภาพ" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/products/health/",
                                  text: "สุขภาพ",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{CC3F0F9C-2F1D-4151-9D50-8817D8833A0A}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "67e1efb3-aeda-48b9-9abc-6bb215c3c25c",
                            name: "Protection",
                            displayName: "Protection",
                            fields: {
                              title: { value: "คุ้มครองชีวิต" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/products/life-protection/",
                                  text: "คุ้มครองชีวิต",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{31C8200E-34EF-4DB6-BDF6-8B913C89B67D}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "5f16a651-dd81-4ceb-95d1-a8b2accba76f",
                            name: "Savings",
                            displayName: "Savings",
                            fields: {
                              title: { value: "สะสมทรัพย์" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/products/savings/",
                                  text: "ออมทรัพย์",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{5D51E9D2-C137-4A1C-9264-34AD4ACD4A5E}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "cad57476-729e-4916-921a-2f65d21fb0ec",
                            name: "Retirement",
                            displayName: "Retirement",
                            fields: {
                              title: { value: "เกษียณ" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/products/retirement/",
                                  text: "เกษียณ",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{93901AC3-0039-487C-B069-ACC1543BF234}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "0e168952-5248-4f3c-b139-bf2b21a5d4c4",
                            name: "Legacy",
                            displayName: "Legacy",
                            fields: {
                              title: { value: "มรดก" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/products/legacy/",
                                  text: "มรดก",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{4A49126C-4B5E-46A7-9ECC-562F3A84D188}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "2f577974-2257-4640-bd46-c88ac10bb112",
                            name: "Accident",
                            displayName: "Accident",
                            fields: {
                              title: { value: "อุบัติเหตุ" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/products/accident/",
                                  text: "อุบัติเหตุ",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{203A797B-8E26-40B2-8B79-11EA13B002FD}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "30bd944c-268a-4146-af1a-630af2106951",
                            name: "Investments",
                            displayName: "Investments",
                            fields: {
                              title: { value: "การลงทุน" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/products/investments/",
                                  text: "การลงทุน",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{D0FDA387-C773-4046-9DCD-BFA0E0A4363A}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "c3fbd081-a57e-4ad0-be56-49ce57c4f3c9",
                            name: "General insurance",
                            displayName: "General insurance",
                            fields: {
                              title: { value: "ประกันวินาศภัย" },
                              link: {
                                value: {
                                  href: "http://www.fwdgi.co.th/th/",
                                  text: "ประกันวินาศภัย",
                                  linktype: "external",
                                  url: "http://www.fwdgi.co.th/th/",
                                  anchor: "",
                                  target: "_blank",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: "e1218d56-f214-44e3-be35-2dd3d9cdbb72",
                    name: "column-2",
                    displayName: "column-2",
                    fields: {},
                    Children: [
                      {
                        id: "6c17bfb7-d526-45b3-a8b6-ec8b32c9d45c",
                        name: "Claims",
                        displayName: "Claims",
                        fields: {
                          title: { value: "การเรียกร้องสินไหม" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/claims/",
                              text: "การเรียกร้องสินไหม",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{69567D54-9813-4873-A169-DDE101852FAE}",
                            },
                          },
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                        Children: [
                          {
                            id: "1f66df00-095b-4c41-9e70-3188c99920f0",
                            name: "Find a form",
                            displayName: "Find a form",
                            fields: {
                              title: { value: "ค้นหาแบบฟอร์ม" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/support/forms/",
                                  text: "ค้นหาแบบฟอร์ม",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{6EDDED5F-86D9-4C1B-82ED-846BB127475D}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "88965a10-6265-4ca1-baa3-c94f57abaebc",
                            name: "Accident and health claims",
                            displayName: "Accident and health claims",
                            fields: {
                              title: {
                                value: "เรียกร้องสินไหมสุขภาพและอุบัติเหตุ",
                              },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/claims/accident-and-health/",
                                  text: "เรียกร้องสินไหมอุบัติเหตุและสุขภาพ",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{645F9677-0A72-4985-BA13-AFC14647AE5F}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "21857281-1532-4ce2-849f-801a59173477",
                            name: "Critical illness claims",
                            displayName: "Critical illness claims",
                            fields: {
                              title: { value: "เรียกร้องสินไหมโรคร้ายแรง" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/claims/critical-illness/",
                                  text: "Critical illness claims",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "Critical illness claims",
                                  querystring: "",
                                  id: "{ABC09A1E-7445-4F45-B811-3B75522C30DB}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "759104b1-d6f4-4c89-8b14-b6bc69225d50",
                            name: "Cancer claims",
                            displayName: "Cancer claims",
                            fields: {
                              title: { value: "เรียกร้องสินไหมโรคมะเร็ง" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/claims/cancer/",
                                  text: "Cancer claims",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "Cancer claims",
                                  querystring: "",
                                  id: "{433BFB79-6580-44CA-8FDF-7DB422C1215F}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "9277ace0-aced-45ee-b30a-02b7d3ab4344",
                            name: "Death claims",
                            displayName: "Death claims",
                            fields: {
                              title: { value: "เรียกร้องสินไหมมรณกรรม" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/claims/death/",
                                  text: "Death",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{472E1AF9-7793-4CB8-AF80-8F68B7BE9CE9}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "2d32a3fb-4a3f-4344-afdb-06d19c79203c",
                            name: "FWD Care Card",
                            displayName: "FWD Care Card",
                            fields: {
                              title: { value: "เรียกร้องสินไหมทุพพลภาพ" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/claims/total-permanent-disability/",
                                  text: "เรียกร้องสินไหมทุพพลภาพ",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{D2287612-7D43-4F33-BAEA-A141E381B89D}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "cdcb3fa9-ba09-40eb-aadf-fc3cf607913c",
                            name: "FWD Card",
                            displayName: "FWD Card",
                            fields: {
                              title: { value: "เอฟดับบลิวดี การ์ด" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/claims/fwd-card/",
                                  text: "FWD Care Card claims",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "FWD Care Card claims",
                                  querystring: "",
                                  id: "{F2FE3494-85FA-4D1F-8429-E75E14968F75}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: "7ac15a62-29cc-4f9d-9188-9f2c8a8e4f69",
                    name: "column-3",
                    displayName: "column-3",
                    fields: {},
                    Children: [
                      {
                        id: "ebbb4309-d07f-4dcc-a15c-4861a5c3baab",
                        name: "Support",
                        displayName: "Support",
                        fields: {
                          title: { value: "บริการลูกค้า" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/support/",
                              text: "บริการลูกค้า",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{A09F0B08-17C3-43BA-A3B1-FD62BA1E29C9}",
                            },
                          },
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                        Children: [
                          {
                            id: "8afdbf39-5c61-4981-8c49-1e24a5604842",
                            name: "FAQs",
                            displayName: "FAQs",
                            fields: {
                              title: { value: "คำถามที่พบบ่อย" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/support/faq/",
                                  text: "FAQs",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{4D410CCC-DDD8-456C-B317-FD8D00637F32}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "f09ec3cf-41f2-419d-82f4-6ee7f2d00023",
                            name: "Live chat",
                            displayName: "Live chat",
                            fields: {
                              title: { value: "ไลฟ์แชท" },
                              link: { value: {} },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "1eed96f8-20e1-4179-84a9-5497a8a82055",
                            name: "Call 1351",
                            displayName: "Call 1351",
                            fields: {
                              title: { value: "โทร.1351" },
                              link: {
                                value: {
                                  href: "http://tel:1351",
                                  text: "โทร.1351",
                                  linktype: "external",
                                  url: "tel:1351",
                                  anchor: "",
                                  target: "",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "fd670504-d972-4fee-9582-656b0d6ba342",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/call",
                                fields: {
                                  value: { value: "Call" },
                                  key: { value: "call" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "dd51f4b7-9985-49f8-8d5f-2ae3e7a90ce2",
                            name: "Online enquiry",
                            displayName: "Online enquiry",
                            fields: {
                              title: { value: "สอบถามออนไลน์" },
                              link: {
                                value: {
                                  text: "",
                                  linktype: "form",
                                  querystring: "bookAnAgent",
                                  target: "",
                                  id: "{90D7A8DC-2EBC-4E16-8D0F-E162C7D01EC5}",
                                  href: "/formslist/general-enquiry-form",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "2048ab07-103c-4f6d-96e2-01c2cd790ff7",
                            name: "Locate us",
                            displayName: "Locate us",
                            fields: {
                              title: { value: "ที่ตั้งสำนักงาน" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/branch-locator/",
                                  text: "ที่ตั้งสำนักงาน",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{AAD27929-2ECF-455F-9D17-7FBE1554B510}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "835afd47-d362-491a-b9ce-779208b3116a",
                            name: "Our hospital and clinic network",
                            displayName: "Our hospital and clinic network",
                            fields: {
                              title: { value: "โรงพยาบาลในเครือข่ายของเรา" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/hospital-network/",
                                  text: "โรงพยาบาลในเครือข่ายของเรา",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  querystring: "",
                                  id: "{EE338D6E-F74B-4A3C-AD12-A3E1CE871156}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "f98bad30-663a-401a-8d46-2f3a41ee1664",
                            name: "Fund information",
                            displayName: "Fund information",
                            fields: {
                              title: { value: "ข้อมูลกองทุน" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/products/investments/fund-information/",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring: "",
                                  id: "{5504F779-9CCF-4A7D-9EF3-DAF930E507C8}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "" },
                              gaLabelName: { value: "" },
                            },
                          },
                          {
                            id: "4f0bb82a-8f73-4226-ad5f-909740a924d4",
                            name: "Announcement",
                            displayName: "Announcement",
                            fields: {
                              title: { value: "ประกาศบริษัท" },
                              link: {
                                value: {
                                  href: "https://www.fwd.co.th/th/announcements/?contenttype=Article&subtype=Announcements",
                                  text: "",
                                  anchor: "",
                                  linktype: "internal",
                                  class: "",
                                  title: "",
                                  target: "",
                                  querystring:
                                    "contenttype=Article&subtype=Announcements",
                                  id: "{3BD9A9AF-214B-4772-BF6C-B1219096C060}",
                                },
                              },
                              buttonIcon: {
                                id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                                fieldType: "CustomDroplink",
                                fieldName: "buttonIcon",
                                url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                                fields: {
                                  value: { value: "chevron-right" },
                                  key: { value: "chevronRight" },
                                },
                              },
                              listType: {
                                id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                                fieldType: "Droplink",
                                fieldName: "listType",
                                url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                                fields: {
                                  value: { value: "Generic Link" },
                                  key: { value: "generic_link" },
                                },
                              },
                              gaCategoryName: { value: "Announcement" },
                              gaLabelName: { value: "Announcement" },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: "b619a274-7118-41da-b746-32fd8e568f9b",
                    name: "column-4",
                    displayName: "column-4",
                    fields: {},
                    Children: [
                      {
                        id: "9250bdd6-55d1-4fa5-ac26-9a4c309d82b7",
                        name: "Rewards",
                        displayName: "Rewards",
                        fields: {
                          title: { value: "สิทธิพิเศษ" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/rewards/",
                              text: "",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{37296FD4-8CF2-45BA-88E0-FAAEC51215A7}",
                            },
                          },
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "d0be86f1-2763-4ac9-a867-22ea867b091b",
                        name: "Business insurance",
                        displayName: "Business insurance",
                        fields: {
                          title: { value: "ประกันภัยกลุ่ม" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/group-insurance/",
                              text: "ประกันภัยกลุ่ม",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{0D08A74E-81B5-4DFD-9B53-B8AD7413F555}",
                            },
                          },
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "5e02f182-9bcc-4212-8cba-14bd94cd4435",
                        name: "FWD MAX",
                        displayName: "FWD MAX",
                        fields: {
                          title: { value: "เอฟดับบลิวดี แมกซ์" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/fwdmax/",
                              text: "เอฟดับบลิวดี แมกซ์",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{B06FCBBE-D82F-45E6-8CF6-9907C875B081}",
                            },
                          },
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                      {
                        id: "07f70095-3eb9-4845-b7b8-cca6feffccc3",
                        name: "About us",
                        displayName: "About us",
                        fields: {
                          title: { value: "เกี่ยวกับเรา" },
                          link: {
                            value: {
                              href: "https://www.fwd.co.th/th/about-us/",
                              text: "เกี่ยวกับเรา",
                              anchor: "",
                              linktype: "internal",
                              class: "",
                              title: "",
                              querystring: "",
                              id: "{49F0D81D-2E91-44B2-9F6E-3267BABAFA41}",
                            },
                          },
                          buttonIcon: {
                            id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                            fieldType: "CustomDroplink",
                            fieldName: "buttonIcon",
                            url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                            fields: {
                              value: { value: "chevron-right" },
                              key: { value: "chevronRight" },
                            },
                          },
                          listType: {
                            id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                            fieldType: "Droplink",
                            fieldName: "listType",
                            url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                            fields: {
                              value: { value: "Generic Link" },
                              key: { value: "generic_link" },
                            },
                          },
                          gaCategoryName: { value: "" },
                          gaLabelName: { value: "" },
                        },
                      },
                    ],
                  },
                ],
                countrySelector: [
                  {
                    id: "0f8ee116-4b66-4b7e-81c5-275ee4c64978",
                    name: "Group",
                    displayName: "Group",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "FWD Group" },
                      link: {
                        value: {
                          href: "https://www.fwd.com/",
                          text: "FWD Group",
                          linktype: "external",
                          url: "https://www.fwd.com/",
                          anchor: "",
                          title: "FWD Group",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "c8790a90-c83f-4e0e-9337-d4b42e0f634b",
                    name: "Cambodia",
                    displayName: "Cambodia",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "กัมพูชา" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.kh/",
                          text: "กัมพูชา",
                          linktype: "external",
                          url: "https://www.fwd.com.kh/",
                          anchor: "",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "705fb6bf-8708-4aff-aba3-843de80e7577",
                    name: "Hong Kong",
                    displayName: "Hong Kong",
                    fields: {
                      isDefault: { value: false },
                      title: { value: " ฮ่องกง" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.hk/",
                          text: "FWD Hong Kong",
                          linktype: "external",
                          url: "https://www.fwd.com.hk/",
                          anchor: "",
                          title: "FWD Hong Kong",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "4c2ac688-4db2-44c0-a2a3-df7eee3f311b",
                    name: "Macau",
                    displayName: "Macau",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "มาเก๊า" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.mo/",
                          text: "FWD Macau",
                          linktype: "external",
                          url: "https://www.fwd.com.mo/",
                          anchor: "",
                          title: "FWD Macau",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "d6ec9fe1-6716-41f9-b260-777a3a0df396",
                    name: "Indonesia",
                    displayName: "Indonesia",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "อินโดนีเซีย" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.id/",
                          text: "FWD Indonesia",
                          linktype: "external",
                          url: "https://www.fwd.co.id/",
                          anchor: "",
                          title: "FWD Indonesia",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "1c474efb-12a7-46c4-b789-9dac52771e92",
                    name: "Japan",
                    displayName: "Japan",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "ญี่ปุ่น" },
                      link: {
                        value: {
                          href: "http://www.fwdlife.co.jp",
                          text: "FWD Japan",
                          linktype: "external",
                          url: "http://www.fwdlife.co.jp",
                          anchor: "",
                          title: "FWD Japan",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "7819367f-f443-4cc4-8500-853d174d5931",
                    name: "Malaysia",
                    displayName: "Malaysia",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "มาเลเซีย" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.my/",
                          text: "FWD Malaysia",
                          linktype: "external",
                          url: "https://www.fwd.com.my/",
                          anchor: "",
                          title: "FWD Malaysia",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "3cbf0795-1368-4bfa-823f-992a5e34ef0d",
                    name: "Philippines",
                    displayName: "Philippines",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "ฟิลิปปินส์" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.ph/",
                          text: "FWD Philippines",
                          linktype: "external",
                          url: "https://www.fwd.com.ph/",
                          anchor: "",
                          title: "FWD Philippines",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "38e2032c-59d9-45f0-b485-98c30b212638",
                    name: "Singapore",
                    displayName: "Singapore",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "สิงคโปร์" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.sg/",
                          text: "FWD Singapore",
                          linktype: "external",
                          url: "https://www.fwd.com.sg/",
                          anchor: "",
                          title: "FWD Singapore",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "66cfbe84-bc11-4565-9e91-63a71e5e33aa",
                    name: "Thailand",
                    displayName: "Thailand",
                    fields: {
                      isDefault: { value: true },
                      title: { value: "ประเทศไทย" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/",
                          text: "FWD Thailand",
                          linktype: "external",
                          url: "https://www.fwd.co.th/",
                          anchor: "",
                          title: "FWD Thailand",
                          target: "",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "35530397-2c2a-4175-9914-35dc9ed3b057",
                    name: "Vietnam",
                    displayName: "Vietnam",
                    fields: {
                      isDefault: { value: false },
                      title: { value: "เวียดนาม" },
                      link: {
                        value: {
                          href: "https://www.fwd.com.vn/",
                          text: "FWD Vietnam",
                          linktype: "external",
                          url: "https://www.fwd.com.vn/",
                          anchor: "",
                          title: "FWD Vietnam",
                          target: "_blank",
                        },
                      },
                      buttonIcon: null,
                      listType: null,
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                ],
                socialMediaLinks: [
                  {
                    id: "790af4e5-19e0-4919-bcc8-d2b55e0c7b2e",
                    name: "Facebook",
                    displayName: "Facebook",
                    fields: {
                      title: { value: "facebook" },
                      link: {
                        value: {
                          href: "https://www.facebook.com/fwdthailand/",
                          text: "facebook",
                          linktype: "external",
                          url: "https://www.facebook.com/fwdthailand/",
                          anchor: "",
                          target: "",
                        },
                      },
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "FacebookFWDThailand" },
                    },
                  },
                  {
                    id: "0b365b93-2a12-443e-9c70-672b09782fa0",
                    name: "Line",
                    displayName: "Line",
                    fields: {
                      title: { value: "line" },
                      link: {
                        value: {
                          href: "https://timeline.line.me/user/_dfo2OBQneRhH2PTn7wxjlbWMqCMR6Txr95avbeY",
                          text: "line",
                          linktype: "external",
                          url: "https://timeline.line.me/user/_dfo2OBQneRhH2PTn7wxjlbWMqCMR6Txr95avbeY",
                          anchor: "",
                          target: "",
                        },
                      },
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "LineFWDThailand" },
                    },
                  },
                  {
                    id: "cb9d89cf-e96d-46b9-af34-1c1af2174905",
                    name: "Twitter",
                    displayName: "Twitter",
                    fields: {
                      title: { value: "twitter" },
                      link: {
                        value: {
                          href: "https://twitter.com/fwdthailand",
                          text: "twitter",
                          linktype: "external",
                          url: "https://twitter.com/fwdthailand",
                          anchor: "",
                          target: "",
                        },
                      },
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "TwitterFWDThailand" },
                    },
                  },
                  {
                    id: "beff79a2-16f1-4d2a-b469-8af59318e1a6",
                    name: "YouTube",
                    displayName: "YouTube",
                    fields: {
                      title: { value: "youtube" },
                      link: {
                        value: {
                          href: "https://www.youtube.com/channel/UCD3UsUfE10gjPjGEepO_r1A",
                          text: "youtube",
                          linktype: "external",
                          url: "https://www.youtube.com/channel/UCD3UsUfE10gjPjGEepO_r1A",
                          anchor: "",
                          target: "",
                        },
                      },
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "YoutubeFWDThailand" },
                    },
                  },
                ],
                footerQuickLinks: [
                  {
                    id: "dafa174b-ab18-4821-ba4a-c9bb5aadf0d6",
                    name: "Sitemap",
                    displayName: "Sitemap",
                    fields: {
                      title: { value: "แผนผังเว็บไซต์" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/th/sitemap/",
                          text: "แผนผังเว็บไซต์",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "แผนผังเว็บไซต์",
                          querystring: "",
                          id: "{6D4D73F8-997F-44B4-9503-87589C0201EC}",
                        },
                      },
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "8a2e371d-020e-410d-85ee-1fddb7a48c44",
                    name: "Disclaimer",
                    displayName: "Disclaimer",
                    fields: {
                      title: { value: "ข้อตกลงการใช้" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/th/disclaimer/",
                          text: "Disclaimer",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "Disclaimer",
                          querystring: "",
                          id: "{A6C39A1A-72C8-4766-AA77-F71EC84E3753}",
                        },
                      },
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                  {
                    id: "fd02bc01-2d73-4dd1-ab20-40f7696b80a1",
                    name: "Privacy Policy",
                    displayName: "Privacy Policy",
                    fields: {
                      title: { value: "นโยบายข้อมูลส่วนบุคคล" },
                      link: {
                        value: {
                          href: "https://www.fwd.co.th/th/privacy-policy/",
                          text: "Privacy Policy",
                          anchor: "",
                          linktype: "internal",
                          class: "",
                          title: "Privacy Policy",
                          querystring: "",
                          id: "{586403F5-4598-40C9-96E5-0BB8ADC0D789}",
                        },
                      },
                      buttonIcon: {
                        id: "f637d977-efa3-43f2-966a-b6aa2db4e70b",
                        fieldType: "CustomDroplink",
                        fieldName: "buttonIcon",
                        url: "/sitecore/content/fwd/global/settings/list/linkvariant/chevron-right",
                        fields: {
                          value: { value: "chevron-right" },
                          key: { value: "chevronRight" },
                        },
                      },
                      listType: {
                        id: "319b533c-ce50-4dfd-97b3-19b7b917cb0e",
                        fieldType: "Droplink",
                        fieldName: "listType",
                        url: "/sitecore/content/fwd/global/settings/list/navigationlinklisttype/generic_link",
                        fields: {
                          value: { value: "Generic Link" },
                          key: { value: "generic_link" },
                        },
                      },
                      gaCategoryName: { value: "" },
                      gaLabelName: { value: "" },
                    },
                  },
                ],
                copyrightLabel: {
                  value:
                    "สงวนลิขสิทธิ์ &copy; 2021 บริษัท เอฟดับบลิวดี ประกันชีวิต จำกัด (มหาชน)",
                },
                defaultComplianceAccreditation: {
                  id: "93dede65-6cb1-439f-af28-236163f6342a",
                  fieldType: "Droplink",
                  fieldName: "defaultComplianceAccreditation",
                  url: "/components/compliance-accreditation/iso27001_th",
                  fields: {
                    Description: {
                      value:
                        "เอฟดับบลิวดี ประกันชีวิต ได้รับการรับรองระบบบริหารจัดการด้านความปลอดภัยของสารสนเทศตามมาตรฐาน ISO 27001 จาก TUV NORD (Thailand) Ltd.",
                    },
                    Images: [
                      {
                        id: "a5ebb96c-442c-41ff-a15d-95304b9dd21b",
                        fields: {
                          mobileImage: {
                            value: {
                              src: "/-/media/images/home/iso_270001/iso-logo-th.png?rev=96188739dc0d4378acac53c80983116c",
                              alt: "ISO27001",
                              x1: "/-/media/images/home/iso_270001/iso-logo-th.png?rev=96188739dc0d4378acac53c80983116c&cx=0&cy=0&cw=328&ch=164&hash=2A22C37F951F9B626B7C1EB333C0164F",
                              x2: "/-/media/images/home/iso_270001/iso-logo-th.png?rev=96188739dc0d4378acac53c80983116c&cx=0&cy=0&cw=656&ch=328&hash=41FE2CBB735E950FA0C291A5ADCB79BE",
                            },
                          },
                          link: { value: {} },
                          image: {
                            value: {
                              src: "/-/media/images/home/iso_270001/iso-logo-th.png?rev=96188739dc0d4378acac53c80983116c",
                              alt: "ISO27001",
                              x1: "/-/media/images/home/iso_270001/iso-logo-th.png?rev=96188739dc0d4378acac53c80983116c&cx=0&cy=0&cw=392&ch=196&hash=5167D3E3E36439DF58799023FAB6971F",
                              x2: "/-/media/images/home/iso_270001/iso-logo-th.png?rev=96188739dc0d4378acac53c80983116c&cx=0&cy=0&cw=784&ch=392&hash=BD6CFB479EC72206606AAEF5C5DCFA57",
                            },
                          },
                        },
                      },
                    ],
                    accreditationMode: null,
                  },
                },
                disableComplianceAccreditation: { value: false },
                gaCategoryName: { value: "" },
                gaLabelName: { value: "" },
                languageModalDescription: { value: "" },
                languageModalLink: { value: {} },
                languageModalSecondaryLink: { value: "" },
                languageModalTitle: { value: "" },
                languageList: [
                  {
                    id: "65e62323-9da1-4172-b472-7443ebbbfbee",
                    fields: {
                      languageName: { value: "EN" },
                      languageCode: { value: "en" },
                      defaultLanguage: { value: "Th" },
                    },
                  },
                  {
                    id: "5f8cb340-ec7f-4b71-bb4a-c950856d3495",
                    fields: {
                      languageName: { value: "ไทย" },
                      languageCode: { value: "th" },
                      defaultLanguage: { value: "En" },
                    },
                  },
                ],
                enableLanguageToggle: { value: true },
              },
            },
          ],
        },
      },
    },
    productDetails: {
      initializer: "bookAnAgent",
      enquiryInitializer: "SUPPORT",
      productName: "",
      minAge: "",
      maxAge: "",
      minSumAssured: "",
      maxSumAssured: "",
      calculationOptions: [],
      sumAssuredSelectionType: "",
      premiumSelectionType: "",
      minPremiumYearly: "",
      maxPremiumYearly: "",
      sumAssuredRange: "",
      sumAssuredPaymentMode: [],
      purchaseMethod: [],
      premiumRange: "",
      premiumStepperInterval: "",
      sumAssuredStepperInterval: "",
      plans: [],
      ridersAvailable: null,
      enableEnquiryForRiders: null,
      associatedItems: [],
      filteredAssociatedItems: [],
      allPlanCards: [],
      productType: "",
      talkToAgentLink: null,
      talkToAgentTitle: "",
      expectedInsuranceType: "",
      parameters: null,
      expectedInsuranceTypeProductCard: "",
      parametersProductCard: "",
    },
    formLinks: {
      calculateFormLink: "",
      recommenderFormLink: "",
      enquiryFormLink: "",
      callbackFormLink:
        "https://www.fwd.co.th/sitecore/api/layout/render/jss?item=/formslist/general-enquiry-form&sc_lang=th&sc_apikey={D7333054-1DCE-4B0C-A9A5-AC7372A796AB}",
    },
    finalizer: "",
    apiStatus: {
      loading: false,
      apiStatus: null,
      errorCode: "",
      failCounter: 0,
    },
    form: {
      sitecore: {
        context: {
          pageEditing: false,
          site: { name: "fwd-th" },
          pageState: "normal",
          language: "th",
          languageCode: "th",
          defaultLanguage: "th",
          siteSettings: {
            productListPage: "/products/",
            splashPage: "",
            articleTagLink: "/search/",
            articleTypeDesign: [],
            articleOverlineText: false,
            globalMetaText: "เอฟดับบลิวดี ประเทศไทย",
            globalMetaTag: "",
            cookieMessage:
              'เราใช้คุกกี้เพื่อเพิ่มประสบการณ์การใช้งานที่ดี การเข้าใช้งานเว็บไซต์นี้ ถือว่าท่านยอมรับวิธีที่เราใช้คุกกี้และข้อมูลของท่าน ตาม<a href="https://www.fwd.co.th/th/privacy-policy/">นโยบายคุ้มครองข้อมูลส่วนบุคคล</a> ของเรา',
            cookieTimeStamp: "365",
            currencyPlacement: "AfterNumericals",
            currencyWhitespace: false,
            currencySeparator: { value: {} },
            currencyLabel: { value: { THB: "บาท" } },
            splashPageUpdatedDuration: "365",
            splashPageUpdatedDate: "",
            faviconImageUrl:
              "/-/media/global/images/icons/favicon.ico?rev=9d80f0017e88450db421c1247e3665fe",
            productErrorPictogramUrl:
              "/-/media/pictograms/no-result-48px2x.png?rev=458f050fa6494a13874483d2d84d6bc2",
            dateFormat: "DD/MM/YYYY",
            enablePlanCardSharePostCalc: "",
            sessionTimeout: "20",
            loaderTimeout: "",
            gAID: "GTM-WKBBW9X",
            gTMID: "GTM-WKBBW9X",
            gtmParamters: [],
            optimize360: true,
            hostName: "https://www.fwd.co.th",
            enableBackToTopButton: 1,
            dialogSessionTimeout: "5",
            productFallbackCTA: {
              value: {
                href: "/formslist/product-enquiry-form",
                text: "สอบถาม",
                anchor: "",
                linkType: "form",
                title: "",
                queryString: "enquiry",
                id: "{136AA02C-41C6-4E79-88E1-7893B161A37F}",
                gaLabel: "",
              },
            },
            brightcoveAccountID: "5650355171001",
            languageIcon: { key: "language-globe", value: "language-globe" },
            enableMultipleNotifications: false,
            hidePrimaryLanguage: false,
            currencyGALabelName: "",
            showArticleSubtitle: false,
            hasArticleSubtitleFallback: false,
          },
          share: {
            socialApps: [
              {
                facebook: {
                  url: {
                    value: {
                      href: "https://www.facebook.com/sharer.php?u=",
                      text: "Facebook Url",
                      linktype: "external",
                      url: "https://www.facebook.com/sharer.php?u=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "แชร์บนเฟซบุ๊ก" },
                  toolTip: { value: "" },
                },
              },
              {
                twitter: {
                  url: {
                    value: {
                      href: "https://twitter.com/intent/tweet?text=",
                      text: "Twitter Url",
                      linktype: "external",
                      url: "https://twitter.com/intent/tweet?text=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "แชร์บนทวิตเตอร์" },
                  toolTip: { value: "" },
                },
              },
              {
                line: {
                  url: {
                    value: {
                      href: "https://social-plugins.line.me/lineit/share?url=",
                      text: "Line Url",
                      linktype: "external",
                      url: "https://social-plugins.line.me/lineit/share?url=",
                      anchor: "",
                      target: "",
                    },
                  },
                  header: { value: "แชร์บนไลน์" },
                  toolTip: { value: "" },
                },
              },
            ],
          },
          siteNotifications: { notifications: [] },
          dialogModals: {
            modalList: [
              {
                activeSessionModal: {
                  title: { value: "คุณยังอยู่ที่นี่หรือไม่?" },
                  description: {
                    value:
                      "หน้านี้จะหมดอายุใน {time} คุณไม่ได้ใช้งานมาระยะหนึ่งแล้ว เลือกดำเนินการต่อเพื่อให้อยู่ในหน้า",
                  },
                  key: {
                    id: "bab3dabc-242d-419f-bc41-f342458cb50a",
                    fieldType: "Droplink",
                    fieldName: "key",
                    url: "/sitecore/content/fwd/global/settings/list/dialog-modal/activesessionmodal",
                    fields: {
                      value: { value: "ActiveSessionModal" },
                      key: { value: "activeSessionModal" },
                    },
                  },
                  buttonIcon: {
                    id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                    fieldType: "CustomDroplink",
                    fieldName: "buttonIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                    fields: {
                      value: { value: "arrow-right" },
                      key: { value: "Link" },
                    },
                  },
                  link: { value: {} },
                  buttonMode: {
                    id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                    fieldType: "Droplink",
                    fieldName: "buttonMode",
                    url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                    fields: {
                      value: { value: "Primary" },
                      key: { value: "Primary" },
                    },
                  },
                  linkGALabelName: { value: "" },
                  secondaryLinkButtonMode: {
                    id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                    fieldType: "Droplink",
                    fieldName: "secondaryLinkButtonMode",
                    url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                    fields: {
                      value: { value: "Secondary" },
                      key: { value: "Secondary" },
                    },
                  },
                  secondaryLinkGALabelName: { value: "" },
                  secondaryLink: { value: {} },
                  secondaryLinkButtonIcon: {
                    id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                    fieldType: "CustomDroplink",
                    fieldName: "secondaryLinkButtonIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                    fields: {
                      value: { value: "arrow-right" },
                      key: { value: "Link" },
                    },
                  },
                },
              },
              {
                expiredSessionModal: {
                  title: { value: "หน้านี้หมดอายุแล้ว" },
                  description: {
                    value:
                      "ดูเหมือนว่าคุณจะไม่ได้ใช้งานมาระยะหนึ่งแล้ว ข้อมูลของคุณยังไม่ได้รับการจัดเก็บ โปรดรีเฟรชและลองอีกครั้ง",
                  },
                  key: {
                    id: "13bd5030-db40-4148-a65f-678b8f0fb5a5",
                    fieldType: "Droplink",
                    fieldName: "key",
                    url: "/sitecore/content/fwd/global/settings/list/dialog-modal/expiredsessionmodal",
                    fields: {
                      value: { value: "ExpiredSessionModal" },
                      key: { value: "expiredSessionModal" },
                    },
                  },
                  buttonIcon: {
                    id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                    fieldType: "CustomDroplink",
                    fieldName: "buttonIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                    fields: {
                      value: { value: "arrow-right" },
                      key: { value: "Link" },
                    },
                  },
                  link: { value: {} },
                  buttonMode: {
                    id: "2d7e3979-8dae-42d1-bfdf-45522db9a1b9",
                    fieldType: "Droplink",
                    fieldName: "buttonMode",
                    url: "/sitecore/content/fwd/global/settings/list/button-mode/primary",
                    fields: {
                      value: { value: "Primary" },
                      key: { value: "Primary" },
                    },
                  },
                  linkGALabelName: { value: "" },
                  secondaryLinkButtonMode: {
                    id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                    fieldType: "Droplink",
                    fieldName: "secondaryLinkButtonMode",
                    url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                    fields: {
                      value: { value: "Secondary" },
                      key: { value: "Secondary" },
                    },
                  },
                  secondaryLinkGALabelName: { value: "" },
                  secondaryLink: { value: {} },
                  secondaryLinkButtonIcon: {
                    id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                    fieldType: "CustomDroplink",
                    fieldName: "secondaryLinkButtonIcon",
                    url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                    fields: {
                      value: { value: "arrow-right" },
                      key: { value: "Link" },
                    },
                  },
                },
              },
            ],
          },
          disclosurePopups: {
            popupList: [
              {
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                sessionTimeout: { value: "" },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                isRiskDisclosure: { value: true },
                defaultPageLink: { value: {} },
                enableSmallView: { value: false },
                title: { value: "คำเตือน" },
                footerText: { value: "" },
                text: {
                  value:
                    '<ul>\n    <li>หนังสือชี้ชวนที่ปรากฎอยู่ใน&nbsp;<span style="text-decoration: underline;">fwd.co.th</span>&nbsp;แม้ว่าจะได้รับการอนุมัติให้จัดตั้งและจัดการจากสำนักงานคณะกรรมการ ก.ล.ต.แต่มิได้เป็นการแสดงว่า คณะกรรมการ กลต. และสำนักงานคณะกรรมการ กลต. ได้รับรองถึงความถูกต้องของข้อมูลในหนังสือชี้ชวนและมิได้ประกันราคาหน่วยลงทุนที่เสนอขาย</li>\n</ul>\n<ul>\n    <li>การลงทุนมีความเสี่ยง ผู้เอาประกันภัยอาจได้รับเงินคืนมากกว่าหรือน้อยกว่ามูลค่าเบี้ยประกันภัยที่ถูกจัดสรรเข้ากองทุนรวมโดยหากผลการดำเนินงานของกองทุนรวมมีกำไร ผู้เอาประกันภัยก็จะได้ผลตอบแทนสูง แต่หากผลการดำเนินงานของกองทุนรวมขาดทุน ผู้เอาประกันภัยจะได้ผลตอบแทนต่ำ หรือบางกรณีอาจขาดทุน กล่าวคือ ไม่ได้รับเงินส่วนลงทุนคืนเต็มจำนวน ทั้งนี้กรมธรรม์นี้ไม่มีการรับประกันเงินส่วนลงทุน</li>\n</ul>\n<ul>\n    <li>กรมธรรม์นี้เหมาะสำหรับการออมเงินระยะยาว</li>\n</ul>\n<ul>\n    <li>ผู้เอาประกันภัยควรศึกษารายละเอียดเกี่ยวกับความเสี่ยงจากการลงทุนในกองทุนรวมในหนังสือชี้ชวนของกองทุนรวมด้วย</li>\n</ul>\n<ul>\n    <li>กองทุนรวมเป็นนิติบุคคลแยกต่างหากจากบริษัทประกันชีวิตและบริษัทจัดการ ดังนั้น บริษัทประกันชีวิตและบริษัทจัดการจึงไม่มีภาระผูกพันในการชดเชยผลขาดทุนของกองทุนรวม และจะไม่สามารถนำทรัพย์สินของกองทุนรวมไปใช้ประโยชน์เพื่อการชำระหนี้ของตนเอง</li>\n</ul>\n<ul>\n    <li>การลงทุนในหน่วยลงทุนมิใช่การฝากเงิน ผู้ลงทุนอาจได้รับคืนเงินลงทุนมากกว่าหรือน้อยกว่าเงินลงทุนเริ่มต้นและมีโอกาสไม่ได้รับชำระเงินค่าขายคืนหน่วยลงทุนภายในระยะเวลาที่กำหนด ในกรณีกองทุนเปิด ผู้ลงทุนอาจไม่สามารถขายคืนหน่วยลงทุนได้ตามที่มีคำสั่งไว้&nbsp;</li>\n</ul>\n<ul>\n    <li>การวัดผลการดำเนินงานของกองทุนรวม จัดทำขึ้นตามมาตรฐานการวัดผลการดำเนินงานของสมาคมบริษัทจัดการลงทุน</li>\n</ul>\n<ul>\n    <li>ผลการดำเนินงานของกองทุนรวม ไม่ได้ขึ้นอยู่กับสถานะทางการเงินหรือผลการดำเนินงานของบริษัทจัดการและบริษัทประกันชีวิต</li>\n</ul>\n<ul>\n    <li>ผลการดำเนินงานในอดีตของกองทุนรวม มิได้เป็นสิ่งยืนยันถึงผลการดำเนินงานในอนาคต</li>\n</ul>\n<ul>\n    <li>ผู้สนใจลงทุนควรศึกษาข้อมูลในหนังสือชี้ชวนให้เข้าใจอย่างละเอียดก่อนซื้อหน่วยลงทุน และควรเก็บเป็นข้อมูลไว้ใช้อ้างอิงในอนาคต หากต้องการข้อมูลเพิ่มเติมสามารถขอข้อมูลโครงการและสอบถามรายละเอียดได้ที่บริษัทจัดการหรือตัวแทน</li>\n</ul>\n<ul>\n    <li>กรุณาตอบคำถามตามแบบสอบถามของบริษัทฯ ซึ่งควรให้ข้อมูลที่เป็นความจริง ถูกต้อง เป็นปัจจุบัน และครบถ้วน โดยท่านได้รับหนังสือชี้ชวนจากบริษัทฯ แล้ว ทั้งนี้การให้ข้อมูลของท่าน จะมีผลต่อการให้บริการ หรือการให้คำแนะนำที่ท่านจะได้รับจากตัวแทนประกันชีวิตและบริษัทฯ</li>\n</ul>\n<ul>\n    <li>ข้อมูลที่ปรากฎอยู่ใน เว็บไซต์นี้ บริษัทได้จัดทำและรวบรวมขึ้นด้วยความสุจริต และพยายามจัดทำขึ้น บนพื้นฐานของแหล่งข้อมูลที่มีความน่าเชื่อถือ เพื่อให้เป็นข้อมูลที่ถูกต้อง แต่บริษัทและผู้บริหาร รวมถึงพนักงานเจ้าหน้าที่ของบริษัทมิอาจรับประกันความถูกต้อง ครบถ้วน หรือความน่าเชื่อถือของข้อมูลดังกล่าวได้ ทั้งนี้ อาจมีสาเหตุมาจาก ข้อมูลนั้นเอง หรืออาจมาจากสาเหตุอื่น ๆ ดังนั้น หากผู้ลงทุนจะใช้ข้อมูลที่ปรากฏอยู่ในเว็บไซต์นี้ เพื่อการดำเนินการอย่างใดอย่างหนึ่งผู้ลงทุนควรใช้ด้วยความรอบคอบ หรือใช้ข้อมูลจากแหล่งอื่นๆ ประกอบการพิจารณาด้วย</li>\n</ul>\n<ul>\n    <li>บริษัทขอสงวนสิทธิ์ในการแก้ไข ปรับปรุง หรือเปลี่ยนแปลงข้อมูลใดๆ ใน&nbsp;website แห่งนี้ โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้าแต่อย่างใด</li>\n</ul>\n<ul>\n    <li>บริษัทและผู้บริหาร รวมถึงพนักงานเจ้าหน้าที่ของบริษัท ขอสงวนสิทธิ์ที่จะไม่รับผิดชอบ ต่อความเสียหายทุกกรณี ที่เกิดขึ้นกับข้อมูล หรือ ระบบสื่อสารของผู้เข้าเยี่ยมชมหรือผู้ลงทุน อันเนื่องมาจากการเข้ามาใช้เว็บไซต์นี้ และหรือ เว็บไซต์ที่ร่วมกิจกรรมกับบริษัท</li>\n</ul>\n<ul>\n    <li>ผู้ลงทุนควรตรวจสอบให้แน่ใจว่า ผู้ขายประกันชีวิตควบการลงทุนเป็นบุคคลที่ได้รับความเห็นชอบจากสำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย และควรขอดูบัตรประจำตัวของบุคคลดังกล่าวที่สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย ออกให้ด้วย</li>\n</ul>\n<ul>\n    <li>การเผยแพร่ข้อมูลต่างๆ บริษัททำขึ้นเพื่อวัตถุประสงค์ในการอำนวยความสะดวกแก่ผู้ลงทุนเท่านั้น บริษัทมิได้รับรองถึงความถูกต้องแท้จริงและความครบถ้วนของข้อมูลไม่ว่าใน กรณีใดๆ ทั้งสิ้น</li>\n</ul>',
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: { value: {} },
                buttonMode: {
                  id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                  fields: {
                    value: { value: "SimpleLink" },
                    key: { value: "SimpleLink" },
                  },
                },
                linkGALabelName: { value: "InvestmentDisclosureAccepted" },
                isCloseCTA: { value: true },
                closeCTALabel: {
                  value: "ใช่ ข้าพเจ้าได้อ่านและเข้าใจเงื่อนไขดังกล่าวข้างต้น",
                },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: {
                  value: "InvestmentDisclosureDenied",
                },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: {
                  value: "ไม่ ข้าพเจ้าไม่ต้องการจะดำเนินการต่อ",
                },
                isSecondaryCloseCTA: { value: true },
                IsFormPost: { value: false },
                FormParameters: { value: {} },
                id: "c375f832-ec0e-4a2b-8836-bbfe6d573640",
              },
              {
                sticky: { value: true },
                activeAtEndOfScroll: { value: true },
                sessionTimeout: { value: "" },
                frequency: {
                  id: "0585858d-6024-4df6-a556-08bc04932510",
                  fieldType: "Droplink",
                  fieldName: "frequency",
                  url: "/sitecore/content/fwd/global/settings/list/disclosure-frequency-type/every-time-user-land-on-identified-page",
                  fields: {
                    value: {
                      value: "Every time user land on the identified page",
                    },
                    key: { value: "every-time-in-session" },
                  },
                },
                isRiskDisclosure: { value: true },
                defaultPageLink: { value: {} },
                enableSmallView: { value: false },
                title: { value: "คำเตือน" },
                footerText: { value: "" },
                text: {
                  value:
                    '<ul>\n    <li>หนังสือชี้ชวนที่ปรากฎอยู่ใน&nbsp;<span style="text-decoration: underline;">fwd.co.th</span>&nbsp;แม้ว่าจะได้รับการอนุมัติให้จัดตั้งและจัดการจากสำนักงานคณะกรรมการ ก.ล.ต.แต่มิได้เป็นการแสดงว่า คณะกรรมการ กลต. และสำนักงานคณะกรรมการ กลต. ได้รับรองถึงความถูกต้องของข้อมูลในหนังสือชี้ชวนและมิได้ประกันราคาหน่วยลงทุนที่เสนอขาย</li>\n</ul>\n<ul>\n    <li>การลงทุนมีความเสี่ยง ผู้เอาประกันภัยอาจได้รับเงินคืนมากกว่าหรือน้อยกว่ามูลค่าเบี้ยประกันภัยที่ถูกจัดสรรเข้ากองทุนรวมโดยหากผลการดำเนินงานของกองทุนรวมมีกำไร ผู้เอาประกันภัยก็จะได้ผลตอบแทนสูง แต่หากผลการดำเนินงานของกองทุนรวมขาดทุน ผู้เอาประกันภัยจะได้ผลตอบแทนต่ำ หรือบางกรณีอาจขาดทุน กล่าวคือ ไม่ได้รับเงินส่วนลงทุนคืนเต็มจำนวน ทั้งนี้กรมธรรม์นี้ไม่มีการรับประกันเงินส่วนลงทุน</li>\n</ul>\n<ul>\n    <li>กรมธรรม์นี้เหมาะสำหรับการออมเงินระยะยาว</li>\n</ul>\n<ul>\n    <li>ผู้เอาประกันภัยควรศึกษารายละเอียดเกี่ยวกับความเสี่ยงจากการลงทุนในกองทุนรวมในหนังสือชี้ชวนของกองทุนรวมด้วย</li>\n</ul>\n<ul>\n    <li>กองทุนรวมเป็นนิติบุคคลแยกต่างหากจากบริษัทประกันชีวิตและบริษัทจัดการ ดังนั้น บริษัทประกันชีวิตและบริษัทจัดการจึงไม่มีภาระผูกพันในการชดเชยผลขาดทุนของกองทุนรวม และจะไม่สามารถนำทรัพย์สินของกองทุนรวมไปใช้ประโยชน์เพื่อการชำระหนี้ของตนเอง</li>\n</ul>\n<ul>\n    <li>การลงทุนในหน่วยลงทุนมิใช่การฝากเงิน ผู้ลงทุนอาจได้รับคืนเงินลงทุนมากกว่าหรือน้อยกว่าเงินลงทุนเริ่มต้นและมีโอกาสไม่ได้รับชำระเงินค่าขายคืนหน่วยลงทุนภายในระยะเวลาที่กำหนด ในกรณีกองทุนเปิด ผู้ลงทุนอาจไม่สามารถขายคืนหน่วยลงทุนได้ตามที่มีคำสั่งไว้&nbsp;</li>\n</ul>\n<ul>\n    <li>การวัดผลการดำเนินงานของกองทุนรวม จัดทำขึ้นตามมาตรฐานการวัดผลการดำเนินงานของสมาคมบริษัทจัดการลงทุน</li>\n</ul>\n<ul>\n    <li>ผลการดำเนินงานของกองทุนรวม ไม่ได้ขึ้นอยู่กับสถานะทางการเงินหรือผลการดำเนินงานของบริษัทจัดการและบริษัทประกันชีวิต</li>\n</ul>\n<ul>\n    <li>ผลการดำเนินงานในอดีตของกองทุนรวม มิได้เป็นสิ่งยืนยันถึงผลการดำเนินงานในอนาคต</li>\n</ul>\n<ul>\n    <li>ผู้สนใจลงทุนควรศึกษาข้อมูลในหนังสือชี้ชวนให้เข้าใจอย่างละเอียดก่อนซื้อหน่วยลงทุน และควรเก็บเป็นข้อมูลไว้ใช้อ้างอิงในอนาคต หากต้องการข้อมูลเพิ่มเติมสามารถขอข้อมูลโครงการและสอบถามรายละเอียดได้ที่บริษัทจัดการหรือตัวแทน</li>\n</ul>\n<ul>\n    <li>กรุณาตอบคำถามตามแบบสอบถามของบริษัทฯ ซึ่งควรให้ข้อมูลที่เป็นความจริง ถูกต้อง เป็นปัจจุบัน และครบถ้วน โดยท่านได้รับหนังสือชี้ชวนจากบริษัทฯ แล้ว ทั้งนี้การให้ข้อมูลของท่าน จะมีผลต่อการให้บริการ หรือการให้คำแนะนำที่ท่านจะได้รับจากตัวแทนประกันชีวิตและบริษัทฯ</li>\n</ul>\n<ul>\n    <li>ข้อมูลที่ปรากฎอยู่ใน เว็บไซต์นี้ บริษัทได้จัดทำและรวบรวมขึ้นด้วยความสุจริต และพยายามจัดทำขึ้น บนพื้นฐานของแหล่งข้อมูลที่มีความน่าเชื่อถือ เพื่อให้เป็นข้อมูลที่ถูกต้อง แต่บริษัทและผู้บริหาร รวมถึงพนักงานเจ้าหน้าที่ของบริษัทมิอาจรับประกันความถูกต้อง ครบถ้วน หรือความน่าเชื่อถือของข้อมูลดังกล่าวได้ ทั้งนี้ อาจมีสาเหตุมาจาก ข้อมูลนั้นเอง หรืออาจมาจากสาเหตุอื่น ๆ ดังนั้น หากผู้ลงทุนจะใช้ข้อมูลที่ปรากฏอยู่ในเว็บไซต์นี้ เพื่อการดำเนินการอย่างใดอย่างหนึ่งผู้ลงทุนควรใช้ด้วยความรอบคอบ หรือใช้ข้อมูลจากแหล่งอื่นๆ ประกอบการพิจารณาด้วย</li>\n</ul>\n<ul>\n    <li>บริษัทขอสงวนสิทธิ์ในการแก้ไข ปรับปรุง หรือเปลี่ยนแปลงข้อมูลใดๆ ใน&nbsp;website แห่งนี้ โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้าแต่อย่างใด</li>\n</ul>\n<ul>\n    <li>บริษัทและผู้บริหาร รวมถึงพนักงานเจ้าหน้าที่ของบริษัท ขอสงวนสิทธิ์ที่จะไม่รับผิดชอบ ต่อความเสียหายทุกกรณี ที่เกิดขึ้นกับข้อมูล หรือ ระบบสื่อสารของผู้เข้าเยี่ยมชมหรือผู้ลงทุน อันเนื่องมาจากการเข้ามาใช้เว็บไซต์นี้ และหรือ เว็บไซต์ที่ร่วมกิจกรรมกับบริษัท</li>\n</ul>\n<ul>\n    <li>ผู้ลงทุนควรตรวจสอบให้แน่ใจว่า ผู้ขายประกันชีวิตควบการลงทุนเป็นบุคคลที่ได้รับความเห็นชอบจากสำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย และควรขอดูบัตรประจำตัวของบุคคลดังกล่าวที่สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย ออกให้ด้วย</li>\n</ul>\n<ul>\n    <li>การเผยแพร่ข้อมูลต่างๆ บริษัททำขึ้นเพื่อวัตถุประสงค์ในการอำนวยความสะดวกแก่ผู้ลงทุนเท่านั้น บริษัทมิได้รับรองถึงความถูกต้องแท้จริงและความครบถ้วนของข้อมูลไม่ว่าใน กรณีใดๆ ทั้งสิ้น</li>\n</ul>',
                },
                buttonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "buttonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                link: { value: {} },
                buttonMode: {
                  id: "02a5a5c7-c318-4919-b773-86a65ba98969",
                  fieldType: "Droplink",
                  fieldName: "buttonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/simple-link",
                  fields: {
                    value: { value: "SimpleLink" },
                    key: { value: "SimpleLink" },
                  },
                },
                linkGALabelName: { value: "InvestmentDisclosureAccepted" },
                isCloseCTA: { value: true },
                closeCTALabel: {
                  value: "ใช่ ข้าพเจ้าได้อ่านและเข้าใจเงื่อนไขดังกล่าวข้างต้น",
                },
                secondaryLinkButtonMode: {
                  id: "b096e18e-daae-43a8-87dd-1775ad1f16b6",
                  fieldType: "Droplink",
                  fieldName: "secondaryLinkButtonMode",
                  url: "/sitecore/content/fwd/global/settings/list/button-mode/secondary",
                  fields: {
                    value: { value: "Secondary" },
                    key: { value: "Secondary" },
                  },
                },
                secondaryLinkGALabelName: {
                  value: "InvestmentDisclosureDenied",
                },
                secondaryLink: { value: {} },
                secondaryLinkButtonIcon: {
                  id: "7ea908fb-506f-45e9-ab04-2b33b5dcde2a",
                  fieldType: "CustomDroplink",
                  fieldName: "secondaryLinkButtonIcon",
                  url: "/sitecore/content/fwd/global/settings/list/linkvariant/link",
                  fields: {
                    value: { value: "arrow-right" },
                    key: { value: "Link" },
                  },
                },
                secondaryCloseCTALabel: {
                  value: "ไม่ ข้าพเจ้าไม่ต้องการจะดำเนินการต่อ",
                },
                isSecondaryCloseCTA: { value: true },
                IsFormPost: { value: false },
                FormParameters: { value: {} },
                id: "441cbf7c-a146-4a9b-b7e1-5dfbc83700c7",
              },
            ],
          },
          localizedPages: [
            { th: "https://www.fwd.co.th/th/formslist/general-enquiry-form" },
            { en: "/en/formslist/general-enquiry-form" },
          ],
          isRequestFromExternalSource: false,
          availableLanguages: ["th", "en"],
        },
        route: {
          name: "general-enquiry-form",
          displayName: "general-enquiry-form",
          fields: {
            apiList: [
              {
                id: "2334a4bf-d431-461f-b313-1dd10100c27e",
                fields: {
                  apiName: { value: "Email" },
                  value: {
                    value: "https://prd-api-www.fwd.com/api/v1/factors/send",
                  },
                  key: {
                    value:
                      "C9VX6X34b56tC2n2b67hlL5N97VoHguVy1mVnH65KgCm0MWVATlgx9Z453Zb0gE0HXpOzo0Z6ery6oRiNN28z34mBk",
                  },
                },
              },
              {
                id: "d58e3660-0ab7-4811-ad6f-d007e52af349",
                fields: {
                  apiName: { value: "SaveLead" },
                  value: {
                    value: "https://prd-api-www.fwd.com/api/v1/lead/save",
                  },
                  key: {
                    value:
                      "C9VX6X34b56tC2n2b67hlL5N97VoHguVy1mVnH65KgCm0MWVATlgx9Z453Zb0gE0HXpOzo0Z6ery6oRiNN28z34mBk",
                  },
                },
              },
            ],
            formEmailTemplate: {
              value: {
                text: "",
                linktype: "form",
                querystring: "",
                target: "",
                id: "{CF05FC76-248F-4CDE-9F23-9C90727C56C3}",
                href: "/formslist/general-enquiry-form/general-enquiry-email-template",
                apiKey: "{D7333054-1DCE-4B0C-A9A5-AC7372A796AB}",
                apiHost: 'https://www.fwd.co.th'
              },
            },
            enableProductName: { value: false },
            gtmEventType: null,
            dynamicFormParams: { value: {} },
          },
          databaseName: "web",
          deviceId: "fe5d7fdf-89c0-4d99-9aa3-b5fbd009c9f3",
          itemId: "90d7a8dc-2ebc-4e16-8d0f-e162c7d01ec5",
          itemLanguage: "th",
          itemVersion: 1,
          layoutId: "e60605a5-f4f9-479a-b992-741bce767b1d",
          templateId: "d48ab251-45a3-498a-a8c1-629e33a6b9b4",
          templateName: "Form",
          placeholders: {
            "jss-metadata": [],
            "jss-header": [],
            "jss-main": [
              {
                uid: "da48a850-ee29-44f2-81cb-334204bfb850",
                componentName: "Forms",
                dataSource: "{FA29DD87-0838-4973-BB98-1CDE45079034}",
                params: { formType: "conversational" },
                fields: {
                  items: [
                    {
                      id: "4e66a871-a961-4986-a6f9-ab23f3b004bd",
                      name: "splashScreen",
                      displayName: "splashScreen",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "b47928d6-98fc-4b29-8d0f-586ab477286e",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/orangewhite",
                          fields: {
                            value: { value: "orange-white" },
                            key: { value: "OrangeWhite" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "splashScreenPage darkMode" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "3F83046E6287400389197ECF35DAA74D",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "d45428a9-ed64-4626-82d9-b205c9bf3742",
                          name: "introText",
                          displayName: "introText",
                          parentId: "4e66a871-a961-4986-a6f9-ab23f3b004bd",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: {
                              value:
                                "ฝากเรื่องให้เจ้าหน้าที่ติดต่อกลับ กรุณากรอกแบบฟอร์มเพื่อช่วยให้เราเข้าใจคำถามของคุณมากยิ่งขึ้น",
                            },
                            "Css Class": { value: "intro" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "F0B323C89D9942BFA7DA017E69B864AB",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "c35591dd-abfb-4656-a1bd-3583ccbaf870",
                          name: "splashScreenClick",
                          displayName: "splashScreenClick",
                          parentId: "4e66a871-a961-4986-a6f9-ab23f3b004bd",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "เริ่ม" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "12A1320BA02240D6A3DAA22D4CD38950",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "b0edd5c5-bba3-4ae6-8afe-ae0caabf2b8f",
                          name: "Text",
                          displayName: "Text",
                          parentId: "4e66a871-a961-4986-a6f9-ab23f3b004bd",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: {
                              value:
                                '</br>\r\n<font name="Noto Sans Thai-Regular", size="4px">หรือคุณสามารถใช้บริการออนไลน์ ทำได้ด้วยตัวเอง สะดวก ง่าย ตลอด 24 ชั่วโมง ตอบสนองทุกความต้องการ  \r\n<a target="_blank" href="https://fwdlink.fwd.co.th/fwd/login?utm_source=nexgen&utm_medium=referral_general_enquiry_form&utm_campaign=20210201-nexgenreferral" style="color:#FFFFFF;">ที่นี่</a></font>',
                            },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "89B5A6C3C7D84BCEAB2F22A622F968AE",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                      ],
                    },
                    {
                      id: "7e949fa3-723f-4c49-8731-c0e8732660f6",
                      name: "taskPage",
                      displayName: "taskPage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "interestedPage" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "04B6B0BE40774539912EB6E4268008B9",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "1fd52fdd-20d1-4d15-8be2-626803acad79",
                          name: "Text",
                          displayName: "Text",
                          parentId: "7e949fa3-723f-4c49-8731-c0e8732660f6",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "ฉันต้องการที่จะ" },
                            "Css Class": { value: "block" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "B5C635B295AC460DB7A7644CD8A4B416",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "65808aac-abe9-4661-9093-49e01302361f",
                          name: "taskOptionsList",
                          displayName: "taskOptionsList",
                          parentId: "7e949fa3-723f-4c49-8731-c0e8732660f6",
                          fields: {
                            Datasource: {
                              id: "128c6cd5-16b8-4325-9a2b-51a9605e29bf",
                              fieldType: "Droptree",
                              fieldName: "Datasource",
                              url: "/content/forms/tasks",
                              fields: {},
                            },
                            "Default Selection": { value: "" },
                            "Display Field Name": { value: "__Display name" },
                            "Is Dynamic": { value: true },
                            "Value Field Name": { value: "value" },
                            "Css Class": { value: "block" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "02e6f52d-421f-4179-b9f6-9cc0863cc4da",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/queryreason",
                              fields: {
                                value: { value: "queryReason" },
                                key: { value: "queryReason" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "edbd38a8-1ae9-42ec-8ccd-f5b0e2998b4f",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/radio-button-list",
                              fields: {
                                BackgroundColor: { value: "Grass" },
                                Icon: {
                                  value:
                                    "OfficeWhite/32x32/radio_button_group.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/list",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomRadioButtonListViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/RadioButtonList",
                                },
                              },
                            },
                            Conditions: {
                              value:
                                '{"fieldConditions":[{"matchTypeId":"{365C94DA-C1CD-4783-A91D-0D17A16C7117}","conditions":[{"fieldId":"93BF0439473B468BBC93BC561328CA9D","operatorId":"{49F47E77-E8C5-46F9-BF39-78D6B0D40B48}","value":"Book time with an agent"}],"actions":[{"fieldId":"70CF13F315E14103A03450E07FEA39C1","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null},{"fieldId":"5FBCE57CD34D482097819B7F8557F2E9","actionTypeId":"{7F58C8DD-D7C0-4FB7-BB44-8EC6B5E1C3D9}","value":null},{"fieldId":"3AD1E5279740470796028C7203617EB0","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null}]},{"matchTypeId":"{365C94DA-C1CD-4783-A91D-0D17A16C7117}","conditions":[{"fieldId":"93BF0439473B468BBC93BC561328CA9D","operatorId":"{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}","value":"Book time with an agent"}],"actions":[{"fieldId":"0B059E90D26E41B2B35BE476FB35A168","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null},{"fieldId":"D9B947C796E4429A9649870470347AE9","actionTypeId":"{7F58C8DD-D7C0-4FB7-BB44-8EC6B5E1C3D9}","value":null},{"fieldId":"5716EB890BFF4A96A4C23F038A9086D8","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null},{"fieldId":"611F3DE333B54D1B8C963ECD22D8EE72","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null},{"fieldId":"33B9AF355D484265A2131F07E4A7978F","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null},{"fieldId":"1115B84BAAE646A59A23F5A3B965CC6E","actionTypeId":"{7F58C8DD-D7C0-4FB7-BB44-8EC6B5E1C3D9}","value":null},{"fieldId":"7881B9CA368C47B8B4418EFCABB92091","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null}]}]}',
                            },
                            "Field Key": {
                              value: "93BF0439473B468BBC93BC561328CA9D",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "d6f96b17-4c1f-49b6-bfd5-954226891e66",
                              name: "makeAnEnquiry",
                              displayName: "สอบถามข้อมูลทั่วไป",
                              parentId: "128c6cd5-16b8-4325-9a2b-51a9605e29bf",
                              fields: {
                                value: { value: "Make a general enquiry" },
                                key: { value: "2" },
                              },
                            },
                            {
                              id: "40bdb3c2-a60a-435c-8e91-9baba3a9239e",
                              name: "giveFeedback",
                              displayName: "ให้ข้อเสนอแนะหรือร้องเรียน",
                              parentId: "128c6cd5-16b8-4325-9a2b-51a9605e29bf",
                              fields: {
                                value: {
                                  value: "Give feedback or a complaint",
                                },
                                key: { value: "3" },
                              },
                            },
                            {
                              id: "5b319d24-db69-4569-a4ca-57cffe36390b",
                              name: "meetAnAgent",
                              displayName: "นัดพบตัวแทน",
                              parentId: "128c6cd5-16b8-4325-9a2b-51a9605e29bf",
                              fields: {
                                value: { value: "Book time with an agent" },
                                key: { value: "1" },
                              },
                            },
                            {
                              id: "f38778e4-d91f-40c0-8659-2d450a621d42",
                              name: "others",
                              displayName: "สอบถามข้อมูลอื่นๆ",
                              parentId: "128c6cd5-16b8-4325-9a2b-51a9605e29bf",
                              fields: {
                                value: { value: "Ask something else" },
                                key: { value: "4" },
                              },
                            },
                          ],
                        },
                        {
                          id: "231e7596-a29b-482d-9a0e-dc669126a14b",
                          name: "tasksNextButtonClick",
                          displayName: "tasksNextButtonClick",
                          parentId: "7e949fa3-723f-4c49-8731-c0e8732660f6",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: {
                              value: "หรือ กดเอ็นเทอร์เพื่อดำเนินการต่อ",
                            },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "0B059E90D26E41B2B35BE476FB35A168",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "f6cc8b39-9ffe-4926-84ec-a447b36049a8",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "231e7596-a29b-482d-9a0e-dc669126a14b",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{7EA12945-75EB-4253-91BC-3E25846B70BF}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                        {
                          id: "3c2db40f-6b84-409d-8c2f-3205560a1fe6",
                          name: "otherOptionNextClick",
                          displayName: "otherOptionNextClick",
                          parentId: "7e949fa3-723f-4c49-8731-c0e8732660f6",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: {
                              value: "หรือ กดเอ็นเทอร์เพื่อดำเนินการต่อ",
                            },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "70CF13F315E14103A03450E07FEA39C1",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "a2a9cb17-472d-4370-a0ce-2ef0e57b662d",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "3c2db40f-6b84-409d-8c2f-3205560a1fe6",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{78AE98E4-6BC8-4901-82D5-F04F015CF3BA}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "7ea12945-75eb-4253-91bc-3e25846b70bf",
                      name: "subTaskPage",
                      displayName: "subTaskPage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "subTaskPage conditionPage" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "83F59508E70E42938C9C8BC6626295FC",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "53ffa759-2c2c-4463-b500-bc1af6b8bc4c",
                          name: "Text",
                          displayName: "Text",
                          parentId: "7ea12945-75eb-4253-91bc-3e25846b70bf",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "ต้องการสอบถามเกี่ยวกับ" },
                            "Css Class": { value: "block" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "9572D218437248E980F66B54BF9FAEA5",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "0229d7e4-aa2d-4ebc-b7ca-9e7b72ce6b6b",
                          name: "subTasksOptionsList",
                          displayName: "subTasksOptionsList",
                          parentId: "7ea12945-75eb-4253-91bc-3e25846b70bf",
                          fields: {
                            Datasource: {
                              id: "b729f9d7-9ea4-4f75-b5e3-1273ef9fabae",
                              fieldType: "Droptree",
                              fieldName: "Datasource",
                              url: "/content/forms/insurancetypes",
                              fields: {},
                            },
                            "Default Selection": { value: "" },
                            "Display Field Name": { value: "__Display name" },
                            "Is Dynamic": { value: true },
                            "Value Field Name": { value: "value" },
                            "Css Class": { value: "block" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "f2b244d0-fa3e-4b3e-ad38-ed69bbbbcd89",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/expectedinsurancetype",
                              fields: {
                                value: { value: "expectedInsuranceType" },
                                key: { value: "expectedInsuranceType" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "edbd38a8-1ae9-42ec-8ccd-f5b0e2998b4f",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/radio-button-list",
                              fields: {
                                BackgroundColor: { value: "Grass" },
                                Icon: {
                                  value:
                                    "OfficeWhite/32x32/radio_button_group.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/list",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomRadioButtonListViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/RadioButtonList",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "D63E2549B3914223B72033F1F1A3EA30",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "4cad71bf-fb77-4072-844f-079ae25e50d6",
                              name: "lifeInsurance",
                              displayName: "ประกันชีวิต",
                              parentId: "b729f9d7-9ea4-4f75-b5e3-1273ef9fabae",
                              fields: {
                                value: { value: "ประกันชีวิต" },
                                key: { value: "1" },
                              },
                            },
                            {
                              id: "33306e81-6a70-459a-8379-6f6060fe2f50",
                              name: "healthInsurance",
                              displayName: "ประกันสุขภาพ",
                              parentId: "b729f9d7-9ea4-4f75-b5e3-1273ef9fabae",
                              fields: {
                                value: { value: "ประกันสุขภาพ" },
                                key: { value: "2" },
                              },
                            },
                            {
                              id: "082116c3-2ed1-4266-b4de-6da085584d7e",
                              name: "criticalIllness",
                              displayName: "ประกันโรคร้าย",
                              parentId: "b729f9d7-9ea4-4f75-b5e3-1273ef9fabae",
                              fields: {
                                value: { value: "ประกันโรคร้าย" },
                                key: { value: "3" },
                              },
                            },
                            {
                              id: "1c46a1df-2e30-4898-b1f0-48a9daa3cc01",
                              name: "personalAccident",
                              displayName: "ประกันอุบัติเหตุ",
                              parentId: "b729f9d7-9ea4-4f75-b5e3-1273ef9fabae",
                              fields: {
                                value: { value: "ประกันอุบัติเหตุ" },
                                key: { value: "4" },
                              },
                            },
                            {
                              id: "962342c9-badc-498c-8955-f4e25871918f",
                              name: "investment",
                              displayName: "ประกันเพื่อการลงทุน",
                              parentId: "b729f9d7-9ea4-4f75-b5e3-1273ef9fabae",
                              fields: {
                                value: { value: "ประกันเพื่อการลงทุน" },
                                key: { value: "5" },
                              },
                            },
                            {
                              id: "c2f8648f-6995-4247-aae6-8a14550700c5",
                              name: "saving",
                              displayName: "ประกันเพื่อการสะสมทรัพย์",
                              parentId: "b729f9d7-9ea4-4f75-b5e3-1273ef9fabae",
                              fields: {
                                value: { value: "ประกันเพื่อการสะสมทรัพย์" },
                                key: { value: "6" },
                              },
                            },
                            {
                              id: "07084f17-feb1-4c14-a4e2-ef5609512c3a",
                              name: "Pension",
                              displayName: "ประกันบำนาญ",
                              parentId: "b729f9d7-9ea4-4f75-b5e3-1273ef9fabae",
                              fields: {
                                value: { value: "ประกันบำนาญ" },
                                key: { value: "7" },
                              },
                            },
                          ],
                        },
                        {
                          id: "00ebe254-39b5-48b3-a248-1cb315e6ebd9",
                          name: "subTaskButtonNextClick",
                          displayName: "subTaskButtonNextClick",
                          parentId: "7ea12945-75eb-4253-91bc-3e25846b70bf",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "63FEB8F928EA4CAFB690CB395F0667A5",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "e2a7acbe-5130-4c9e-880c-7c327ef0c15f",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "00ebe254-39b5-48b3-a248-1cb315e6ebd9",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{78AE98E4-6BC8-4901-82D5-F04F015CF3BA}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "78ae98e4-6bc8-4901-82d5-f04f015cf3ba",
                      name: "namePage",
                      displayName: "namePage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "namePage" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "F2B07BE6685F41968F59E8E76ABBC8AD",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "546e6964-a710-47e3-b6dc-9a15a80ab67c",
                          name: "Text",
                          displayName: "Text",
                          parentId: "78ae98e4-6bc8-4901-82d5-f04f015cf3ba",
                          fields: {
                            "Html Tag": { value: "h3" },
                            Text: { value: "ข้าพเจ้า" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "04919D66DA774E6D896DB65E36D0E8D8",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "3325c7c8-b6be-42d2-b617-fce2c6e3542f",
                          name: "first-name",
                          displayName: "first-name",
                          parentId: "78ae98e4-6bc8-4901-82d5-f04f015cf3ba",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "0" },
                            "Min Length": { value: "0" },
                            "Placeholder Text": { value: "ชื่อจริง" },
                            dialInCodeLength: null,
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "f20d5651-f7b9-49a8-9e57-0a3c7e0b5cb8",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/firstname",
                              fields: {
                                value: { value: "firstName" },
                                key: { value: "firstName" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "57CE7E7216534F4F9033E231AD69AFE0",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "c3f86958-511a-4e4d-bb57-a1cc83201a3c",
                          name: "last-name",
                          displayName: "last-name",
                          parentId: "78ae98e4-6bc8-4901-82d5-f04f015cf3ba",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "0" },
                            "Min Length": { value: "0" },
                            "Placeholder Text": { value: "นามสกุล" },
                            dialInCodeLength: null,
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "ceb2b470-c127-4eda-b777-0d5943f0c90a",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/lastname",
                              fields: {
                                value: { value: "lastName" },
                                key: { value: "lastName" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "EF0F512D39CE4F759715B4680BF02EF5",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "6041224a-4693-4742-8e77-1c5461755e4d",
                          name: "nameButtonNextClick",
                          displayName: "nameButtonNextClick",
                          parentId: "78ae98e4-6bc8-4901-82d5-f04f015cf3ba",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "5FBCE57CD34D482097819B7F8557F2E9",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "c3c7074c-e251-486b-9d50-d5c4db74120b",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "6041224a-4693-4742-8e77-1c5461755e4d",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{FA8D63FD-89D3-4E4D-9400-738A8C0B5130}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                        {
                          id: "968b204a-91fc-4082-a2da-6de8347a0af7",
                          name: "emailNextClickScreen",
                          displayName: "emailNextClickScreen",
                          parentId: "78ae98e4-6bc8-4901-82d5-f04f015cf3ba",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "D9B947C796E4429A9649870470347AE9",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "14a01723-e4ee-48e6-a7e7-62eb41d88b66",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "968b204a-91fc-4082-a2da-6de8347a0af7",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{54F70D30-3792-4B58-9679-126D22933378}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "fa8d63fd-89d3-4e4d-9400-738a8c0b5130",
                      name: "dobPage",
                      displayName: "dobPage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "dobPage conditionPage" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "9FD54BB460BB45E98070FFA70F90B125",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "db06ecce-51fc-47cd-ab6f-868a83528db8",
                          name: "Text",
                          displayName: "Text",
                          parentId: "fa8d63fd-89d3-4e4d-9400-738a8c0b5130",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "วันเกิด" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "7608E2AEADD747F3A7C5E3153071806F",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "947236ce-a0e6-4b76-bf22-327769947dbc",
                          name: "Dob",
                          displayName: "Dob",
                          parentId: "fa8d63fd-89d3-4e4d-9400-738a8c0b5130",
                          fields: {
                            label: { value: "วันเกิด" },
                            minimumYear: { value: "1999" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "อายุไม่ถูกต้อง" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "0bd382ca-9d5e-40ad-86d0-6e97e39d7e77",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/dob",
                              fields: {
                                value: { value: "dob" },
                                key: { value: "dob" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "1cc9222f-8f9b-4063-98a1-7c9794c3287e",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/dob",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "5722975d-f7b2-4014-beb3-7440e4ee1088",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/dob",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomDobViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Dob" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "5B62A414FEA74EC1B5728CE04A20B3BB",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "3fe198e3-2bdd-49f9-a8ed-0eaf0275d06f",
                          name: "ToolTip",
                          displayName: "ToolTip",
                          parentId: "fa8d63fd-89d3-4e4d-9400-738a8c0b5130",
                          fields: {
                            toolTipText: {
                              value:
                                "The information you provide will help us know you better.",
                            },
                            label: { value: "ทำไมเราจึงถามคำถามนี้?" },
                            "Css Class": { value: "tool-tip" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Is Tracking Enabled": { value: true },
                            "Field Type": {
                              id: "fff6a7f6-db43-49f4-80aa-519af8ede3c5",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/tooltip",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: { value: "Office/32x32/question.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "1edd4140-c0f7-4b64-aaf6-dd99abd590de",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/tooltip",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomToolTipViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/ToolTip",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "3B3C363E5739467C829F10B16A483A65",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "30bdcc42-653e-4ca5-857b-83e64b678572",
                          name: "dobNextButtonClick",
                          displayName: "dobNextButtonClick",
                          parentId: "fa8d63fd-89d3-4e4d-9400-738a8c0b5130",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: {
                              value: "หรือ กดเอ็นเทอร์เพื่อดำเนินการต่อ",
                            },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "A6B908F18ECA47BCBE78E84562A87543",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "9c2400ca-cf84-461b-88c2-4ccbeb18d784",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "30bdcc42-653e-4ca5-857b-83e64b678572",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{534D1058-28F9-4FAF-9B91-489E34099A58}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "534d1058-28f9-4faf-9b91-489e34099a58",
                      name: "provincePage",
                      displayName: "provincePage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "provincePage conditionPage" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "14B3FDC651A24EA499E5A9F483DE51EF",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "e60abfe6-0da6-47f1-a0b7-590b5558a304",
                          name: "Text",
                          displayName: "Text",
                          parentId: "534d1058-28f9-4faf-9b91-489e34099a58",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "ฉันอาศัยที่" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "5A7F483B3ECA40548921DD8C5237490C",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "21ed6a1d-b4c2-4ace-b3a0-48a4cab4b06b",
                          name: "provinceDropdown",
                          displayName: "provinceDropdown",
                          parentId: "534d1058-28f9-4faf-9b91-489e34099a58",
                          fields: {
                            "Show Empty Item": { value: true },
                            isAutoSuggest: { value: false },
                            node: { value: "" },
                            isDynamicDropdown: { value: false },
                            Datasource: {
                              id: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fieldType: "Droptree",
                              fieldName: "Datasource",
                              url: "/content/forms/provinces",
                              fields: {},
                            },
                            "Default Selection": { value: "" },
                            "Display Field Name": { value: "value" },
                            "Is Dynamic": { value: true },
                            "Value Field Name": { value: "key" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "1dd4c5da-24f2-4331-bf8e-46a49d5060a7",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/homeprovince",
                              fields: {
                                value: { value: "homeProvince" },
                                key: { value: "homeProvince" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Collapsed by Default": { value: false },
                            "Field Type": {
                              id: "e0cfadee-1ac0-471d-a820-2e70d1547b4b",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/dropdown-list",
                              fields: {
                                BackgroundColor: { value: "Grass" },
                                Icon: {
                                  value: "OfficeWhite/32x32/drop_down_list.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "9121d435-48b8-4649-9d13-03d680474fad",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/dropdownlist",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomDropDownListViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/DropdownList",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "2784E36D133E42A19BACECDB7693C0A9",
                            },
                          },
                          items: [
                            {
                              id: "a314a308-dfc2-497a-b982-37c3c4bec631",
                              name: "bangkoktest",
                              displayName: "กรุงเทพ",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "กรุงเทพ" },
                                key: { value: "1" },
                              },
                            },
                            {
                              id: "4e85da38-414b-4882-9b9a-4c4b940a8220",
                              name: "buengKan",
                              displayName: "บึงกาฬ",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "บึงกาฬ" },
                                key: { value: "77" },
                              },
                            },
                            {
                              id: "6b80bb15-68a3-4df6-ae40-7c0542fbaf3c",
                              name: "chachoengsao",
                              displayName: "ฉะเชิงเทรา",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ฉะเชิงเทรา" },
                                key: { value: "8" },
                              },
                            },
                            {
                              id: "0d6bed35-2d82-43e9-b5e9-bb8afd185bae",
                              name: "chaiNat",
                              displayName: "ชัยนาท",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ชัยนาท" },
                                key: { value: "10" },
                              },
                            },
                            {
                              id: "50309d80-8048-4cb4-b70b-4f96a901a003",
                              name: "chaiyaphum",
                              displayName: "ชัยภูมิ",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ชัยภูมิ" },
                                key: { value: "11" },
                              },
                            },
                            {
                              id: "2b530c5c-9b4c-44a0-848c-e0f17ac3b451",
                              name: "chanthaburi",
                              displayName: "จันทบุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "จันทบุรี" },
                                key: { value: "7" },
                              },
                            },
                            {
                              id: "d92e8719-5b27-466e-89ed-904b69199fb7",
                              name: "Krabi",
                              displayName: "กระบี่",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "กระบี่" },
                                key: { value: "2" },
                              },
                            },
                            {
                              id: "9b00f6e1-795b-48e8-9c52-47f3322dba34",
                              name: "kalasin",
                              displayName: "กาฬสินธุ์",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "กาฬสินธุ์" },
                                key: { value: "4" },
                              },
                            },
                            {
                              id: "cb062875-80a7-485a-a331-ed1181c78d24",
                              name: "Kanchanaburi",
                              displayName: "กาญจนบุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "กาญจนบุรี" },
                                key: { value: "3" },
                              },
                            },
                            {
                              id: "3ce6ac0a-4e15-41df-bf3e-cd7abaab4943",
                              name: "kamphaengPhet",
                              displayName: "กำแพงเพชร",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "กำแพงเพชร" },
                                key: { value: "5" },
                              },
                            },
                            {
                              id: "1c2b1245-ea30-4785-bfe5-9b47e0dc7381",
                              name: "khonKaen",
                              displayName: "ขอนแก่น",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ขอนแก่น" },
                                key: { value: "6" },
                              },
                            },
                            {
                              id: "68e16514-cb7d-4f8b-b08c-0d069b383271",
                              name: "chonBuri",
                              displayName: "ชลบุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ชลบุรี" },
                                key: { value: "9" },
                              },
                            },
                            {
                              id: "10a6740c-075c-4068-8a0b-5b43fdf6b868",
                              name: "chumphon",
                              displayName: "ชุมพร",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ชุมพร" },
                                key: { value: "12" },
                              },
                            },
                            {
                              id: "cfe97ce5-33bc-4d4d-88a2-3441707525cb",
                              name: "chiangRai",
                              displayName: "เชียงราย",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "เชียงราย" },
                                key: { value: "13" },
                              },
                            },
                            {
                              id: "73bcbdfb-52dc-400d-b2a7-d79628b82f8c",
                              name: "chiangMai",
                              displayName: "เชียงใหม่",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "เชียงใหม่" },
                                key: { value: "14" },
                              },
                            },
                            {
                              id: "4aa30dae-db3c-455e-8d44-7fc8d0ac1bc6",
                              name: "trat",
                              displayName: "ตราด",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ตราด" },
                                key: { value: "15" },
                              },
                            },
                            {
                              id: "7022ba8a-cabe-409b-b4c1-0216d68dc087",
                              name: "Trang",
                              displayName: "ตรัง",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ตรัง" },
                                key: { value: "16" },
                              },
                            },
                            {
                              id: "619c62df-1a5a-450a-96dd-5f12e33bab6c",
                              name: "Tak",
                              displayName: "ตาก",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ตาก" },
                                key: { value: "17" },
                              },
                            },
                            {
                              id: "023070c9-924a-4b68-a404-0aae77dbf3e1",
                              name: "nakhonNayok",
                              displayName: "นครนายก",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "นครนายก" },
                                key: { value: "18" },
                              },
                            },
                            {
                              id: "02cd1cd7-9c31-40b7-a75b-d833ea6ad376",
                              name: "nakhonPathom",
                              displayName: "นครปฐม",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "นครปฐม" },
                                key: { value: "19" },
                              },
                            },
                            {
                              id: "7d245e0d-682b-4fac-b40d-7545e10f03df",
                              name: "nakhonPhanom",
                              displayName: "นครพนม",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "นครพนม" },
                                key: { value: "20" },
                              },
                            },
                            {
                              id: "b19fb999-c4f0-45c3-865d-8157d10e5945",
                              name: "nakhonRatchasima",
                              displayName: "นครราชสีมา",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "นครราชสีมา" },
                                key: { value: "21" },
                              },
                            },
                            {
                              id: "7644b41d-5502-43cd-85ab-8b011b575291",
                              name: "nakhonSiThammarat",
                              displayName: "นครศรีธรรมราช",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "นครศรีธรรมราช" },
                                key: { value: "22" },
                              },
                            },
                            {
                              id: "5a808f11-af3b-479d-b141-8912af31fd2a",
                              name: "nakhonSawan",
                              displayName: "นครสวรรค์ ",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "นครสวรรค์ " },
                                key: { value: "23" },
                              },
                            },
                            {
                              id: "d43ec20a-26d9-4014-a1cc-8e045d9af7cf",
                              name: "nonthaburi",
                              displayName: "นนทบุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "นนทบุรี" },
                                key: { value: "24" },
                              },
                            },
                            {
                              id: "adcc0a93-e12b-486e-8629-8e0aa36dbcf6",
                              name: "narathiwat",
                              displayName: "นราธิวาส",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "นราธิวาส" },
                                key: { value: "25" },
                              },
                            },
                            {
                              id: "01bff920-1b8e-4a5c-b31d-99b2e5e9baa3",
                              name: "nan",
                              displayName: "น่าน",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "น่าน" },
                                key: { value: "26" },
                              },
                            },
                            {
                              id: "625d943f-b189-4b9e-9ae7-fc614b56f929",
                              name: "buriRam",
                              displayName: "บุรีรัมย์",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "บุรีรัมย์" },
                                key: { value: "27" },
                              },
                            },
                            {
                              id: "cc38c594-ab11-4575-b26e-88b847dcab88",
                              name: "pathumThani",
                              displayName: "ปทุมธานี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ปทุมธานี" },
                                key: { value: "28" },
                              },
                            },
                            {
                              id: "cc74e073-8e6c-4a71-a3f9-158ffdccda0a",
                              name: "prachuapKhiriKhan",
                              displayName: "ประจวบคีรีขันธ์",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ประจวบคีรีขันธ์" },
                                key: { value: "29" },
                              },
                            },
                            {
                              id: "60adef49-18b2-43fe-9f4e-0f333d736939",
                              name: "prachinBuri",
                              displayName: "ปราจีนบุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ปราจีนบุรี" },
                                key: { value: "30" },
                              },
                            },
                            {
                              id: "a7310696-43a8-45f9-803e-aba7d86195b6",
                              name: "pattani",
                              displayName: "ปัตตานี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ปัตตานี" },
                                key: { value: "31" },
                              },
                            },
                            {
                              id: "4178ff6d-2560-40be-b5b9-101220aabf16",
                              name: "phraNakhonSiAyutthaya",
                              displayName: "พระนครศรีอยุธยา",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "พระนครศรีอยุธยา" },
                                key: { value: "32" },
                              },
                            },
                            {
                              id: "beca8314-d390-47b6-9e82-4ffd38057a7f",
                              name: "phayao",
                              displayName: "พะเยา",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "พะเยา" },
                                key: { value: "33" },
                              },
                            },
                            {
                              id: "a527b8aa-0ccd-4fd4-a995-fa7a8e59101f",
                              name: "phichit",
                              displayName: "พิจิตร",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "พิจิตร" },
                                key: { value: "34" },
                              },
                            },
                            {
                              id: "4cc487cb-23fa-4831-a4c5-b18d2f758456",
                              name: "Phitsanulok",
                              displayName: "พิษณุโลก",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "พิษณุโลก" },
                                key: { value: "35" },
                              },
                            },
                            {
                              id: "94d52e0d-41da-4b10-8640-c46aa64784f5",
                              name: "Phetchabun",
                              displayName: "เพชรบูรณ์",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "เพชรบูรณ์" },
                                key: { value: "36" },
                              },
                            },
                            {
                              id: "900625df-80fe-4cba-ad55-a9b0f8049cbb",
                              name: "Phetchaburi",
                              displayName: "เพชรบุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "เพชรบุรี" },
                                key: { value: "37" },
                              },
                            },
                            {
                              id: "f0728d0e-e7e0-4ea8-93bc-7e1994595c68",
                              name: "Phrae",
                              displayName: "แพร่",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "แพร่" },
                                key: { value: "38" },
                              },
                            },
                            {
                              id: "841248af-ff4b-4c48-acd6-7569d4be1329",
                              name: "Phangnga",
                              displayName: "พังงา",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "พังงา" },
                                key: { value: "39" },
                              },
                            },
                            {
                              id: "37761dae-f5f6-4093-859a-9f7e17811bc7",
                              name: "Phatthalung",
                              displayName: "พัทลุง",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "พัทลุง" },
                                key: { value: "40" },
                              },
                            },
                            {
                              id: "63dea0d0-fa6f-4c9d-8610-1971f82dad24",
                              name: "Phuket",
                              displayName: "ภูเก็ต",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ภูเก็ต" },
                                key: { value: "41" },
                              },
                            },
                            {
                              id: "91550320-1c82-4639-8f89-0544b80ba538",
                              name: "Mukdahan",
                              displayName: "มุกดาหาร",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "มุกดาหาร" },
                                key: { value: "42" },
                              },
                            },
                            {
                              id: "50628ebd-242e-4ae7-b3d1-dd588ab89fbd",
                              name: "mahaSarakham",
                              displayName: "มหาสารคาม",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "มหาสารคาม" },
                                key: { value: "43" },
                              },
                            },
                            {
                              id: "f7ec3de8-50bb-47ed-879b-1ad525c4f7d8",
                              name: "maeHongSon",
                              displayName: "แม่ฮ่องสอน",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "แม่ฮ่องสอน" },
                                key: { value: "44" },
                              },
                            },
                            {
                              id: "81f29269-da0f-4112-87a3-47e699c2105e",
                              name: "Yala",
                              displayName: "ยะลา",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ยะลา" },
                                key: { value: "45" },
                              },
                            },
                            {
                              id: "564b739f-e784-4549-9d26-afdf96465f36",
                              name: "Yasothon",
                              displayName: "ยโสธร",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ยโสธร" },
                                key: { value: "46" },
                              },
                            },
                            {
                              id: "a93b95d3-ed93-4356-bf25-93accdde3d1a",
                              name: "roiEt",
                              displayName: "ร้อยเอ็ด",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ร้อยเอ็ด" },
                                key: { value: "47" },
                              },
                            },
                            {
                              id: "167f3c74-df9f-4d13-a4d4-cde840955032",
                              name: "Ranong",
                              displayName: "ระนอง",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ระนอง" },
                                key: { value: "48" },
                              },
                            },
                            {
                              id: "1081a318-4ae8-4c47-89be-0d9581a19e33",
                              name: "Rayong",
                              displayName: "ระยอง",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ระยอง" },
                                key: { value: "49" },
                              },
                            },
                            {
                              id: "a093dca5-96c8-44ff-9116-a6095ce65c03",
                              name: "Ratchaburi",
                              displayName: "ราชบุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ราชบุรี" },
                                key: { value: "50" },
                              },
                            },
                            {
                              id: "53756522-6041-490e-91c2-f438df423881",
                              name: "Lopburi",
                              displayName: "ลพบุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ลพบุรี" },
                                key: { value: "51" },
                              },
                            },
                            {
                              id: "a082bb6e-fca8-4603-b486-89089726bce1",
                              name: "Lampang",
                              displayName: "ลำปาง",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ลำปาง" },
                                key: { value: "52" },
                              },
                            },
                            {
                              id: "465631aa-ca4c-488f-b173-90df385d6054",
                              name: "Lamphun",
                              displayName: "ลำพูน",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ลำพูน" },
                                key: { value: "53" },
                              },
                            },
                            {
                              id: "0e0a065c-2c98-4a84-be83-d98b7aaef989",
                              name: "Loei",
                              displayName: "เลย",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "เลย" },
                                key: { value: "54" },
                              },
                            },
                            {
                              id: "1379db8b-2da7-40f2-aa94-3494634adf16",
                              name: "siSaKet",
                              displayName: "ศรีสะเกษ",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "ศรีสะเกษ" },
                                key: { value: "55" },
                              },
                            },
                            {
                              id: "c877009c-0a25-46e7-adc9-ff80f39e1693",
                              name: "sakonNakhon",
                              displayName: "สกลนคร",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สกลนคร" },
                                key: { value: "56" },
                              },
                            },
                            {
                              id: "7df30c98-f130-4925-96c4-cbf25e1a9812",
                              name: "Songkhla",
                              displayName: "สงขลา",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สงขลา" },
                                key: { value: "57" },
                              },
                            },
                            {
                              id: "186ee89d-b5c0-4204-9120-a82e3aa1186c",
                              name: "Satun",
                              displayName: "สตูล",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สตูล" },
                                key: { value: "58" },
                              },
                            },
                            {
                              id: "b51f3b12-fa16-49c9-9d58-cc72244f85ed",
                              name: "samutSakhon",
                              displayName: "สมุทรสาคร",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สมุทรสาคร" },
                                key: { value: "59" },
                              },
                            },
                            {
                              id: "b9290a32-83ea-4d16-a262-908328117313",
                              name: "samutPrakan",
                              displayName: "สมุทรปราการ",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สมุทรปราการ" },
                                key: { value: "60" },
                              },
                            },
                            {
                              id: "267cbc9a-4ff3-4c72-89a1-2f05839de6ec",
                              name: "samutSongkhram",
                              displayName: "สมุทรสงคราม",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สมุทรสงคราม" },
                                key: { value: "61" },
                              },
                            },
                            {
                              id: "cd08bc91-f44d-4b07-bd72-a75b3b5eda93",
                              name: "saKaeo",
                              displayName: "สระแก้ว",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สระแก้ว" },
                                key: { value: "62" },
                              },
                            },
                            {
                              id: "bd42e1be-f296-442e-bcc6-187537fef806",
                              name: "Saraburi",
                              displayName: "สระบุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สระบุรี" },
                                key: { value: "63" },
                              },
                            },
                            {
                              id: "5fd841a9-9d82-4afa-b9f8-ed3f47266ee5",
                              name: "singBuri",
                              displayName: "สิงห์บุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สิงห์บุรี" },
                                key: { value: "64" },
                              },
                            },
                            {
                              id: "4beb644e-2bba-4723-aa76-59ce25a6096f",
                              name: "Sukhothai",
                              displayName: "สุโขทัย",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สุโขทัย" },
                                key: { value: "65" },
                              },
                            },
                            {
                              id: "9ac9db41-3342-463f-a16b-2e71b8c408f0",
                              name: "suphanBuri",
                              displayName: "สุพรรณบุรี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สุพรรณบุรี" },
                                key: { value: "66" },
                              },
                            },
                            {
                              id: "681f3432-d97d-4b06-8fe6-1fefe7f54981",
                              name: "suratThani",
                              displayName: "สุราษฎร์ธานี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สุราษฎร์ธานี" },
                                key: { value: "67" },
                              },
                            },
                            {
                              id: "523aa46b-5942-41d0-88df-c56f62154b72",
                              name: "Surin",
                              displayName: "สุรินทร์",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "สุรินทร์" },
                                key: { value: "68" },
                              },
                            },
                            {
                              id: "4f3f956d-d42b-48fe-b80c-c62d7cb50d5c",
                              name: "nongKhai",
                              displayName: "หนองคาย",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "หนองคาย" },
                                key: { value: "69" },
                              },
                            },
                            {
                              id: "eb9dd4de-bbfb-462a-b6a4-1d019c9eb950",
                              name: "nongBuaLamPhu",
                              displayName: "หนองบัวลำภู",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "หนองบัวลำภู" },
                                key: { value: "70" },
                              },
                            },
                            {
                              id: "b839e02f-66bf-46d7-ad22-0d6ea8e70b29",
                              name: "angThong",
                              displayName: "อ่างทอง",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "อ่างทอง" },
                                key: { value: "71" },
                              },
                            },
                            {
                              id: "b513b45b-84b0-4da5-8c2a-b6f47d9cf99a",
                              name: "ubonRatchathani",
                              displayName: "อุบลราชธานี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "อุบลราชธานี" },
                                key: { value: "72" },
                              },
                            },
                            {
                              id: "e6f06344-49fb-4e1a-8d5f-1b62c61e3652",
                              name: "uthaiThani",
                              displayName: "อุทัยธานี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "อุทัยธานี" },
                                key: { value: "73" },
                              },
                            },
                            {
                              id: "569f34ac-c78a-483a-9dcb-3e08b7cf4c35",
                              name: "udonThani",
                              displayName: "อุดรธานี",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "อุดรธานี" },
                                key: { value: "74" },
                              },
                            },
                            {
                              id: "ca5c4d72-875f-45f7-be6d-165ed76cbd14",
                              name: "uttaradit",
                              displayName: "อุตรดิตถ์",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "อุตรดิตถ์" },
                                key: { value: "75" },
                              },
                            },
                            {
                              id: "e36ad611-b0fd-4ed8-b0e2-837267372a63",
                              name: "amnatCharoen",
                              displayName: "อำนาจเจริญ",
                              parentId: "7b881c37-5a06-49c3-a62d-a5ed9263b176",
                              fields: {
                                value: { value: "อำนาจเจริญ" },
                                key: { value: "76" },
                              },
                            },
                          ],
                        },
                        {
                          id: "2d8ffbfc-cdc2-4c8c-97d5-8e463671591a",
                          name: "ToolTip",
                          displayName: "ToolTip",
                          parentId: "534d1058-28f9-4faf-9b91-489e34099a58",
                          fields: {
                            toolTipText: {
                              value: "เราจะค้นหาตัวแทนที่อยู่ในจังหวัดของคุณ",
                            },
                            label: { value: "ทำไมเราจึงถามคำถามนี้?" },
                            "Css Class": { value: "tool-tip" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Is Tracking Enabled": { value: true },
                            "Field Type": {
                              id: "fff6a7f6-db43-49f4-80aa-519af8ede3c5",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/tooltip",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: { value: "Office/32x32/question.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "1edd4140-c0f7-4b64-aaf6-dd99abd590de",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/tooltip",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomToolTipViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/ToolTip",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "9848245B74E1436CAFECD9C427FE4996",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "8062e841-3b31-4bba-8ebd-efa6919f6e60",
                          name: "provinceNextClick",
                          displayName: "provinceNextClick",
                          parentId: "534d1058-28f9-4faf-9b91-489e34099a58",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "A556F548C0994307BFCB7D93CAE4328A",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "02f60812-644d-4acc-83d4-ae16b5707718",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "8062e841-3b31-4bba-8ebd-efa6919f6e60",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{54F70D30-3792-4B58-9679-126D22933378}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "54f70d30-3792-4b58-9679-126d22933378",
                      name: "emailPage",
                      displayName: "emailPage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "emailPage" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "9D55C171FC094F128842ACE2B3DDA4A9",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "df3fbd65-a9b7-470a-a497-6a6434c70d38",
                          name: "Text",
                          displayName: "Text",
                          parentId: "54f70d30-3792-4b58-9679-126d22933378",
                          fields: {
                            "Html Tag": { value: "h5" },
                            Text: { value: "อีเมล" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "97A7E3EA18774D5EBD50D8D73064CD99",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "0e067322-4b1f-46a1-b109-f3c7c51111ed",
                          name: "Email",
                          displayName: "Email",
                          parentId: "54f70d30-3792-4b58-9679-126d22933378",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "0" },
                            "Placeholder Text": { value: "abc@domain.com" },
                            dialInCodeLength: null,
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "fa36b97a-b013-41b6-b33a-b8c3e2843137",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/email",
                              fields: {
                                value: { value: "email" },
                                key: { value: "email" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "9bae3e9a-d89f-4f93-9577-68b5e9d44a38",
                                fields: {
                                  Message: { value: "โปรดกรอกอีเมลที่ถูกต้อง" },
                                  Parameters: {
                                    value:
                                      "/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]/",
                                  },
                                  Type: {
                                    value:
                                      "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "04c39cac-8976-4910-be0d-879ed3368429",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/email",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: { value: "OfficeWhite/32x32/mail.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "886adec1-abf8-40e1-9926-d9189c4e8e1b",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/email",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "9bae3e9a-d89f-4f93-9577-68b5e9d44a38",
                                    fields: {
                                      Message: {
                                        value: "โปรดกรอกอีเมลที่ถูกต้อง",
                                      },
                                      Parameters: {
                                        value:
                                          "/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]/",
                                      },
                                      Type: {
                                        value:
                                          "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                      },
                                    },
                                  },
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    " FWD.Foundation.Forms.CustomSingleLineViewModel, FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Email" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "CF485B1F33E5435281D931A3DD5B328B",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "af359db8-be02-4ecd-b6f0-418b9b6ceb29",
                          name: "emailNextClick",
                          displayName: "emailNextClick",
                          parentId: "54f70d30-3792-4b58-9679-126d22933378",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "3AD1E5279740470796028C7203617EB0",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "2b54cdf6-74e8-4de2-89ce-cf331a2180eb",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "af359db8-be02-4ecd-b6f0-418b9b6ceb29",
                              fields: {
                                Description: { value: "Phone Number" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{3FF7F1D2-9871-47AC-8E7F-CF93520837A4}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                        {
                          id: "5bcf1f94-95e2-440c-9656-d222afa27870",
                          name: "phoneForMobileNextClick",
                          displayName: "phoneForMobileNextClick",
                          parentId: "54f70d30-3792-4b58-9679-126d22933378",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "5716EB890BFF4A96A4C23F038A9086D8",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "4d0dc52e-46a1-40c8-9e83-4f0472a9dad9",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "5bcf1f94-95e2-440c-9656-d222afa27870",
                              fields: {
                                Description: {
                                  value: "Phone Number For Mobile",
                                },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{F2FEE2CD-2C03-4B04-A71B-26E747A338DE}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "3ff7f1d2-9871-47ac-8e7f-cf93520837a4",
                      name: "phonePage",
                      displayName: "phonePage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "phonePage conditionPage" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "A822D936CE184893B07F20E4B97E9B22",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "17f82185-9c2e-4a42-86c2-2bf87568d49e",
                          name: "Text",
                          displayName: "Text",
                          parentId: "3ff7f1d2-9871-47ac-8e7f-cf93520837a4",
                          fields: {
                            "Html Tag": { value: "h5" },
                            Text: { value: "หมายเลขโทรศัพท์" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "68525ADA341A44E4A149A8B8DFECA243",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "5690dacb-ccd3-4228-8dd4-e78e9b286167",
                          name: "country_code",
                          displayName: "country_code",
                          parentId: "3ff7f1d2-9871-47ac-8e7f-cf93520837a4",
                          fields: {
                            "Default Value": { value: "+66" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "0" },
                            "Placeholder Text": { value: "" },
                            dialInCodeLength: null,
                            "Css Class": {
                              value: "inline disabled countryCodeInput",
                            },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: true },
                            apiName: {
                              id: "01b8756b-4bc7-4534-b990-516943821261",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/countrycode",
                              fields: {
                                value: { value: "countryCode" },
                                key: { value: "countryCode" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: false },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "8964ED2ED7E64233BBB0708A7872ABD8",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "3d07523c-3fdd-44a4-bd87-9e0451db139a",
                          name: "Telephone",
                          displayName: "Telephone",
                          parentId: "3ff7f1d2-9871-47ac-8e7f-cf93520837a4",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "10" },
                            "Min Length": { value: "9" },
                            "Placeholder Text": { value: "" },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "No" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": { value: "inline telephoneInput" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "22259656-b6e9-4f74-993e-4578dbcf0741",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/cellphone",
                              fields: {
                                value: { value: "cellPhone" },
                                key: { value: "cellPhone" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "4a662f4f-977d-452c-ac86-edb8eb1c7f7d",
                                fields: {
                                  Message: {
                                    value:
                                      "โปรดกรอกเบอร์โทรศัพท์ด้วยตัวเลขไม่เกิน 10 หลัก",
                                  },
                                  Parameters: {
                                    value: "/^0\\d{1}(\\d{7}|\\d{8})$/",
                                  },
                                  Type: {
                                    value:
                                      "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "df74f55b-47e6-4d1c-92f8-b0d46a7b2704",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/telephone",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/mobile_phone.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "1aa74652-2177-48c9-88f5-1214445fea34",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "//^d +$//" },
                                      Type: {
                                        value:
                                          "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                      },
                                    },
                                  },
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Telephone",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "4799D38182DD4823B332E218187C23B0",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "88281c40-2fc9-470a-8364-c76106ae6927",
                          name: "phoneNextClick",
                          displayName: "phoneNextClick",
                          parentId: "3ff7f1d2-9871-47ac-8e7f-cf93520837a4",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "7BB73BAD1EEC4F309AB7046C2FFF2ED2",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "cee88bd9-3baa-4654-bcaa-a11185491b1d",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "88281c40-2fc9-470a-8364-c76106ae6927",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{97015CE8-8C1A-493E-963A-B58315166081}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "f2fee2cd-2c03-4b04-a71b-26e747a338de",
                      name: "phonePageForMobile",
                      displayName: "phonePageForMobile",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "phonePage conditionPage" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "A822D936CE184893B07F20E4B97E9B22",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "e55320b4-f746-474f-a609-72a4c40ae368",
                          name: "Text",
                          displayName: "Text",
                          parentId: "f2fee2cd-2c03-4b04-a71b-26e747a338de",
                          fields: {
                            "Html Tag": { value: "h5" },
                            Text: { value: "หมายเลขโทรศัพท์" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "68525ADA341A44E4A149A8B8DFECA243",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "b739063b-0279-4d5c-b0c6-110d1894ca62",
                          name: "country_code",
                          displayName: "country_code",
                          parentId: "f2fee2cd-2c03-4b04-a71b-26e747a338de",
                          fields: {
                            "Default Value": { value: "+66" },
                            "Max Length": { value: "255" },
                            "Min Length": { value: "0" },
                            "Placeholder Text": { value: "" },
                            dialInCodeLength: null,
                            "Css Class": {
                              value: "inline disabled countryCodeInput",
                            },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: true },
                            apiName: {
                              id: "01b8756b-4bc7-4534-b990-516943821261",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/countrycode",
                              fields: {
                                value: { value: "countryCode" },
                                key: { value: "countryCode" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: false },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "4ee89ea7-cefe-4c8e-8532-467ef64591fc",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/single-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/text_field.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/SingleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "8964ED2ED7E64233BBB0708A7872ABD8",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "5618a54c-9282-41ed-a12a-47ba24d28035",
                          name: "TelephoneForMobileOnly",
                          displayName: "TelephoneForMobileOnly",
                          parentId: "f2fee2cd-2c03-4b04-a71b-26e747a338de",
                          fields: {
                            "Default Value": { value: "" },
                            "Max Length": { value: "10" },
                            "Min Length": { value: "10" },
                            "Placeholder Text": { value: "" },
                            dialInCodeLength: {
                              id: "924aee12-9c96-42e0-8548-8378e251a8c7",
                              fieldType: "Droplink",
                              fieldName: "dialInCodeLength",
                              url: "/sitecore/content/fwd/global/settings/list/formdiallingcodelength/zero",
                              fields: {
                                value: { value: "No" },
                                key: { value: "zero" },
                              },
                            },
                            "Css Class": { value: "inline telephoneInput" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "22259656-b6e9-4f74-993e-4578dbcf0741",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/cellphone",
                              fields: {
                                value: { value: "cellPhone" },
                                key: { value: "cellPhone" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [
                              {
                                id: "58e08623-e9cb-4086-bd92-b412a13276e5",
                                fields: {
                                  Message: {
                                    value:
                                      "โปรดกรอกเบอร์มือถือด้วยตัวเลข 10 หลัก",
                                  },
                                  Parameters: { value: "/^0[689]\\d{8}$/" },
                                  Type: {
                                    value:
                                      "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                  },
                                },
                              },
                            ],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "df74f55b-47e6-4d1c-92f8-b0d46a7b2704",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/telephone",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/mobile_phone.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "0908030b-4564-42ea-a6fa-c7a5a2d921a8",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/input",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "1aa74652-2177-48c9-88f5-1214445fea34",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "//^d +$//" },
                                      Type: {
                                        value:
                                          "FWD.Foundation.Forms.Validators.CustomRegularExpressionValidation,FWD.Foundation.Forms",
                                      },
                                    },
                                  },
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomSingleLineViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Telephone",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "4799D38182DD4823B332E218187C23B0",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "820d883e-5e0e-4574-b4e9-778ba3eed288",
                          name: "phoneNextClickMeetAnAgent",
                          displayName: "phoneNextClickMeetAnAgent",
                          parentId: "f2fee2cd-2c03-4b04-a71b-26e747a338de",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "172ABD10475D4D829A918792A8F911DD",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "4071f508-f983-4a2b-b745-4f6ae77c554d",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "820d883e-5e0e-4574-b4e9-778ba3eed288",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{14134845-E549-47E6-8BC4-4E5C210FA7DA}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "97015ce8-8c1a-493e-963a-b58315166081",
                      name: "preferredContactModePage",
                      displayName: "preferredContactModePage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "conditionPage" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "4DF8F5E941DF48CC846122E6426D5C47",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "bbeb0b00-cb70-4e8a-b5d0-9a56f128b22b",
                          name: "Text",
                          displayName: "Text",
                          parentId: "97015ce8-8c1a-493e-963a-b58315166081",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "ฉันต้องการให้ติดต่อโดย" },
                            "Css Class": { value: "block" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "2CEFA97A507747A183E4DB2D202E0B10",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "809c053d-dee0-4c49-8636-cb7a828f1688",
                          name: "ContactMode",
                          displayName: "ContactMode",
                          parentId: "97015ce8-8c1a-493e-963a-b58315166081",
                          fields: {
                            Datasource: null,
                            "Default Selection": { value: "" },
                            "Display Field Name": { value: "__Display name" },
                            "Is Dynamic": { value: false },
                            "Value Field Name": { value: "Value" },
                            "Css Class": { value: "block" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "50d505ca-38f7-420f-8f73-f221ef889e74",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/preferredcontactmethod",
                              fields: {
                                value: { value: "preferredContactMethod" },
                                key: { value: "preferredContactMethod" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "edbd38a8-1ae9-42ec-8ccd-f5b0e2998b4f",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/radio-button-list",
                              fields: {
                                BackgroundColor: { value: "Grass" },
                                Icon: {
                                  value:
                                    "OfficeWhite/32x32/radio_button_group.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/list",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomRadioButtonListViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/RadioButtonList",
                                },
                              },
                            },
                            Conditions: {
                              value:
                                '{"fieldConditions":[{"matchTypeId":"{365C94DA-C1CD-4783-A91D-0D17A16C7117}","conditions":[{"fieldId":"049474A552CA48A58B82690D22292B31","operatorId":"{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}","value":"phone"}],"actions":[{"fieldId":"DFA430F198F44C0DA33CD16E1DB2299E","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null},{"fieldId":"915D7E632E374A2AA094ABE3D95213BE","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null},{"fieldId":"4268BDA3502A42B5ABFB35917297516C","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null}]},{"matchTypeId":"{365C94DA-C1CD-4783-A91D-0D17A16C7117}","conditions":[{"fieldId":"049474A552CA48A58B82690D22292B31","operatorId":"{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}","value":"email"}],"actions":[{"fieldId":"2430B00246264359913BD046555A9C43","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null},{"fieldId":"98FB8E4051374455BD89F04F5AAA2D77","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null},{"fieldId":"1BCD51427EDA4A908AD768C2D9CA67CF","actionTypeId":"{AAE07A52-46A4-49EF-98B0-C2595BAC2382}","value":null}]}]}',
                            },
                            "Field Key": {
                              value: "049474A552CA48A58B82690D22292B31",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "bbafe913-9f76-4bba-8f5d-8d58b0a8ddac",
                              name: "phone",
                              displayName: "โทรศัพท์",
                              parentId: "809c053d-dee0-4c49-8636-cb7a828f1688",
                              fields: { value: { value: "phone" } },
                              items: [],
                            },
                            {
                              id: "3729fc3f-09c8-40f1-a925-560476ae7cc9",
                              name: "email",
                              displayName: "อีเมล์",
                              parentId: "809c053d-dee0-4c49-8636-cb7a828f1688",
                              fields: { value: { value: "email" } },
                              items: [],
                            },
                          ],
                        },
                        {
                          id: "821e6c76-9029-4949-9bd4-81db26caa698",
                          name: "phoneOptionNextClick",
                          displayName: "phoneOptionNextClick",
                          parentId: "97015ce8-8c1a-493e-963a-b58315166081",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "DFA430F198F44C0DA33CD16E1DB2299E",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "51b7fee1-615d-4a8f-a072-9ce4170a34b8",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "821e6c76-9029-4949-9bd4-81db26caa698",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{14134845-E549-47E6-8BC4-4E5C210FA7DA}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                        {
                          id: "1696c22d-2368-469f-98f8-15fef055c04f",
                          name: "emaiNextClick",
                          displayName: "emaiNextClick",
                          parentId: "97015ce8-8c1a-493e-963a-b58315166081",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "2430B00246264359913BD046555A9C43",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "e20b2c49-3e38-47c6-9c11-a905f4dce56b",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "1696c22d-2368-469f-98f8-15fef055c04f",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{35256F74-1D01-48A0-B221-64FFC10B120A}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "14134845-e549-47e6-8bc4-4e5c210fa7da",
                      name: "dayPage",
                      displayName: "dayPage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": {
                          value: "availabilityDayPage conditionPage",
                        },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "9E94EEE6AE21451DBE91C3B2B376849A",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "61bcdbc3-6f2f-4f6b-a2b7-3e1fdcffcc12",
                          name: "Text",
                          displayName: "Text",
                          parentId: "14134845-e549-47e6-8bc4-4e5c210fa7da",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "ฉันสะดวกที่จะให้ติดต่อกลับเมื่อ" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "04BB8D346D4D4667B6D98295CE78AB93",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "5ed72d5c-316b-4ad2-9ee4-b41482cbd448",
                          name: "dayDropdown",
                          displayName: "dayDropdown",
                          parentId: "14134845-e549-47e6-8bc4-4e5c210fa7da",
                          fields: {
                            "Show Empty Item": { value: true },
                            isAutoSuggest: { value: false },
                            node: { value: "" },
                            isDynamicDropdown: { value: false },
                            Datasource: {
                              id: "bb339335-5ea1-4dac-a9da-35a04b0a0c46",
                              fieldType: "Droptree",
                              fieldName: "Datasource",
                              url: "/content/forms/contactdaylist",
                              fields: {},
                            },
                            "Default Selection": { value: "" },
                            "Display Field Name": { value: "value" },
                            "Is Dynamic": { value: true },
                            "Value Field Name": { value: "key" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "58b136a7-764d-48c7-a721-a53d8fa01074",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/preferredday",
                              fields: {
                                value: { value: "preferredDay" },
                                key: { value: "preferredDay" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "เลือกวัน" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Collapsed by Default": { value: false },
                            "Field Type": {
                              id: "e0cfadee-1ac0-471d-a820-2e70d1547b4b",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/dropdown-list",
                              fields: {
                                BackgroundColor: { value: "Grass" },
                                Icon: {
                                  value: "OfficeWhite/32x32/drop_down_list.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "9121d435-48b8-4649-9d13-03d680474fad",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/dropdownlist",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomDropDownListViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/DropdownList",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "F388ECF875174833A4D66E2E2642B15B",
                            },
                          },
                          items: [
                            {
                              id: "276d2cc4-8bde-4e8d-9b88-55da1298aa15",
                              name: "Weekdays",
                              displayName: "วันธรรมดา",
                              parentId: "bb339335-5ea1-4dac-a9da-35a04b0a0c46",
                              fields: {
                                value: { value: "วันธรรมดา" },
                                key: { value: "2" },
                              },
                            },
                            {
                              id: "22125a18-e438-41e9-8572-5720661b2acb",
                              name: "Weekends",
                              displayName: "วันหยุดสุดสัปดาห์",
                              parentId: "bb339335-5ea1-4dac-a9da-35a04b0a0c46",
                              fields: {
                                value: { value: "วันหยุดสุดสัปดาห์" },
                                key: { value: "3" },
                              },
                            },
                            {
                              id: "f1c0246a-fe49-473b-ac99-feaf423f8296",
                              name: "Any day",
                              displayName: "ทุกวัน",
                              parentId: "bb339335-5ea1-4dac-a9da-35a04b0a0c46",
                              fields: {
                                value: { value: "ทุกวัน" },
                                key: { value: "1" },
                              },
                            },
                          ],
                        },
                        {
                          id: "9556e289-77ae-4764-aed8-7ac393274557",
                          name: "ToolTip",
                          displayName: "ToolTip",
                          parentId: "14134845-e549-47e6-8bc4-4e5c210fa7da",
                          fields: {
                            toolTipText: {
                              value:
                                "เราจะติดต่อคุณในช่วงเวลาที่คุณได้เลือกไว้",
                            },
                            label: { value: "ทำไมเราจึงถามคำถามนี้?" },
                            "Css Class": { value: "tool-tip" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Is Tracking Enabled": { value: true },
                            "Field Type": {
                              id: "fff6a7f6-db43-49f4-80aa-519af8ede3c5",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/tooltip",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: { value: "Office/32x32/question.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "1edd4140-c0f7-4b64-aaf6-dd99abd590de",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/tooltip",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomToolTipViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/ToolTip",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "131179784D46453C96D7EBC2817EB577",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "a5d9f6a6-ec11-4717-9e21-03361d2bab47",
                          name: "dayButtonNextClick",
                          displayName: "dayButtonNextClick",
                          parentId: "14134845-e549-47e6-8bc4-4e5c210fa7da",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "B544A093CB784BB8AF1E0C9494DE48EE",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "77bc4454-d90f-4f8a-b523-257119cb071c",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "a5d9f6a6-ec11-4717-9e21-03361d2bab47",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{86D35045-1A2A-4FC8-804B-A3AE2B929D0D}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "86d35045-1a2a-4fc8-804b-a3ae2b929d0d",
                      name: "timePage",
                      displayName: "timePage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": {
                          value:
                            "availabilityTimePage submitPage conditionPage",
                        },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "F46A6A39786642D2A743E145F488033A",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "2065d307-9720-4d75-9b3a-a8374df2200e",
                          name: "Text",
                          displayName: "Text",
                          parentId: "86d35045-1a2a-4fc8-804b-a3ae2b929d0d",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "ฉันสะดวกที่จะแชทระหว่าง " },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "3FE63FA45349456B87D9EFA8F775D9FE",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "dcee8dc3-5bb0-4d7e-b3fa-ec52262c7636",
                          name: "timeDropdown",
                          displayName: "timeDropdown",
                          parentId: "86d35045-1a2a-4fc8-804b-a3ae2b929d0d",
                          fields: {
                            "Show Empty Item": { value: true },
                            isAutoSuggest: { value: false },
                            node: { value: "" },
                            isDynamicDropdown: { value: false },
                            Datasource: {
                              id: "cbfc6e99-6b69-4d87-9c1d-1a10253ea8ab",
                              fieldType: "Droptree",
                              fieldName: "Datasource",
                              url: "/content/forms/contacttimelist",
                              fields: {},
                            },
                            "Default Selection": { value: "" },
                            "Display Field Name": { value: "value" },
                            "Is Dynamic": { value: true },
                            "Value Field Name": { value: "key" },
                            "Css Class": { value: "inline" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "1e985703-c4e7-402d-a310-c17b2d90d381",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/preferredtime",
                              fields: {
                                value: { value: "preferredTime" },
                                key: { value: "preferredTime" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "เลือกเวลา" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Collapsed by Default": { value: false },
                            "Field Type": {
                              id: "e0cfadee-1ac0-471d-a820-2e70d1547b4b",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/lists/dropdown-list",
                              fields: {
                                BackgroundColor: { value: "Grass" },
                                Icon: {
                                  value: "OfficeWhite/32x32/drop_down_list.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "9121d435-48b8-4649-9d13-03d680474fad",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/dropdownlist",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomDropDownListViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/DropdownList",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "3769A8E2F8484912B8012DBDCD9A47CA",
                            },
                          },
                          items: [
                            {
                              id: "e534f9ff-5894-47de-8f13-85abdc753cc9",
                              name: "8am - 12pm",
                              displayName: "8.00-12.00 น.",
                              parentId: "cbfc6e99-6b69-4d87-9c1d-1a10253ea8ab",
                              fields: {
                                value: { value: "8.00-12.00 น." },
                                key: { value: "1" },
                              },
                            },
                            {
                              id: "eb8c15e4-bdff-4db9-90b6-3849964b5bd3",
                              name: "12pm - 1pm",
                              displayName: "12.00-13.00 น.",
                              parentId: "cbfc6e99-6b69-4d87-9c1d-1a10253ea8ab",
                              fields: {
                                value: { value: "12.00-13.00 น." },
                                key: { value: "2" },
                              },
                            },
                            {
                              id: "bb8cd832-9b04-4d7e-a24c-351eb6ce0a0b",
                              name: "1pm - 3pm",
                              displayName: "13.00-15.00 น.",
                              parentId: "cbfc6e99-6b69-4d87-9c1d-1a10253ea8ab",
                              fields: {
                                value: { value: "13.00-15.00 น." },
                                key: { value: "3" },
                              },
                            },
                            {
                              id: "ec1a464a-23b8-4ebb-a19a-f4d8044281da",
                              name: "3pm - 5pm",
                              displayName: "15.00-17.00 น.",
                              parentId: "cbfc6e99-6b69-4d87-9c1d-1a10253ea8ab",
                              fields: {
                                value: { value: "15.00-17.00 น." },
                                key: { value: "4" },
                              },
                            },
                            {
                              id: "3f6abbc0-53a5-4a20-ac5d-b5034ac1b88b",
                              name: "5pm - 8pm",
                              displayName: "17.00-20.00 น.",
                              parentId: "cbfc6e99-6b69-4d87-9c1d-1a10253ea8ab",
                              fields: {
                                value: { value: "17.00-20.00 น." },
                                key: { value: "5" },
                              },
                            },
                            {
                              id: "f14ebf34-9e9c-4e3b-a72b-05c331766f53",
                              name: "Any time",
                              displayName: "ทุกช่วงเวลา",
                              parentId: "cbfc6e99-6b69-4d87-9c1d-1a10253ea8ab",
                              fields: {
                                value: { value: "ทุกช่วงเวลา" },
                                key: { value: "6" },
                              },
                            },
                          ],
                        },
                        {
                          id: "ae955ef2-d083-42ce-bb8c-ca86bd7906f7",
                          name: "ToolTip",
                          displayName: "ToolTip",
                          parentId: "86d35045-1a2a-4fc8-804b-a3ae2b929d0d",
                          fields: {
                            toolTipText: {
                              value:
                                "เราจะติดต่อคุณในช่วงเวลาที่คุณได้เลือกไว้",
                            },
                            label: { value: "ทำไมเราจึงถามคำถามนี้?" },
                            "Css Class": { value: "tool-tip" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Is Tracking Enabled": { value: true },
                            "Field Type": {
                              id: "fff6a7f6-db43-49f4-80aa-519af8ede3c5",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/tooltip",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: { value: "Office/32x32/question.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "1edd4140-c0f7-4b64-aaf6-dd99abd590de",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/tooltip",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomToolTipViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/ToolTip",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "08ACA529BB6048C09ADF023D64D0EDAD",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "80b3d4e4-732e-4b57-81e4-0038f89c39a8",
                          name: "ConsentSection",
                          displayName: "ConsentSection",
                          parentId: "86d35045-1a2a-4fc8-804b-a3ae2b929d0d",
                          fields: {
                            backgroundColor: {
                              id: "cf8cf9a4-0f70-4db2-b298-90e820aca94b",
                              fieldType: "Droplink",
                              fieldName: "backgroundColor",
                              url: "/sitecore/content/fwd/global/settings/list/colors/greywhite",
                              fields: {
                                value: { value: "grey-white" },
                                key: { value: "grey-white" },
                              },
                            },
                            "Css Class": { value: "consentSection" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "447aa745-6d29-4b65-a5a3-8173aa8af548",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/section",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: {
                                  value:
                                    "OfficeWhite/32x32/document_header.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "8cddb194-f456-4a75-89b7-346f8f39f95c",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/section",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "Sitecore.ExperienceForms.Mvc.Models.Fields.FieldViewModel,Sitecore.ExperienceForms.Mvc",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Section",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "7881B9CA368C47B8B4418EFCABB92091",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "92f0434f-a9ec-439e-b1cb-fb7c284fd240",
                              name: "privacyPolicy",
                              displayName: "privacyPolicy",
                              parentId: "80b3d4e4-732e-4b57-81e4-0038f89c39a8",
                              fields: {
                                Datasource: {
                                  id: "e8c592ad-cf7f-465a-b669-94d1f2744ced",
                                  fieldType: "Droptree",
                                  fieldName: "Datasource",
                                  url: "/content/forms/privacypolicy/general-consent-002",
                                  fields: {},
                                },
                                "Default Selection": { value: "" },
                                "Display Field Name": { value: "value" },
                                "Is Dynamic": { value: true },
                                "Value Field Name": { value: "key" },
                                "Css Class": {
                                  value: "block privacyPolicyCheckbox",
                                },
                                HelpText: { value: "" },
                                GeneralError: { value: "" },
                                SpecificError: { value: "" },
                                isHidden: { value: false },
                                apiName: {
                                  id: "2b066ac3-4cbd-41c7-8e19-c26ab07eccc1",
                                  fieldType: "Droplink",
                                  fieldName: "apiName",
                                  url: "/sitecore/content/fwd/global/settings/list/form-api-fields/consentcheckbox",
                                  fields: {
                                    value: { value: "consentCheckBox" },
                                    key: { value: "consentCheckBox" },
                                  },
                                },
                                serverValidationErrorText: { value: "" },
                                enableServerValidation: { value: false },
                                serverValidationAPI: null,
                                serverValidationLoadingText: { value: "" },
                                "Label Css Class": { value: "" },
                                Title: { value: "" },
                                Required: { value: true },
                                Validations: [],
                                "Is Tracking Enabled": { value: true },
                                "Allow Save": { value: true },
                                "Value Provider Parameters": { value: "" },
                                "Value Provider": null,
                                "Field Type": {
                                  id: "d86a361a-d4ff-46b2-9e97-a37fc5b1fe1a",
                                  fieldType: "Droptree",
                                  fieldName: "Field Type",
                                  url: "/sitecore/system/settings/forms/field-types/lists/checkbox-list",
                                  fields: {
                                    BackgroundColor: { value: "Grass" },
                                    Icon: {
                                      value:
                                        "OfficeWhite/32x32/checkbox_group.png",
                                    },
                                    IsDisabled: { value: false },
                                    SpritePosition: { value: "" },
                                    "Field Template": {
                                      id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                      fieldType: "Droptree",
                                      fieldName: "Field Template",
                                      url: "/sitecore/templates/system/forms/fields/list",
                                      fields: {},
                                    },
                                    "Allowed Validations": [],
                                    "Model Type": {
                                      value:
                                        "FWD.Foundation.Forms.CustomCheckBoxListViewModel,FWD.Foundation.Forms",
                                    },
                                    "Property Editor": null,
                                    "View Path": {
                                      value: "FieldTemplates/CheckBoxList",
                                    },
                                  },
                                },
                                Conditions: { value: '{"fieldConditions":[]}' },
                                "Field Key": {
                                  value: "C470CC60AF974C7AADFF19FFAF9BF37D",
                                },
                                "Collapsed by Default": { value: false },
                              },
                              items: [
                                {
                                  id: "804cdfce-0538-4b4a-8a2a-8ec157a56712",
                                  name: "privacy-policy",
                                  displayName: "privacy-policy",
                                  parentId:
                                    "e8c592ad-cf7f-465a-b669-94d1f2744ced",
                                  fields: {
                                    value: {
                                      value:
                                        'คุณยินยอมให้บริษัท เอฟดับบลิวดี ประกันชีวิต จำกัด (มหาชน) เก็บ รวบรวม และ/หรือใช้ข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลที่มีความอ่อนไหวของข้าพเจ้าเพื่อเสนอผลิตภัณฑ์ บริการ และข้อเสนอพิเศษอื่น และเปิดเผยข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลที่มีความอ่อนไหว ให้แก่บริษัทคู่ค้าและบริษัทในเครือ เพื่อวิเคราะห์ เสนอผลิตภัณฑ์ บริการ และข้อเสนอพิเศษอื่น คุณรับทราบ เข้าใจวัตถุประสงค์ข้างต้น รวมทั้งคำชี้แจงเกี่ยวกับข้อมูลส่วนบุคคลของเอฟดับบลิวดี ตาม <a rel="noopener noreferrer" href="https://www.fwd.co.th/th/privacy-policy" target="_blank">นโยบายข้อมูลส่วนบุคคล</a>&nbsp;อย่างชัดเจนแล้ว (<a rel="noopener noreferrer" href="https://www.fwd.co.th/th/privacy-policy/consent-for-use-of-personal-data" target="_blank">อ่านเพิ่มเติม</a>)',
                                    },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          id: "64c18ec7-3936-4ae2-962e-15879d536a7e",
                          name: "SubmitSection",
                          displayName: "SubmitSection",
                          parentId: "86d35045-1a2a-4fc8-804b-a3ae2b929d0d",
                          fields: {
                            backgroundColor: null,
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "447aa745-6d29-4b65-a5a3-8173aa8af548",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/section",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: {
                                  value:
                                    "OfficeWhite/32x32/document_header.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "8cddb194-f456-4a75-89b7-346f8f39f95c",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/section",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "Sitecore.ExperienceForms.Mvc.Models.Fields.FieldViewModel,Sitecore.ExperienceForms.Mvc",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Section",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "611F3DE333B54D1B8C963ECD22D8EE72",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "3ae44fc2-1128-4c45-b995-32d8f389bc51",
                              name: "timeSubmitClickforMeetAnAgent",
                              displayName: "timeSubmitClickforMeetAnAgent",
                              parentId: "64c18ec7-3936-4ae2-962e-15879d536a7e",
                              fields: {
                                "Navigation Step": { value: "0" },
                                emailTemplateLink: {
                                  value:
                                    "/FormsList/general-enquiry-form/general-enquiry-template-for-meetAnAgent",
                                },
                                "Css Class": { value: "submitButton" },
                                HelpText: { value: "" },
                                GeneralError: { value: "" },
                                SpecificError: { value: "" },
                                isHidden: { value: false },
                                apiName: {
                                  id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                                  fieldType: "Droplink",
                                  fieldName: "apiName",
                                  url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                                  fields: {
                                    value: { value: "" },
                                    key: { value: "" },
                                  },
                                },
                                serverValidationErrorText: { value: "" },
                                enableServerValidation: { value: false },
                                serverValidationAPI: null,
                                serverValidationLoadingText: { value: "" },
                                "Label Css Class": { value: "" },
                                Title: { value: "ตกลง" },
                                "Field Type": {
                                  id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                                  fieldType: "Droptree",
                                  fieldName: "Field Type",
                                  url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                                  fields: {
                                    BackgroundColor: { value: "Eggplant" },
                                    Icon: {
                                      value: "OfficeWhite/32x32/button.png",
                                    },
                                    IsDisabled: { value: false },
                                    SpritePosition: { value: "" },
                                    "Field Template": {
                                      id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                      fieldType: "Droptree",
                                      fieldName: "Field Template",
                                      url: "/sitecore/templates/system/forms/fields/button",
                                      fields: {},
                                    },
                                    "Allowed Validations": [],
                                    "Model Type": {
                                      value:
                                        "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                    },
                                    "Property Editor": null,
                                    "View Path": {
                                      value: "FieldTemplates/Button",
                                    },
                                  },
                                },
                                Conditions: { value: '{"fieldConditions":[]}' },
                                "Field Key": {
                                  value: "F78E7E81BBDA41518CC7CE20C580CB1A",
                                },
                                "Collapsed by Default": { value: false },
                              },
                              items: [
                                {
                                  id: "0e5e4379-3c1d-4f73-be41-80ded45a3a0c",
                                  name: "Save Data",
                                  displayName: "Save Data",
                                  parentId:
                                    "3ae44fc2-1128-4c45-b995-32d8f389bc51",
                                  fields: {
                                    Description: { value: "" },
                                    Parameters: { value: "" },
                                    "Submit Action": {
                                      id: "0c61eab3-a61e-47b8-ae0b-b6eba0d6eb1b",
                                      fieldType: "Droptree",
                                      fieldName: "Submit Action",
                                      url: "/sitecore/system/settings/forms/submit-actions/save-data",
                                      fields: {
                                        Editor: null,
                                        "Error Message": { value: "" },
                                        "Model Type": {
                                          value:
                                            "Sitecore.ExperienceForms.Processing.Actions.SaveData",
                                        },
                                      },
                                    },
                                  },
                                  items: [],
                                },
                                {
                                  id: "be56435c-6b83-454c-adc1-bdf636a8c548",
                                  name: "Redirect to Page",
                                  displayName: "Redirect to Page",
                                  parentId:
                                    "3ae44fc2-1128-4c45-b995-32d8f389bc51",
                                  fields: {
                                    Description: { value: "" },
                                    Parameters: {
                                      value:
                                        '{"referenceId":"{70E44DB9-A7DC-485B-A596-961ED02AEC3C}"}',
                                    },
                                    "Submit Action": {
                                      id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                      fieldType: "Droptree",
                                      fieldName: "Submit Action",
                                      url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                      fields: {
                                        Editor: null,
                                        "Error Message": { value: "" },
                                        "Model Type": {
                                          value:
                                            "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                        },
                                      },
                                    },
                                  },
                                  items: [],
                                },
                              ],
                            },
                            {
                              id: "bc044852-c87d-4bef-8f5c-6e80015494da",
                              name: "Source",
                              displayName: "Source",
                              parentId: "64c18ec7-3936-4ae2-962e-15879d536a7e",
                              fields: {
                                "Html Tag": { value: "p" },
                                Text: { value: "4" },
                                "Css Class": { value: "" },
                                HelpText: { value: "" },
                                GeneralError: { value: "" },
                                SpecificError: { value: "" },
                                isHidden: { value: true },
                                apiName: {
                                  id: "0d6d0e98-3398-447a-90a9-94636f297d18",
                                  fieldType: "Droplink",
                                  fieldName: "apiName",
                                  url: "/sitecore/content/fwd/global/settings/list/form-api-fields/source",
                                  fields: {
                                    value: { value: "source" },
                                    key: { value: "source" },
                                  },
                                },
                                serverValidationErrorText: { value: "" },
                                enableServerValidation: { value: false },
                                serverValidationAPI: null,
                                serverValidationLoadingText: { value: "" },
                                "Field Type": {
                                  id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                                  fieldType: "Droptree",
                                  fieldName: "Field Type",
                                  url: "/sitecore/system/settings/forms/field-types/basic/text",
                                  fields: {
                                    BackgroundColor: { value: "Sky" },
                                    Icon: {
                                      value:
                                        "OfficeWhite/32x32/document_text.png",
                                    },
                                    IsDisabled: { value: false },
                                    SpritePosition: { value: "" },
                                    "Field Template": {
                                      id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                      fieldType: "Droptree",
                                      fieldName: "Field Template",
                                      url: "/sitecore/templates/system/forms/fields/text",
                                      fields: {},
                                    },
                                    "Allowed Validations": [],
                                    "Model Type": {
                                      value:
                                        "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                    },
                                    "Property Editor": null,
                                    "View Path": {
                                      value: "FieldTemplates/Text",
                                    },
                                  },
                                },
                                Conditions: { value: '{"fieldConditions":[]}' },
                                "Field Key": {
                                  value: "BA68F782EAE8454592E7634AEBDE648C",
                                },
                                "Collapsed by Default": { value: false },
                              },
                              items: [],
                            },
                          ],
                        },
                        {
                          id: "011f5a80-4277-4edc-90c9-5f405df868f8",
                          name: "timeButtonNextClick",
                          displayName: "timeButtonNextClick",
                          parentId: "86d35045-1a2a-4fc8-804b-a3ae2b929d0d",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "next-button" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ต่อไป" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "1115B84BAAE646A59A23F5A3B965CC6E",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "a6cbe7e8-447a-4de1-b13f-1a829ba89967",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "011f5a80-4277-4edc-90c9-5f405df868f8",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{35256F74-1D01-48A0-B221-64FFC10B120A}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: "35256f74-1d01-48a0-b221-64ffc10b120a",
                      name: "commentsPage",
                      displayName: "commentsPage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "cbdc6265-d09f-4982-981a-bcc8f118f36f",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/whiteorange",
                          fields: {
                            value: { value: "white-orange" },
                            key: { value: "WhiteOrange" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": { value: "conditionPage" },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "124E675A556E49098DB1F1CA757BA6BA",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "5b753901-bc2d-4a60-9f96-544af40710e5",
                          name: "Text",
                          displayName: "Text",
                          parentId: "35256f74-1d01-48a0-b221-64ffc10b120a",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "ส่งข้อความถึงเรา" },
                            "Css Class": { value: "block" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "A75064A325DD4F9886C59B90D94623CD",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "c6cfda5c-40ca-483f-bdae-a440bd55e9ea",
                          name: "AddAComment",
                          displayName: "AddAComment",
                          parentId: "35256f74-1d01-48a0-b221-64ffc10b120a",
                          fields: {
                            Rows: { value: "4" },
                            "Default Value": { value: "" },
                            "Max Length": { value: "0" },
                            "Min Length": { value: "0" },
                            "Placeholder Text": {
                              value: "สอบถามหรือให้คำแนะนำ",
                            },
                            dialInCodeLength: null,
                            "Css Class": { value: "block" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: {
                              value:
                                "เพื่อส่งคำถามหรือคำแนะนำของคุณ กรุณากรอกข้อความ",
                            },
                            isHidden: { value: false },
                            apiName: {
                              id: "87827a1f-bbbd-42b2-b966-5fa2a695f102",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/comment",
                              fields: {
                                value: { value: "comment" },
                                key: { value: "comment" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "" },
                            Required: { value: true },
                            Validations: [],
                            "Is Tracking Enabled": { value: true },
                            "Allow Save": { value: true },
                            "Value Provider Parameters": { value: "" },
                            "Value Provider": null,
                            "Field Type": {
                              id: "a296a1c1-0da0-4493-a92e-b8191f43aec6",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/multiple-line-text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: { value: "OfficeWhite/32x32/text.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "d8386d04-c1e3-4cd3-9227-9e9f86ef3c88",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/multiple-line-text",
                                  fields: {},
                                },
                                "Allowed Validations": [
                                  {
                                    id: "83e96d09-11c8-4132-8a8a-76d8db8208d6",
                                    fields: {
                                      Message: { value: "" },
                                      Parameters: { value: "" },
                                      Type: {
                                        value:
                                          "Sitecore.ExperienceForms.Mvc.Models.Validation.StringLengthValidation,Sitecore.ExperienceForms.Mvc",
                                      },
                                    },
                                  },
                                ],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomMultipleLineTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/MultipleLineText",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "C6739D2F83B749A3A7F79BB681CC6DAD",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "ecfb3b4c-5e9e-4dee-a2c2-05fa164e9b60",
                          name: "PrivacyPolicySection",
                          displayName: "PrivacyPolicySection",
                          parentId: "35256f74-1d01-48a0-b221-64ffc10b120a",
                          fields: {
                            backgroundColor: {
                              id: "cf8cf9a4-0f70-4db2-b298-90e820aca94b",
                              fieldType: "Droplink",
                              fieldName: "backgroundColor",
                              url: "/sitecore/content/fwd/global/settings/list/colors/greywhite",
                              fields: {
                                value: { value: "grey-white" },
                                key: { value: "grey-white" },
                              },
                            },
                            "Css Class": { value: "consentSection" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "447aa745-6d29-4b65-a5a3-8173aa8af548",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/section",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: {
                                  value:
                                    "OfficeWhite/32x32/document_header.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "8cddb194-f456-4a75-89b7-346f8f39f95c",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/section",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "Sitecore.ExperienceForms.Mvc.Models.Fields.FieldViewModel,Sitecore.ExperienceForms.Mvc",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Section",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "978BEE438604440BB13FCF9C3E943CDD",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "f5c9f75c-3cfc-4560-955c-480a57d203e2",
                              name: "privacyPolicy",
                              displayName: "privacyPolicy",
                              parentId: "ecfb3b4c-5e9e-4dee-a2c2-05fa164e9b60",
                              fields: {
                                Datasource: {
                                  id: "2fd77055-4fde-409a-9b4c-dc6732f30938",
                                  fieldType: "Droptree",
                                  fieldName: "Datasource",
                                  url: "/content/forms/privacypolicy/generalconsent001",
                                  fields: {},
                                },
                                "Default Selection": { value: "" },
                                "Display Field Name": { value: "value" },
                                "Is Dynamic": { value: true },
                                "Value Field Name": { value: "key" },
                                "Css Class": {
                                  value: "block privacyPolicyCheckbox",
                                },
                                HelpText: { value: "" },
                                GeneralError: { value: "" },
                                SpecificError: { value: "" },
                                isHidden: { value: false },
                                apiName: {
                                  id: "2b066ac3-4cbd-41c7-8e19-c26ab07eccc1",
                                  fieldType: "Droplink",
                                  fieldName: "apiName",
                                  url: "/sitecore/content/fwd/global/settings/list/form-api-fields/consentcheckbox",
                                  fields: {
                                    value: { value: "consentCheckBox" },
                                    key: { value: "consentCheckBox" },
                                  },
                                },
                                serverValidationErrorText: { value: "" },
                                enableServerValidation: { value: false },
                                serverValidationAPI: null,
                                serverValidationLoadingText: { value: "" },
                                "Label Css Class": { value: "" },
                                Title: { value: "" },
                                Required: { value: true },
                                Validations: [],
                                "Is Tracking Enabled": { value: true },
                                "Allow Save": { value: true },
                                "Value Provider Parameters": { value: "" },
                                "Value Provider": null,
                                "Field Type": {
                                  id: "d86a361a-d4ff-46b2-9e97-a37fc5b1fe1a",
                                  fieldType: "Droptree",
                                  fieldName: "Field Type",
                                  url: "/sitecore/system/settings/forms/field-types/lists/checkbox-list",
                                  fields: {
                                    BackgroundColor: { value: "Grass" },
                                    Icon: {
                                      value:
                                        "OfficeWhite/32x32/checkbox_group.png",
                                    },
                                    IsDisabled: { value: false },
                                    SpritePosition: { value: "" },
                                    "Field Template": {
                                      id: "5b672865-55d2-413e-b699-fdfc7e732ccf",
                                      fieldType: "Droptree",
                                      fieldName: "Field Template",
                                      url: "/sitecore/templates/system/forms/fields/list",
                                      fields: {},
                                    },
                                    "Allowed Validations": [],
                                    "Model Type": {
                                      value:
                                        "FWD.Foundation.Forms.CustomCheckBoxListViewModel,FWD.Foundation.Forms",
                                    },
                                    "Property Editor": null,
                                    "View Path": {
                                      value: "FieldTemplates/CheckBoxList",
                                    },
                                  },
                                },
                                Conditions: { value: '{"fieldConditions":[]}' },
                                "Field Key": {
                                  value: "C470CC60AF974C7AADFF19FFAF9BF37D",
                                },
                                "Collapsed by Default": { value: false },
                              },
                              items: [
                                {
                                  id: "21e87681-d057-4ae3-b2d3-60bea3c04fae",
                                  name: "privacy-policy",
                                  displayName: "privacy-policy",
                                  parentId:
                                    "2fd77055-4fde-409a-9b4c-dc6732f30938",
                                  fields: {
                                    value: {
                                      value:
                                        'คุณยินยอมให้บริษัท เอฟดับบลิวดี ประกันชีวิต จำกัด (มหาชน) เก็บ รวบรวม และ/หรือใช้ข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลที่มีความอ่อนไหวของข้าพเจ้าเพื่อเสนอผลิตภัณฑ์ บริการ และข้อเสนอพิเศษอื่น และเปิดเผยข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลที่มีความอ่อนไหว ให้แก่บริษัทคู่ค้าและบริษัทในเครือ เพื่อวิเคราะห์ เสนอผลิตภัณฑ์ บริการ และข้อเสนอพิเศษอื่น คุณรับทราบ เข้าใจวัตถุประสงค์ข้างต้น รวมทั้งคำชี้แจงเกี่ยวกับข้อมูลส่วนบุคคลของเอฟดับบลิวดี ตาม <a rel="noopener noreferrer" href="https://www.fwd.co.th/th/privacy-policy" target="_blank">นโยบายข้อมูลส่วนบุคคล</a>&nbsp;อย่างชัดเจนแล้ว (<a rel="noopener noreferrer" href="https://www.fwd.co.th/th/privacy-policy/consent-for-use-of-personal-data" target="_blank">อ่านเพิ่มเติม</a>)',
                                    },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          id: "5fccc626-db31-483e-8873-32e06700c8c4",
                          name: "commentsSubmitClick",
                          displayName: "commentsSubmitClick",
                          parentId: "35256f74-1d01-48a0-b221-64ffc10b120a",
                          fields: {
                            "Navigation Step": { value: "0" },
                            emailTemplateLink: {
                              value:
                                "/FormsList/general-enquiry-form/general-enquiry-email-template",
                            },
                            "Css Class": { value: "submitButton" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ตกลง" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "1BCD51427EDA4A908AD768C2D9CA67CF",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "99bfe258-6458-46c8-97b7-8369c23962e4",
                              name: "Send Email",
                              displayName: "Send Email",
                              parentId: "5fccc626-db31-483e-8873-32e06700c8c4",
                              fields: {
                                Description: { value: "" },
                                Parameters: { value: "" },
                                "Submit Action": {
                                  id: "2f66e378-be9d-4d9d-b43b-fc6ddc0e3db5",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/custom-action",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.SaveData",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                            {
                              id: "d4db05b1-95c0-436f-a6d9-1df9ce4b89d1",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "5fccc626-db31-483e-8873-32e06700c8c4",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{70E44DB9-A7DC-485B-A596-961ED02AEC3C}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                        {
                          id: "fb3b7d65-159b-44ec-b97a-e4d2c0ebe092",
                          name: "phoneOptionSubmitClick",
                          displayName: "phoneOptionSubmitClick",
                          parentId: "35256f74-1d01-48a0-b221-64ffc10b120a",
                          fields: {
                            "Navigation Step": { value: "0" },
                            emailTemplateLink: {
                              value:
                                "/FormsList/general-enquiry-form/general-enquiry-phone-template",
                            },
                            "Css Class": { value: "submitButton" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: {
                              id: "842f9760-ad09-47d5-a0bc-4ff98d31e193",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/none",
                              fields: {
                                value: { value: "" },
                                key: { value: "" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ตกลง" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "4268BDA3502A42B5ABFB35917297516C",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "b9f1fc56-20d7-451f-a7de-b530e2c8b617",
                              name: "Send Email",
                              displayName: "Send Email",
                              parentId: "fb3b7d65-159b-44ec-b97a-e4d2c0ebe092",
                              fields: {
                                Description: { value: "" },
                                Parameters: { value: "" },
                                "Submit Action": {
                                  id: "2f66e378-be9d-4d9d-b43b-fc6ddc0e3db5",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/custom-action",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.SaveData",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                            {
                              id: "de2616fb-690a-4612-92c1-61f9d710a854",
                              name: "Redirect to Page",
                              displayName: "Redirect to Page",
                              parentId: "fb3b7d65-159b-44ec-b97a-e4d2c0ebe092",
                              fields: {
                                Description: { value: "" },
                                Parameters: {
                                  value:
                                    '{"referenceId":"{70E44DB9-A7DC-485B-A596-961ED02AEC3C}"}',
                                },
                                "Submit Action": {
                                  id: "3f3e2093-9dea-4199-86ca-44fc69ef624d",
                                  fieldType: "Droptree",
                                  fieldName: "Submit Action",
                                  url: "/sitecore/system/settings/forms/submit-actions/redirect-to-page",
                                  fields: {
                                    Editor: null,
                                    "Error Message": { value: "" },
                                    "Model Type": {
                                      value:
                                        "Sitecore.ExperienceForms.Processing.Actions.RedirectToPage",
                                    },
                                  },
                                },
                              },
                              items: [],
                            },
                          ],
                        },
                        {
                          id: "d6d203c8-8f82-40e4-976c-32a7122ffd60",
                          name: "isAdmin",
                          displayName: "isAdmin",
                          parentId: "35256f74-1d01-48a0-b221-64ffc10b120a",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "false" },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: true },
                            apiName: {
                              id: "f3576073-c163-4a24-b248-03ab0c7c86fc",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/isadmin",
                              fields: {
                                value: { value: "isAdmin" },
                                key: { value: "isAdmin" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "EA4B2690551842E49242BEA36F56AA18",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "7f4554a3-53bb-4769-9c61-79bd3542d370",
                          name: "salesforce",
                          displayName: "salesforce",
                          parentId: "35256f74-1d01-48a0-b221-64ffc10b120a",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "true" },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: true },
                            apiName: {
                              id: "01dd0e23-b03e-4098-b773-c213d1c2d961",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/salesforce",
                              fields: {
                                value: { value: "salesforce" },
                                key: { value: "salesforce" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "5B1463AB49C34150AC998128754E2A2C",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                      ],
                    },
                    {
                      id: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                      name: "phoneBookAnAgentThankYouPage",
                      displayName: "phoneBookAnAgentThankYouPage",
                      parentId: "fa29dd87-0838-4973-bb98-1cde45079034",
                      fields: {
                        backgroundColor: {
                          id: "b47928d6-98fc-4b29-8d0f-586ab477286e",
                          fieldType: "Droplink",
                          fieldName: "backgroundColor",
                          url: "/sitecore/content/fwd/global/settings/list/colors/orangewhite",
                          fields: {
                            value: { value: "orange-white" },
                            key: { value: "OrangeWhite" },
                          },
                        },
                        gaLabel: { value: "" },
                        "Css Class": {
                          value: "phoneSubmitPage darkMode conditionPage",
                        },
                        HelpText: { value: "" },
                        GeneralError: { value: "" },
                        SpecificError: { value: "" },
                        isHidden: { value: false },
                        apiName: null,
                        serverValidationErrorText: { value: "" },
                        enableServerValidation: { value: false },
                        serverValidationAPI: null,
                        serverValidationLoadingText: { value: "" },
                        "Field Type": {
                          id: "d819b43e-c136-4392-9393-8be7fce32f5e",
                          fieldType: "Droptree",
                          fieldName: "Field Type",
                          url: "/sitecore/system/settings/forms/field-types/structure/page",
                          fields: {
                            BackgroundColor: { value: "Eggplant" },
                            Icon: {
                              value: "OfficeWhite/32x32/window_split_ver.png",
                            },
                            IsDisabled: { value: false },
                            SpritePosition: { value: "" },
                            "Field Template": {
                              id: "cfee7b51-8505-45ce-b843-9358f827df87",
                              fieldType: "Droptree",
                              fieldName: "Field Template",
                              url: "/sitecore/templates/system/forms/fields/page",
                              fields: {},
                            },
                            "Allowed Validations": [],
                            "Model Type": {
                              value:
                                "FWD.Foundation.Forms.CustomPageViewModel,FWD.Foundation.Forms",
                            },
                            "Property Editor": null,
                            "View Path": { value: "FieldTemplates/Page" },
                          },
                        },
                        Conditions: { value: '{"fieldConditions":[]}' },
                        "Field Key": {
                          value: "F880144362CB4E118C0EE581A4C3D11C",
                        },
                        "Collapsed by Default": { value: false },
                      },
                      items: [
                        {
                          id: "e0f2074e-9a2b-43f0-907a-c1ff89a6225f",
                          name: "Text",
                          displayName: "Text",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "ขอบคุณที่ติดต่อเรา" },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "753703DC08564AD893AFA873A6215A42",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "7c16d67f-fe68-4463-b8c9-b29d6497d7be",
                          name: "TextForEmail",
                          displayName: "TextForEmail",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: {
                              value:
                                "เจ้าหน้าที่บริการลูกค้าจะติดต่อคุณโดยเร็วที่สุด",
                            },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "98FB8E4051374455BD89F04F5AAA2D77",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "937715a8-032a-4adf-971c-0fbf72661878",
                          name: "TextForMeetAnAgent",
                          displayName: "TextForMeetAnAgent",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: {
                              value:
                                "เจ้าหน้าที่บริการลูกค้าจะติดต่อคุณในช่วงเวลาที่คุณได้เลือกไว้<strong>({preferredDay} {preferredTime})</strong>",
                            },
                            "Css Class": { value: "block" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "915D7E632E374A2AA094ABE3D95213BE",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "caf53d34-e279-4c21-b31f-a642fdd83b91",
                          name: "SectionForMeetAnAgent",
                          displayName: "SectionForMeetAnAgent",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            backgroundColor: null,
                            "Css Class": { value: "block" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "447aa745-6d29-4b65-a5a3-8173aa8af548",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/section",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: {
                                  value:
                                    "OfficeWhite/32x32/document_header.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "8cddb194-f456-4a75-89b7-346f8f39f95c",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/section",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "Sitecore.ExperienceForms.Mvc.Models.Fields.FieldViewModel,Sitecore.ExperienceForms.Mvc",
                                },
                                "Property Editor": null,
                                "View Path": {
                                  value: "FieldTemplates/Section",
                                },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "33B9AF355D484265A2131F07E4A7978F",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [
                            {
                              id: "2fff206f-fe5a-49a2-8437-e2c3cf928a0e",
                              name: "Text",
                              displayName: "Text",
                              parentId: "caf53d34-e279-4c21-b31f-a642fdd83b91",
                              fields: {
                                "Html Tag": { value: "p" },
                                Text: {
                                  value:
                                    "เจ้าหน้าที่บริการลูกค้าจะติดต่อคุณในช่วงเวลาที่คุณได้เลือกไว้<strong>({preferredDay} {preferredTime})</strong>",
                                },
                                "Css Class": { value: "block" },
                                HelpText: { value: "" },
                                GeneralError: { value: "" },
                                SpecificError: { value: "" },
                                isHidden: { value: false },
                                apiName: null,
                                serverValidationErrorText: { value: "" },
                                enableServerValidation: { value: false },
                                serverValidationAPI: null,
                                serverValidationLoadingText: { value: "" },
                                "Field Type": {
                                  id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                                  fieldType: "Droptree",
                                  fieldName: "Field Type",
                                  url: "/sitecore/system/settings/forms/field-types/basic/text",
                                  fields: {
                                    BackgroundColor: { value: "Sky" },
                                    Icon: {
                                      value:
                                        "OfficeWhite/32x32/document_text.png",
                                    },
                                    IsDisabled: { value: false },
                                    SpritePosition: { value: "" },
                                    "Field Template": {
                                      id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                      fieldType: "Droptree",
                                      fieldName: "Field Template",
                                      url: "/sitecore/templates/system/forms/fields/text",
                                      fields: {},
                                    },
                                    "Allowed Validations": [],
                                    "Model Type": {
                                      value:
                                        "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                    },
                                    "Property Editor": null,
                                    "View Path": {
                                      value: "FieldTemplates/Text",
                                    },
                                  },
                                },
                                Conditions: { value: '{"fieldConditions":[]}' },
                                "Field Key": {
                                  value: "45AE5CC0F0514454B696EC9E52ECBB0E",
                                },
                                "Collapsed by Default": { value: false },
                              },
                              items: [],
                            },
                          ],
                        },
                        {
                          id: "44ae55a5-8480-40c9-815c-abf5ded5b837",
                          name: "backToHome",
                          displayName: "backToHome",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            "Navigation Step": { value: "1" },
                            emailTemplateLink: { value: "" },
                            "Css Class": { value: "back-to-home" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: false },
                            apiName: null,
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Label Css Class": { value: "" },
                            Title: { value: "ย้อนกลับ" },
                            "Field Type": {
                              id: "7ce25cab-ef3a-4f73-ab13-d33bdc1e4ee2",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/structure/submit-button",
                              fields: {
                                BackgroundColor: { value: "Eggplant" },
                                Icon: { value: "OfficeWhite/32x32/button.png" },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "94a46d66-b1b8-405d-aae4-7b5a9cd61c5e",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/button",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomButtonViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Button" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "1B48EED990F64B8DBA5887B6BCFC9DC5",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "baae1e39-2329-4a51-886e-5ae1009cc54f",
                          name: "consentMsg",
                          displayName: "consentMsg",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "" },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: true },
                            apiName: {
                              id: "742c941c-44ec-4e36-878f-6dc28f99baff",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/consentmsg",
                              fields: {
                                value: { value: "consentMsg" },
                                key: { value: "consentMsg" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "060F06DE197645569C2D4DFF110C6F4A",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "eea41afd-e59f-42f0-944f-c7d037fd76de",
                          name: "consentVersionCd",
                          displayName: "consentVersionCd",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "MARKETING_CORPWEBSITEENQUIRY-001" },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: true },
                            apiName: {
                              id: "10fc0d1b-f2f0-4007-bcd7-9dc3675741bb",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/consentversioncd",
                              fields: {
                                value: { value: "consentVersionCd" },
                                key: { value: "ConsentVersionCd" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "8DEBE8307E4048FD97CEBBCC69003314",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "ace4169a-2037-48e4-8932-88364472b4ed",
                          name: "dtcCampaignId",
                          displayName: "dtcCampaignId",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "Corporate-GeneralEnquiry" },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: true },
                            apiName: {
                              id: "cd19cd7e-4435-4ee7-8e7b-522d7384522b",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/dtccampaignid",
                              fields: {
                                value: { value: "dTCCampaignId" },
                                key: { value: "dTCCampaignId" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "2D3D1522FD794189802A1E1262CE409A",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "c9fb3d44-1141-460c-9bac-bc1d6e25329e",
                          name: "partnerName",
                          displayName: "partnerName",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "NexGen" },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: true },
                            apiName: {
                              id: "865d0d1e-9b62-4e35-af48-f3912b20dd0c",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/partnername",
                              fields: {
                                value: { value: "partnerName" },
                                key: { value: "PartnerName" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "F0443A845B5242BF84E1432636B1A095",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "1f837eba-ae3f-4210-806e-51a069a85b76",
                          name: "MediaSource",
                          displayName: "MediaSource",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "" },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: true },
                            apiName: {
                              id: "9966e4e3-f61b-48f4-9958-8eedf4aa3665",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/mediasource",
                              fields: {
                                value: { value: "mediaSource" },
                                key: { value: "mediaSource" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "4CA359991C5D4851A464BD522283EE9B",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                        {
                          id: "6efe9f12-c8e4-43e4-82f3-e8766d1ad612",
                          name: "Source",
                          displayName: "Source",
                          parentId: "70e44db9-a7dc-485b-a596-961ed02aec3c",
                          fields: {
                            "Html Tag": { value: "p" },
                            Text: { value: "4" },
                            "Css Class": { value: "" },
                            HelpText: { value: "" },
                            GeneralError: { value: "" },
                            SpecificError: { value: "" },
                            isHidden: { value: true },
                            apiName: {
                              id: "0d6d0e98-3398-447a-90a9-94636f297d18",
                              fieldType: "Droplink",
                              fieldName: "apiName",
                              url: "/sitecore/content/fwd/global/settings/list/form-api-fields/source",
                              fields: {
                                value: { value: "source" },
                                key: { value: "source" },
                              },
                            },
                            serverValidationErrorText: { value: "" },
                            enableServerValidation: { value: false },
                            serverValidationAPI: null,
                            serverValidationLoadingText: { value: "" },
                            "Field Type": {
                              id: "983bfa5f-c6b6-4aee-a3bb-46b95d52e7df",
                              fieldType: "Droptree",
                              fieldName: "Field Type",
                              url: "/sitecore/system/settings/forms/field-types/basic/text",
                              fields: {
                                BackgroundColor: { value: "Sky" },
                                Icon: {
                                  value: "OfficeWhite/32x32/document_text.png",
                                },
                                IsDisabled: { value: false },
                                SpritePosition: { value: "" },
                                "Field Template": {
                                  id: "fc18f915-eac6-460a-8777-6e1376a9ea09",
                                  fieldType: "Droptree",
                                  fieldName: "Field Template",
                                  url: "/sitecore/templates/system/forms/fields/text",
                                  fields: {},
                                },
                                "Allowed Validations": [],
                                "Model Type": {
                                  value:
                                    "FWD.Foundation.Forms.CustomTextViewModel,FWD.Foundation.Forms",
                                },
                                "Property Editor": null,
                                "View Path": { value: "FieldTemplates/Text" },
                              },
                            },
                            Conditions: { value: '{"fieldConditions":[]}' },
                            "Field Key": {
                              value: "016DCF5EF4254725986F43F48E2245C2",
                            },
                            "Collapsed by Default": { value: false },
                          },
                          items: [],
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            "jss-footer": [],
          },
        },
      },
    },
  },
};
